function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("6kz4R", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "Global", ()=>$90efcd042d6a1fde$export$98f03c5d19621d70);
    $parcel$export(module.exports, "default", ()=>$90efcd042d6a1fde$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aIZdc;
    var $a90Ad;
    var $bwLf9;
    var $8Xodm;
    var $9QpK7;
    var $4R6GH;
    var $jkz9m;
    var $fq9Qs;
    var $2ZFrq;
    var $lMn99;
    var $fU2ZY;
    var $dZCvp;
    var $fW7zE;
    var $5o7us;
    var $v8jPJ;
    var $eQ4Jx;
    var $fd1WD;
    var $f5nIZ;
    var $1Siv7;
    var $SdVQy;
    var $eZISU;
    var $k9JTq;
    var $itmJb;
    var $DVljb;
    var $2YP9W;
    const $90efcd042d6a1fde$var$useIsModernGlobalIssueCreatePreferred = ()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("f5nIZ")).gicOptInStatusResources)).data?.gicOptInStatus?.isEnabled ?? false;
    const $90efcd042d6a1fde$var$LegacyComponents = ()=>{
        const baseUrl = '';
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fW7zE")).default), {
            baseUrl: baseUrl,
            locale: locale
        }));
    };
    const $90efcd042d6a1fde$var$ProjectCreateDrawerComponent = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const baseUrl = '';
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fd1WD")).default), {
            baseUrl: baseUrl,
            isAdmin: isAdmin,
            isOnboarding: false,
            locale: locale,
            appEditions: appEditions
        });
    };
    const $90efcd042d6a1fde$var$ModernGlobalIssueCreate = (0, (0, parcelRequire("bwLf9")).default)(()=>(0, (0, parcelRequire("4R6GH")).fg)('render_modern_global_issue_create_modal_experience') && $90efcd042d6a1fde$var$useIsModernGlobalIssueCreatePreferred(), ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZISU")).AsyncEnforceStorageLimitsModal), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fU2ZY")).AsyncIssueCreateModal), null), (0, (0, parcelRequire("4R6GH")).fg)('render_modern_global_issue_create_modal_experience') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5o7us")).default), null) : null), ()=>null);
    const $90efcd042d6a1fde$var$IssueArchiveModal = (0, (0, parcelRequire("9QpK7")).componentWithFF)('issue-unarchival_wdpb9', (0, (0, parcelRequire("lMn99")).default), ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null));
    const $90efcd042d6a1fde$var$ModernIssueTransition = (0, (0, parcelRequire("bwLf9")).default)(()=>(0, (0, parcelRequire("4R6GH")).fg)('render-modern-issue-transition') || (0, (0, parcelRequire("aIZdc")).isFedRamp)(), (0, (0, parcelRequire("dZCvp")).AsyncIssueTransitionModal), ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null));
    const $90efcd042d6a1fde$export$98f03c5d19621d70 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Xodm")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fq9Qs")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jkz9m")).AsyncFeedbackCollectorRenderer), null), (0, ($parcel$interopDefault($5uXOq))).createElement($90efcd042d6a1fde$var$LegacyComponents, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("v8jPJ")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eQ4Jx")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2ZFrq")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement($90efcd042d6a1fde$var$ProjectCreateDrawerComponent, null), (0, ($parcel$interopDefault($5uXOq))).createElement($90efcd042d6a1fde$var$IssueArchiveModal, null), (0, ($parcel$interopDefault($5uXOq))).createElement($90efcd042d6a1fde$var$ModernGlobalIssueCreate, null), (0, ($parcel$interopDefault($5uXOq))).createElement($90efcd042d6a1fde$var$ModernIssueTransition, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Siv7")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": (0, $8a62995671b567d3$export$bfef7353718d9887)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a90Ad")).AsyncJiraCommandPalette), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("SdVQy")).FlagIssueWithCommentModal), null));
    var $90efcd042d6a1fde$export$2e2bcd8739ae039 = $90efcd042d6a1fde$export$98f03c5d19621d70;
});
parcelRegister("a90Ad", function(module, exports) {
    $parcel$export(module.exports, "AsyncJiraCommandPalette", ()=>$3231c1b7cee2dced$export$bc973e46f49f4513);
    var $5uXOq = parcelRequire("5uXOq");
    var $rgeZ7;
    var $d8lE2;
    var $dQEPe;
    var $3Tty1;
    var $lfTZh;
    var $lsa9q;
    var $l8ruj;
    var $kxZPA;
    var $1eYLN;
    const $3231c1b7cee2dced$var$JiraCommandPaletteLazy = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("7cx5l")).then((module)=>module.CommandPaletteIntegration), {
        moduleId: "./src/packages/compal/command-palette-jira-integration/src/ui/index.tsx"
    });
    const $3231c1b7cee2dced$var$InternalAsyncCommandPalette = (props)=>{
        const [initialised, setInitialised] = (0, $5uXOq.useState)(false);
        const [{ isOpen: isOpen }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteIsOpen)();
        const { keyMap: commandPaletteKeyMap } = (0, (0, parcelRequire("rgeZ7")).useCommandPaletteShortcut)();
        const [{ hasLoaded: hasLoaded }] = (0, (0, parcelRequire("lsa9q")).default)();
        (0, $5uXOq.useEffect)(()=>{
            if (!initialised && (isOpen || hasLoaded)) setInitialised(true);
        }, [
            initialised,
            isOpen,
            hasLoaded
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "command-palette"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Tty1")).default), {
            keyMap: commandPaletteKeyMap
        }), initialised && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jira-command-palette",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3231c1b7cee2dced$var$JiraCommandPaletteLazy, props)));
    };
    const $3231c1b7cee2dced$export$bc973e46f49f4513 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eYLN")).JiraCommandPaletteErrorBoundary), {
            id: "jira-command-palette-integration-async"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dQEPe")).CommandPaletteWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement($3231c1b7cee2dced$var$InternalAsyncCommandPalette, props)));
});
parcelRegister("rgeZ7", function(module, exports) {
    $parcel$export(module.exports, "useCommandPaletteShortcut", ()=>$5b2c15c71087a027$export$819c83c949ab2a6b);
    var $eTXmK;
    var $d8lE2;
    var $2f2jJ;
    var $8zOmE;
    var $2NMNM;
    var $5p1kJ;
    const $5b2c15c71087a027$export$819c83c949ab2a6b = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ isLoaded: isLoaded }, { open: open }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteIsLoaded)();
        return {
            keyMap: {
                [`${(0, (0, parcelRequire("2f2jJ")).getShortcutModifierKey)()}+k`]: {
                    callback: (ev)=>{
                        (0, (0, parcelRequire("eTXmK")).default)('command-palette-opened');
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent((0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_PRESSED_ANALYTICS)), (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_ID), {
                            key: 'k',
                            isLoaded: isLoaded
                        });
                        ev?.preventDefault();
                        open();
                    }
                }
            }
        };
    };
});
parcelRegister("d8lE2", function(module, exports) {
    $parcel$export(module.exports, "useCommandPalette", ()=>$f75514d959bfcca8$export$6b58f9610017fbb7);
    $parcel$export(module.exports, "useActionsCommandPalette", ()=>$f75514d959bfcca8$export$72aa7bc7c6a83c36);
    $parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", ()=>$f75514d959bfcca8$export$1f90c8f89f98110e);
    $parcel$export(module.exports, "useCommandPaletteIsOpen", ()=>$f75514d959bfcca8$export$cc979be9b69236df);
    $parcel$export(module.exports, "useCommandPaletteHasChildPopup", ()=>$f75514d959bfcca8$export$a18633b655403b12);
    $parcel$export(module.exports, "useCommandPaletteIsLoaded", ()=>$f75514d959bfcca8$export$af8fd8cd4b048315);
    $parcel$export(module.exports, "useCommandPaletteSessionId", ()=>$f75514d959bfcca8$export$7422170a403e909);
    $parcel$export(module.exports, "useCommandPaletteExpandedCommand", ()=>$f75514d959bfcca8$export$282aa48e4a3afada);
    $parcel$export(module.exports, "useCommandPaletteSearch", ()=>$f75514d959bfcca8$export$96819dfb22ad05d3);
    $parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", ()=>$f75514d959bfcca8$export$f893891deedab3c6);
    $parcel$export(module.exports, "useCommandPaletteUsePerformModeState", ()=>$f75514d959bfcca8$export$bbc05723eb144e03);
    var $5uXOq = parcelRequire("5uXOq");
    var $3sQ5x;
    var $6dDSs;
    var $iXqE5;
    var $gM5ou;
    var $2sRNe;
    const $f75514d959bfcca8$var$initialState = {
        commandPaletteSessionId: '',
        isOpen: false,
        isLoaded: false,
        search: '',
        activeIndex: 0,
        isSearchFieldFocused: false,
        commands: [],
        parentCommand: [],
        sections: [],
        isDisabled: false,
        registry: {},
        activeRegistry: {
            commandRegistry: {},
            registryIds: []
        },
        onClosePendingCommandAction: undefined,
        isLoadChildrenError: false
    };
    const $f75514d959bfcca8$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $f75514d959bfcca8$var$initialState,
        actions: (0, parcelRequire("2sRNe")).actions,
        name: 'commandPalette'
    });
    const $f75514d959bfcca8$export$6b58f9610017fbb7 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store);
    const $f75514d959bfcca8$export$72aa7bc7c6a83c36 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($f75514d959bfcca8$var$store);
    const $f75514d959bfcca8$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
            const commandPalette = $f75514d959bfcca8$export$6b58f9610017fbb7();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentToRender, {
                ...props,
                commandPalette: commandPalette
            });
        };
    const $f75514d959bfcca8$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
            wordCount: (0, (0, parcelRequire("gM5ou")).getWordCount)(search),
            queryLength: search.length,
            queryHash: (0, (0, parcelRequire("gM5ou")).getQueryHash)(search),
            commandPaletteSessionId: commandPaletteSessionId,
            cpMenu: expandedCommand?.id || 'rootMenu',
            ...(0, (0, parcelRequire("gM5ou")).getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
            activeRegistryIds: activeRegistry.registryIds,
            activeRegistryIdsLength: activeRegistry.registryIds.length,
            activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
            relevancyModel: 'v2-string-similarity'
        });
    const $f75514d959bfcca8$export$1f90c8f89f98110e = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: $f75514d959bfcca8$export$56f06313122d0aac
    });
    const $f75514d959bfcca8$export$cc979be9b69236df = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ isOpen: isOpen })=>({
                isOpen: isOpen
            })
    });
    const $f75514d959bfcca8$export$a18633b655403b12 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($f75514d959bfcca8$var$store, {
        selector: (state)=>state.hasPopupOverlay
    });
    const $f75514d959bfcca8$export$af8fd8cd4b048315 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ isLoaded: isLoaded })=>({
                isLoaded: isLoaded
            })
    });
    const $f75514d959bfcca8$export$4372697329bd9cbe = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ isDisabled: isDisabled })=>({
                isDisabled: isDisabled
            })
    });
    const $f75514d959bfcca8$export$7422170a403e909 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
                commandPaletteSessionId: commandPaletteSessionId
            })
    });
    const $f75514d959bfcca8$export$282aa48e4a3afada = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
                expandedCommand: expandedCommand,
                isOpen: isOpen
            })
    });
    const $f75514d959bfcca8$export$96819dfb22ad05d3 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ search: search })=>({
                search: search
            })
    });
    const $f75514d959bfcca8$export$a40e8ae3e53feab0 = (0, (0, parcelRequire("6dDSs")).createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
            registry: registry,
            activeRegistry: activeRegistry,
            expandedCommand: expandedCommand
        }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
        if (!expandedCommand) return undefined;
        const registryData = (0, (0, parcelRequire("gM5ou")).getRegistryData)(registry, activeRegistry, expandedCommand.id);
        return {
            registryData: registryData,
            analyticsAttributes: registryData
        };
    });
    const $f75514d959bfcca8$export$f893891deedab3c6 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: $f75514d959bfcca8$export$a40e8ae3e53feab0
    });
    const $f75514d959bfcca8$export$bbc05723eb144e03 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
                commands: commands,
                search: search,
                expandedCommand: expandedCommand,
                childResult: childResult,
                registry: registry,
                activeRegistry: activeRegistry
            })
    });
});
parcelRegister("gM5ou", function(module, exports) {
    $parcel$export(module.exports, "getRegistryData", ()=>$cf289af0c139712c$export$6a1ed481c04a3ae6);
    $parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", ()=>$cf289af0c139712c$export$eb055284806da6e5);
    $parcel$export(module.exports, "getShortcutSpecialCharacters", ()=>$cf289af0c139712c$export$e6994b845b967732);
    $parcel$export(module.exports, "removeShortcutSpecialCharacters", ()=>$cf289af0c139712c$export$cd2a5827eae5f4cf);
    $parcel$export(module.exports, "mergeSections", ()=>$cf289af0c139712c$export$389b0273703d5c48);
    $parcel$export(module.exports, "mergeChildResults", ()=>$cf289af0c139712c$export$60a91e1b94ab4fef);
    $parcel$export(module.exports, "getAnalyticsAttributesFromState", ()=>$cf289af0c139712c$export$4023cd53e5e5fcb8);
    $parcel$export(module.exports, "isSecondaryTrigger", ()=>$cf289af0c139712c$export$daa5beabdf8d9fc3);
    $parcel$export(module.exports, "hasChildren", ()=>$cf289af0c139712c$export$bd5ff50f0e53d41c);
    $parcel$export(module.exports, "getAnalyticsAttributesFromResult", ()=>$cf289af0c139712c$export$bc9cd28438b3ea4b);
    $parcel$export(module.exports, "getQueryHash", ()=>$cf289af0c139712c$export$fa1c95a5ffa92036);
    $parcel$export(module.exports, "getWordCount", ()=>$cf289af0c139712c$export$dba3e2bcdbd49da4);
    $parcel$export(module.exports, "getCommandAction", ()=>$cf289af0c139712c$export$fb6dafa07e60c21a);
    $parcel$export(module.exports, "hasAction", ()=>$cf289af0c139712c$export$e217e69099d082f5);
    $parcel$export(module.exports, "useSetTimeoutAutoClear", ()=>$cf289af0c139712c$export$c3d20e8c1e93a572);
    var $5uXOq = parcelRequire("5uXOq");
    var $bdDiz = parcelRequire("bdDiz");
    var $2f2jJ;
    var $bcTvL;
    var $jh7L9;
    const $cf289af0c139712c$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
        if (!commandId) return undefined;
        const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
        const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
        return registryData;
    };
    const $cf289af0c139712c$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
    const $cf289af0c139712c$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
        const parentCommandIds = parentCommands?.map((command)=>command.id);
        while(parentCommandIds?.length){
            const nextParentCommandId = parentCommandIds?.pop();
            const registryData = $cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
            if (registryData) return registryData;
        }
        return undefined;
    };
    const $cf289af0c139712c$export$e6994b845b967732 = ()=>[
            {
                char: ' ',
                replacement: (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).THEN
            },
            {
                char: '+',
                replacement: (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).PLUS
            },
            {
                char: '|',
                replacement: (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).OR
            }
        ];
    const $cf289af0c139712c$export$cd2a5827eae5f4cf = (shortcut)=>{
        const specialChars = $cf289af0c139712c$export$e6994b845b967732();
        let strippedShortcut = shortcut;
        specialChars.forEach(({ char: char })=>{
            strippedShortcut = strippedShortcut.split(char).join('');
        });
        return strippedShortcut.toLowerCase();
    };
    const $cf289af0c139712c$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
            Object.entries(curr).forEach(([key, entry])=>{
                acc[key] = entry;
            });
            return acc;
        }, {});
    const $cf289af0c139712c$export$60a91e1b94ab4fef = (childResults)=>{
        const commands = [];
        const sections = [];
        childResults.forEach((childResult)=>{
            commands.push(...childResult.commands);
            if (childResult.sections) sections.push(childResult.sections);
        });
        return {
            commands: commands,
            sections: $cf289af0c139712c$export$389b0273703d5c48(sections)
        };
    };
    const $cf289af0c139712c$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
        const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
        const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
        const regex = new RegExp(regexString, 'g');
        return text.replace(/[.,]/g, '').replace(regex, '').replace(/\s{2,}/g, ' ').trim();
    };
    const $cf289af0c139712c$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
        const analyticsAttributes = {
            commandPaletteId: command.id,
            commandPaletteSessionId: state.commandPaletteSessionId,
            searchTaken: !!state.search,
            method: method,
            cpMenu: 'rootMenu',
            action: command.id,
            actionCategory: 'none',
            wasSecondaryTriggered: wasSecondaryTriggered,
            ...$cf289af0c139712c$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
            ...$cf289af0c139712c$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
            ...$cf289af0c139712c$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
            ...attributes,
            ...!!command.analytics && command.analytics
        };
        if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
        else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
        const sections = state.expandedCommand && state.childResult?.sections ? $cf289af0c139712c$export$389b0273703d5c48([
            ...state.sections,
            state.childResult?.sections
        ]) : $cf289af0c139712c$export$389b0273703d5c48(state.sections);
        const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
        const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
        analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
        return analyticsAttributes;
    };
    const $cf289af0c139712c$export$daa5beabdf8d9fc3 = (event)=>(0, (0, parcelRequire("2f2jJ")).isMacOs)() ? event.metaKey : event.ctrlKey;
    const $cf289af0c139712c$export$bd5ff50f0e53d41c = (command)=>{
        if (command?.wasSecondaryTriggered) {
            if (command?.secondaryAction?.type) {
                const hasSecondaryChildren = (0, (0, parcelRequire("jh7L9")).COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
                return hasSecondaryChildren;
            }
            return (0, (0, parcelRequire("jh7L9")).COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
        }
        return (0, (0, parcelRequire("jh7L9")).COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    };
    const $cf289af0c139712c$export$bc9cd28438b3ea4b = (result)=>{
        if (result) return {
            globalIndex: result.index,
            sectionIndex: result.sectionIndex,
            indexWithinSection: result.indexWithinSection,
            sectionId: result.sectionId
        };
        return {};
    };
    const $cf289af0c139712c$export$fa1c95a5ffa92036 = (str)=>(0, $bdDiz.createHash)().update(str).digest('hex');
    const $cf289af0c139712c$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
    const $cf289af0c139712c$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
        if (!command) return null;
        const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
        if (!primaryAction) return null;
        const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
        return {
            ...commandAction
        };
    };
    const $cf289af0c139712c$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
    const $cf289af0c139712c$export$c3d20e8c1e93a572 = ()=>{
        const timeoutRef = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>()=>{
                if (timeoutRef.current) clearTimeout(timeoutRef.current);
            }, []);
        const setTimeoutAutoClear = (...args)=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(...args);
        };
        return {
            setTimeoutAutoClear: setTimeoutAutoClear
        };
    };
});
parcelRegister("2f2jJ", function(module, exports) {
    $parcel$export(module.exports, "isMacOs", ()=>$6846128323867ebd$export$c5e71f489eb3970b);
    $parcel$export(module.exports, "getShortcutModifierKey", ()=>$6846128323867ebd$export$fe66dae91c68619b);
    const $6846128323867ebd$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
    const $6846128323867ebd$export$fe66dae91c68619b = ()=>$6846128323867ebd$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';
});
parcelRegister("bcTvL", function(module, exports) {
    $parcel$export(module.exports, "UI_EVENT_TYPE", ()=>$3996a4302dca83b1$export$a1562d08625f5d7e);
    $parcel$export(module.exports, "TRACK_EVENT_TYPE", ()=>$3996a4302dca83b1$export$947dac6c72b26f81);
    $parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", ()=>$3996a4302dca83b1$export$1ee9d153576afd13);
    $parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", ()=>$3996a4302dca83b1$export$894e19fc96687503);
    const $3996a4302dca83b1$export$a1562d08625f5d7e = 'UI';
    const $3996a4302dca83b1$export$947dac6c72b26f81 = 'TRACK';
    const $3996a4302dca83b1$export$f1d537d508d2945a = 'SCREEN';
    const $3996a4302dca83b1$export$12346a674644c156 = 'OPERATIONAL';
    var $3996a4302dca83b1$export$1ee9d153576afd13;
    (function(SHORTCUT_ELEMENT_TYPES) {
        SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
        SHORTCUT_ELEMENT_TYPES["OR"] = "or";
        SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
        SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
    })($3996a4302dca83b1$export$1ee9d153576afd13 || ($3996a4302dca83b1$export$1ee9d153576afd13 = {}));
    const $3996a4302dca83b1$export$894e19fc96687503 = 250;
});
parcelRegister("jh7L9", function(module, exports) {
    $parcel$export(module.exports, "CommandActionType", ()=>$b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
    $parcel$export(module.exports, "COMMAND_WITH_CHILDREN", ()=>$b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3);
    var $b1e48ebd4c8d5e4e$export$f041b1b117ab382f;
    (function(CommandActionType) {
        CommandActionType["PERFORM"] = "perform";
        CommandActionType["COMMAND_LIST"] = "command-list";
    })($b1e48ebd4c8d5e4e$export$f041b1b117ab382f || ($b1e48ebd4c8d5e4e$export$f041b1b117ab382f = {}));
    const $b1e48ebd4c8d5e4e$export$3e448fd53031e13c = Object.values($b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
    const $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3 = [
        "command-list"
    ];
});
parcelRegister("2sRNe", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$4f4c9e92d50d4f24$export$e324594224ef24da);
    var $kGsr8 = parcelRequire("kGsr8");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $e7WVN;
    var $eTXmK;
    var $2f2jJ;
    var $jcw0u;
    var $bcTvL;
    var $jh7L9;
    var $gM5ou;
    var $4DwnT;
    var $h3eZO;
    const $4f4c9e92d50d4f24$var$rootCommands = {
        parentCommand: [],
        expandedCommand: undefined,
        childCommands: undefined,
        childResult: undefined
    };
    const $4f4c9e92d50d4f24$var$open = ()=>({ setState: setState, getState: getState })=>{
            if (getState().isDisabled) return;
            setState({
                commandPaletteSessionId: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                isOpen: true,
                activeIndex: 0,
                search: ''
            });
        };
    const $4f4c9e92d50d4f24$var$close = ()=>({ setState: setState })=>{
            setState({
                isOpen: false,
                commandPaletteSessionId: '',
                search: '',
                ...$4f4c9e92d50d4f24$var$rootCommands
            });
        };
    const $4f4c9e92d50d4f24$var$toggle = ()=>({ setState: setState, getState: getState })=>{
            const isOpen = !getState().isOpen;
            setState({
                isOpen: isOpen,
                activeIndex: 0,
                search: '',
                commandPaletteSessionId: isOpen ? (0, ($parcel$interopDefault($7Jxgt))).v4() : '',
                ...!isOpen ? $4f4c9e92d50d4f24$var$rootCommands : {}
            });
        };
    const $4f4c9e92d50d4f24$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const newCommands = currentState.commands.concat(commands);
            const newState = {
                commands: newCommands
            };
            if (currentState.expandedCommand) {
                const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
                if (matchedExpandedCommand.length === 1) {
                    const [updatedExpandedCommand] = matchedExpandedCommand;
                    newState.expandedCommand = updatedExpandedCommand;
                }
            }
            setState(newState);
        };
    const $4f4c9e92d50d4f24$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
            const newCommands = getState().commands.filter((command)=>!commands.includes(command));
            setState({
                commands: newCommands
            });
        };
    const $4f4c9e92d50d4f24$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
            const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
            setState({
                commands: newCommands
            });
        };
    const $4f4c9e92d50d4f24$var$handleSearch = (search)=>({ setState: setState })=>{
            setState({
                search: search,
                activeIndex: 0
            });
        };
    const $4f4c9e92d50d4f24$var$forceSearchValue = (search)=>({ setState: setState })=>{
            setState({
                search: search,
                shouldForceSearchValue: true
            });
        };
    const $4f4c9e92d50d4f24$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
            setState({
                shouldForceSearchValue: false
            });
        };
    const $4f4c9e92d50d4f24$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (!currentState.expandedCommand) return;
            const newState = {
                search: '',
                activeIndex: 0,
                childResult: undefined,
                forceSearchFocus: true
            };
            if (currentState.parentCommand.length && !goToRoot) {
                newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
                newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
                if (newState.expandedCommand?.primaryAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                    commands: newState.expandedCommand?.primaryAction?.commands,
                    sections: newState.expandedCommand?.primaryAction?.sections
                };
            } else {
                newState.loadingList = false;
                newState.parentCommand = [];
                newState.expandedCommand = undefined;
                newState.childResult = undefined;
            }
            if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            }), (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                attributes: {
                    cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                    searchSessionId: currentState.commandPaletteSessionId,
                    action: goToRoot ? 'backToRoot' : 'backToParent',
                    actionCategory: 'back',
                    method: analytics?.method
                }
            });
            setState(newState);
        };
    const $4f4c9e92d50d4f24$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
            setState({
                forceSearchFocus: forceSearchFocus
            });
        };
    const $4f4c9e92d50d4f24$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
            const { isSearchFieldFocused: isSearchFieldFocused } = getState();
            setState({
                activeIndex: index,
                ...!isSearchFieldFocused ? {
                    forceSearchFocus: true
                } : {}
            });
        };
    const $4f4c9e92d50d4f24$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, (0, parcelRequire("gM5ou")).getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
    const $4f4c9e92d50d4f24$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
            setTimeout(()=>{
                const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
                if (onClosePendingCommandAction !== undefined) {
                    try {
                        (0, (0, parcelRequire("eTXmK")).default)('command-palette-executed');
                        onClosePendingCommandAction.perform();
                        if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                            const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                                action: 'taskSucceeded',
                                actionSubject: 'commandPalette'
                            });
                            onAnalytics(performAnalyticsEvent, (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                                attributes: onClosePendingCommandAction?.analyticsArgs
                            });
                        }
                    } catch (err) {
                        const error = err instanceof Error ? err : new Error('Command palette perform error');
                        (0, (0, parcelRequire("jcw0u")).default)({
                            error: error,
                            meta: {
                                id: 'compal.performDialogCloseCommand',
                                packageName: 'jiraCommandPalette',
                                teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                            },
                            attributes: onClosePendingCommandAction.analyticsArgs
                        });
                        (0, (0, parcelRequire("e7WVN")).setInteractionError)('command-palette-executed', {
                            errorMessage: error.message,
                            name: 'performDialogCloseCommandPerformError'
                        });
                    }
                    setState({
                        onClosePendingCommandAction: undefined
                    });
                }
            }, 0);
        };
    const $4f4c9e92d50d4f24$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const newState = {
                ...!(0, (0, parcelRequire("4DwnT")).getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                    search: ''
                },
                activeIndex: 0
            };
            const analyticsAttributes = (0, (0, parcelRequire("gM5ou")).getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
            const currentCommandAction = (0, (0, parcelRequire("gM5ou")).getCommandAction)(command, wasSecondaryTriggered);
            if (!currentCommandAction) return;
            if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
                const analyticsEvent = analytics.createAnalyticsEvent({
                    action: 'navigation',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(analyticsEvent, (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                    attributes: analyticsAttributes
                });
            }
            const shouldLoadChildren = (0, (0, parcelRequire("gM5ou")).hasChildren)({
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            });
            const shouldExecutePerform = currentCommandAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM;
            if (shouldLoadChildren) {
                (0, (0, parcelRequire("eTXmK")).default)('command-palette-load-child-command-list');
                if (currentState.expandedCommand) newState.parentCommand = [
                    ...currentState.parentCommand,
                    currentState.expandedCommand
                ];
                newState.expandedCommand = {
                    ...command,
                    wasSecondaryTriggered: wasSecondaryTriggered
                };
                newState.childResult = undefined;
                newState.forceSearchFocus = true;
                if ((0, (0, parcelRequire("h3eZO")).isSearchableChildrenAction)(currentCommandAction)) {
                    newState.childResult = {
                        commands: currentCommandAction.commands,
                        sections: currentCommandAction.sections
                    };
                    if (command.parentCommands?.length) newState.parentCommand = [
                        ...newState.parentCommand || [],
                        ...command.parentCommands
                    ];
                } else newState.childResult = undefined;
                setState(newState);
                if (currentCommandAction.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
            } else if (shouldExecutePerform) {
                if (!currentCommandAction.preventModalClose) {
                    newState.commandPaletteSessionId = '';
                    newState.isOpen = false;
                    newState.expandedCommand = undefined;
                    newState.parentCommand = [];
                    newState.childResult = undefined;
                    setState(newState);
                    if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                        const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                            action: 'closed',
                            actionSubject: 'commandPalette'
                        });
                        currentState.onAnalytics(closeAnalyticsEvent, (0, (0, parcelRequire("bcTvL")).UI_EVENT_TYPE), {
                            attributes: analyticsAttributes
                        });
                    }
                }
                if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'secondaryAction',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                        attributes: {
                            ...analyticsAttributes,
                            keyPressed: (0, (0, parcelRequire("2f2jJ")).isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                            ...currentCommandAction.analyticsArgs
                        }
                    });
                }
                if (currentCommandAction.preventModalClose) try {
                    (0, (0, parcelRequire("eTXmK")).default)('command-palette-executed');
                    currentCommandAction.perform();
                    if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                        const performAnalyticsEvent = analytics.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        currentState.onAnalytics(performAnalyticsEvent, (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                            attributes: analyticsAttributes
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: 'compal.executeCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                        },
                        attributes: analytics?.attributes
                    });
                    (0, (0, parcelRequire("e7WVN")).setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'executeCommandPerformError'
                    });
                }
                else setState({
                    onClosePendingCommandAction: {
                        ...currentCommandAction,
                        analyticsArgs: analyticsAttributes,
                        createAnalyticsEvent: analytics?.createAnalyticsEvent
                    }
                });
            }
        };
    const $4f4c9e92d50d4f24$var$setChildCommands = (childResult)=>({ setState: setState })=>{
            setState({
                childResult: childResult
            });
        };
    const $4f4c9e92d50d4f24$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
            setState({
                loadingList: loadingList
            });
        };
    const $4f4c9e92d50d4f24$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
                isSearchFieldFocused: isSearchFieldFocused
            });
    const $4f4c9e92d50d4f24$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const sections = currentState.sections.slice(0);
            sections.push(newSections);
            setState({
                sections: sections
            });
        };
    const $4f4c9e92d50d4f24$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const sections = currentState.sections.filter((section)=>section !== newSections);
            setState({
                sections: sections
            });
        };
    const $4f4c9e92d50d4f24$var$markAsLoaded = ()=>({ setState: setState })=>{
            setState({
                isLoaded: true
            });
        };
    const $4f4c9e92d50d4f24$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
            setState({
                isDisabled: isDisabled,
                ...isDisabled ? {
                    isOpen: false
                } : {}
            });
        };
    const $4f4c9e92d50d4f24$var$setRegistry = (registry)=>({ setState: setState })=>{
            setState({
                registry: registry
            });
        };
    const $4f4c9e92d50d4f24$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
            const currentActiveRegistry = getState().activeRegistry;
            const activeRegistry = {
                commandRegistry: {
                    ...currentActiveRegistry.commandRegistry,
                    ...commands.reduce((acc, command)=>{
                        acc[command.id] = {
                            registryId: registryId
                        };
                        return acc;
                    }, {})
                },
                registryIds: (0, ($parcel$interopDefault($kGsr8)))([
                    ...currentActiveRegistry.registryIds,
                    registryId
                ])
            };
            setState({
                activeRegistry: activeRegistry
            });
        };
    const $4f4c9e92d50d4f24$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
            const currentActiveRegistry = getState().activeRegistry;
            const commandRegistry = {
                ...currentActiveRegistry.commandRegistry
            };
            commands.forEach((command)=>{
                delete commandRegistry[command.id];
            });
            setState({
                activeRegistry: {
                    commandRegistry: commandRegistry,
                    registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
                }
            });
        };
    const $4f4c9e92d50d4f24$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
            setState({
                onAnalytics: onAnalytics,
                onErrorAnalytics: onErrorAnalytics
            });
        };
    const $4f4c9e92d50d4f24$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
            setState({
                fallbackOverride: fallbackOverride
            });
        };
    const $4f4c9e92d50d4f24$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
            setState({
                hasPopupOverlay: hasPopupOverlay
            });
        };
    const $4f4c9e92d50d4f24$export$e324594224ef24da = {
        open: $4f4c9e92d50d4f24$var$open,
        toggle: $4f4c9e92d50d4f24$var$toggle,
        close: $4f4c9e92d50d4f24$var$close,
        addCommands: $4f4c9e92d50d4f24$var$addCommands,
        removeCommands: $4f4c9e92d50d4f24$var$removeCommands,
        handleSearch: $4f4c9e92d50d4f24$var$handleSearch,
        forceFocusSearch: $4f4c9e92d50d4f24$var$forceFocusSearch,
        setActiveIndex: $4f4c9e92d50d4f24$var$setActiveIndex,
        executeCommand: $4f4c9e92d50d4f24$var$executeCommand,
        goBackLevel: $4f4c9e92d50d4f24$var$goBackLevel,
        setChildCommands: $4f4c9e92d50d4f24$var$setChildCommands,
        setLoadingList: $4f4c9e92d50d4f24$var$setLoadingList,
        setFocusInput: $4f4c9e92d50d4f24$var$setFocusInput,
        registerSections: $4f4c9e92d50d4f24$var$registerSections,
        unregisterSections: $4f4c9e92d50d4f24$var$unregisterSections,
        markAsLoaded: $4f4c9e92d50d4f24$var$markAsLoaded,
        getAnalyticsAttributes: $4f4c9e92d50d4f24$var$getAnalyticsAttributes,
        setIsDisabled: $4f4c9e92d50d4f24$var$setIsDisabled,
        setRegistry: $4f4c9e92d50d4f24$var$setRegistry,
        updateActiveRegistry: $4f4c9e92d50d4f24$var$updateActiveRegistry,
        removeCommandsById: $4f4c9e92d50d4f24$var$removeCommandsById,
        removeFromActiveRegistry: $4f4c9e92d50d4f24$var$removeFromActiveRegistry,
        performDialogCloseCommand: $4f4c9e92d50d4f24$var$performDialogCloseCommand,
        setAnalytics: $4f4c9e92d50d4f24$var$setAnalytics,
        setFallbackOverride: $4f4c9e92d50d4f24$var$setFallbackOverride,
        setHasPopupOverlay: $4f4c9e92d50d4f24$var$setHasPopupOverlay,
        forceSearchValue: $4f4c9e92d50d4f24$var$forceSearchValue,
        resetShouldForceSearchValue: $4f4c9e92d50d4f24$var$resetShouldForceSearchValue
    };
});
parcelRegister("4DwnT", function(module, exports) {
    $parcel$export(module.exports, "getActiveCommandList", ()=>$b4088022dc3f5c54$export$639b7f41b0b47a01);
    var $jh7L9;
    const $b4088022dc3f5c54$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
        if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
        if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
        return null;
    };
});
parcelRegister("h3eZO", function(module, exports) {
    $parcel$export(module.exports, "isSearchableChildrenAction", ()=>$dd5db8363c7eeda7$export$d75616d77443fe4e);
    var $jh7L9;
    const $dd5db8363c7eeda7$export$d75616d77443fe4e = (action)=>action?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST && action.commands !== undefined;
});
parcelRegister("5p1kJ", function(module, exports) {
    $parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", ()=>$7691773a5eed3db6$export$16b06d29ef8f802b);
    $parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", ()=>$7691773a5eed3db6$export$156ebd2354e25466);
    $parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", ()=>$7691773a5eed3db6$export$7fe859528e87e623);
    $parcel$export(module.exports, "COMMAND_PALETTE_ID", ()=>$7691773a5eed3db6$export$9f646ab88e1d2b14);
    $parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", ()=>$7691773a5eed3db6$export$abf26cc5daebd2c8);
    $parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", ()=>$7691773a5eed3db6$export$12514ca8899b0521);
    $parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", ()=>$7691773a5eed3db6$export$5fa0bcf59f933c21);
    $parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", ()=>$7691773a5eed3db6$export$7d9743be0b7d862f);
    $parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", ()=>$7691773a5eed3db6$export$b4e1633c86db2b70);
    $parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", ()=>$7691773a5eed3db6$export$5e5a87aac5d9771f);
    var $7691773a5eed3db6$export$16b06d29ef8f802b;
    (function(COMMAND_PALETTE_SECTIONS) {
        COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
        COMMAND_PALETTE_SECTIONS["projectNavigation"] = "project-navigation";
        COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
        COMMAND_PALETTE_SECTIONS["help"] = "help";
        COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
        COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
        COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
        COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
    })($7691773a5eed3db6$export$16b06d29ef8f802b || ($7691773a5eed3db6$export$16b06d29ef8f802b = {}));
    const $7691773a5eed3db6$export$156ebd2354e25466 = 'issueActions';
    const $7691773a5eed3db6$export$7fe859528e87e623 = {
        action: 'pressed',
        actionSubject: 'commandPaletteKeyboardShortcut'
    };
    const $7691773a5eed3db6$export$9f646ab88e1d2b14 = 'commandPalette';
    var $7691773a5eed3db6$export$abf26cc5daebd2c8;
    (function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["projectNavigation"] = 2] = "projectNavigation";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
    })($7691773a5eed3db6$export$abf26cc5daebd2c8 || ($7691773a5eed3db6$export$abf26cc5daebd2c8 = {}));
    var $7691773a5eed3db6$export$12514ca8899b0521;
    (function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
    })($7691773a5eed3db6$export$12514ca8899b0521 || ($7691773a5eed3db6$export$12514ca8899b0521 = {}));
    var $7691773a5eed3db6$export$5fa0bcf59f933c21;
    (function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
        COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
        COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
    })($7691773a5eed3db6$export$5fa0bcf59f933c21 || ($7691773a5eed3db6$export$5fa0bcf59f933c21 = {}));
    var $7691773a5eed3db6$export$7d9743be0b7d862f;
    (function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
    })($7691773a5eed3db6$export$7d9743be0b7d862f || ($7691773a5eed3db6$export$7d9743be0b7d862f = {}));
    var $7691773a5eed3db6$export$b4e1633c86db2b70;
    (function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
    })($7691773a5eed3db6$export$b4e1633c86db2b70 || ($7691773a5eed3db6$export$b4e1633c86db2b70 = {}));
    var $7691773a5eed3db6$export$5e5a87aac5d9771f;
    (function(COMMAND_PALETTE_HELP_PRIORITY) {
        COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
        COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
    })($7691773a5eed3db6$export$5e5a87aac5d9771f || ($7691773a5eed3db6$export$5e5a87aac5d9771f = {}));
});
parcelRegister("dQEPe", function(module, exports) {
    $parcel$export(module.exports, "CommandPaletteWrapper", ()=>$37505dcb864f2bf3$export$c6aee8a02c2936db);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $d8lE2;
    const $37505dcb864f2bf3$export$c6aee8a02c2936db = ({ children: children })=>{
        const [analyticsAttributes] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteAnalyticsAttributes)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "commandPalette",
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
            attributes: analyticsAttributes
        }, children);
    };
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("3Tty1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ba57d5dc6c0de0a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9IeM0;
    var $4lkOX;
    var $h0GOb;
    var $k4r7E;
    var $9fuVs;
    var $kspvB;
    let $6ba57d5dc6c0de0a$var$shortcutsCount = 0;
    let $6ba57d5dc6c0de0a$var$subscription = null;
    const $6ba57d5dc6c0de0a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
        const parentRegistry = (0, $5uXOq.useContext)((0, (0, parcelRequire("9fuVs")).ShortcutRegistryContext)) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        const addKeyMap = (0, $5uXOq.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                    keyMap: (0, (0, parcelRequire("kspvB")).bindKeyMapWithErrorHandling)(keyMap, location),
                    label: label
                })), [
            label,
            parentRegistry,
            keyMap,
            location
        ]);
        (0, $5uXOq.useEffect)(()=>{
            $6ba57d5dc6c0de0a$var$shortcutsCount += 1;
            const removeKeyMap = addKeyMap();
            return ()=>{
                removeKeyMap();
                $6ba57d5dc6c0de0a$var$shortcutsCount -= 1;
                if ($6ba57d5dc6c0de0a$var$subscription && $6ba57d5dc6c0de0a$var$shortcutsCount === 0) {
                    $6ba57d5dc6c0de0a$var$subscription.unsubscribe();
                    $6ba57d5dc6c0de0a$var$subscription = null;
                }
            };
        }, [
            addKeyMap
        ]);
        (0, $5uXOq.useEffect)(()=>{
            $6ba57d5dc6c0de0a$var$subscription = $6ba57d5dc6c0de0a$var$subscription || (0, (0, parcelRequire("h0GOb")).default)().subscribe((0, (0, parcelRequire("4lkOX")).default));
        }, [
            parentRegistry,
            keyMap
        ]);
        return null;
    };
    var $6ba57d5dc6c0de0a$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, (0, parcelRequire("9IeM0")).useKeyboardShortcutsToggle), ...props })=>{
        const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
        return isEnabled && !false ? (0, ($parcel$interopDefault($5uXOq))).createElement($6ba57d5dc6c0de0a$var$ShortcutsSubscriber, props) : null;
    };
});
parcelRegister("9IeM0", function(module, exports) {
    $parcel$export(module.exports, "useKeyboardShortcutsToggle", ()=>$dc712fc9bec05022$export$a33a81f1fc5458ad);
    var $jcw0u;
    var $eusud;
    var $j8DrX;
    var $8zOmE;
    var $3sQ5x;
    var $iXqE5;
    const $dc712fc9bec05022$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
    const $dc712fc9bec05022$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
            const currentState = getState().isEnabled;
            const status = currentState ? 'off' : 'on';
            const url = `${$dc712fc9bec05022$var$URL_FRAGMENT}${status}`;
            try {
                await (0, (0, parcelRequire("eusud")).performPutRequest)(url);
                setState({
                    isEnabled: !currentState,
                    error: null
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                    isEnabled: !currentState
                });
            } catch (err) {
                setState({
                    error: err
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'keyboardShortcutToggleFailure',
                        packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                    },
                    error: err
                });
            }
        };
    const $dc712fc9bec05022$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            isEnabled: false ? false : !((0, (0, parcelRequire("j8DrX")).default)('ajs-keyboard-shortcuts-enabled') === 'false'),
            error: null
        },
        actions: {
            toggle: $dc712fc9bec05022$export$b62f67be35e65859
        }
    });
    const $dc712fc9bec05022$export$a33a81f1fc5458ad = (0, (0, parcelRequire("3sQ5x")).createHook)($dc712fc9bec05022$var$Store);
});
parcelRegister("4lkOX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f11d50ddafbb6f85$export$2e2bcd8739ae039);
    var $h0GOb;
    var $k4r7E;
    const $f11d50ddafbb6f85$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
    var $f11d50ddafbb6f85$export$2e2bcd8739ae039 = (keySequence)=>{
        const { sequence: sequence, e: e } = keySequence || {};
        const activeKeyMap = (0, (0, parcelRequire("k4r7E")).rootRegistry).getActiveKeyMap();
        if (sequence !== undefined && activeKeyMap[sequence]) {
            activeKeyMap[sequence].callback(e);
            (0, (0, parcelRequire("h0GOb")).flush)();
        } else {
            const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f11d50ddafbb6f85$var$matches(sequence));
            if (!isFutureMatchPossible) (0, (0, parcelRequire("h0GOb")).flush)();
        }
    };
});
parcelRegister("h0GOb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$849cd54ac4017470$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "flush", ()=>$849cd54ac4017470$export$4909b86c8034bf73);
    var $kVLXA = parcelRequire("kVLXA");
    var $cab1K = parcelRequire("cab1K");
    parcelRequire("jG6Un");
    parcelRequire("eSGL3");
    parcelRequire("1oQta");
    parcelRequire("4kRRr");
    parcelRequire("d0pqD");
    parcelRequire("iQCJJ");
    parcelRequire("fjPtF");
    parcelRequire("2R2to");
    var $lIZQG;
    const $849cd54ac4017470$var$ignoredKeys = {
        Control: true,
        Meta: true,
        Shift: true,
        Alt: true,
        AltGraph: true,
        CapsLock: true,
        Fn: true,
        FnLock: true,
        Hyper: true,
        NumLock: true,
        OS: true,
        ScrollLock: true,
        Super: true,
        Symbol: true,
        SymbolLock: true
    };
    const $849cd54ac4017470$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
    const $849cd54ac4017470$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$849cd54ac4017470$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
    const $849cd54ac4017470$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && (e.key === 'Escape' || !$849cd54ac4017470$var$isEditable(e.target) && !$849cd54ac4017470$var$ignoredKeys[e.key]);
    const $849cd54ac4017470$export$25d1b8252b4c49b7 = ()=>{
        const elBlankets = document.querySelectorAll('.aui-blanket');
        if (elBlankets.length === 0) return true;
        const isAllHidden = Array.from(elBlankets || []).every((el)=>{
            if (el.getAttribute('aria-hidden') === 'true' || el.getAttribute('hidden') !== null) return true;
            return false;
        });
        return isAllHidden;
    };
    let $849cd54ac4017470$var$key$;
    const $849cd54ac4017470$var$flush$ = new (0, $cab1K.Subject)();
    var $849cd54ac4017470$export$2e2bcd8739ae039 = ()=>{
        if (!$849cd54ac4017470$var$key$) {
            $849cd54ac4017470$var$key$ = false ? new (0, $cab1K.Subject)() : (0, $kVLXA.Observable).fromEvent(document, 'keydown').filter($849cd54ac4017470$var$isRelevantKeyEvent).filter($849cd54ac4017470$export$25d1b8252b4c49b7).map((0, (0, parcelRequire("lIZQG")).toKeyWithModifiers));
            const sequence$ = $849cd54ac4017470$var$key$.scan((seq, key)=>{
                if (!key || !seq) return undefined;
                return {
                    sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                    e: key.e
                };
            });
            $849cd54ac4017470$var$key$ = $849cd54ac4017470$var$key$.debounceTime(1000).startWith(null).merge($849cd54ac4017470$var$flush$).switchMapTo(sequence$);
        }
        return $849cd54ac4017470$var$key$;
    };
    const $849cd54ac4017470$export$4909b86c8034bf73 = ()=>{
        $849cd54ac4017470$var$flush$.next();
    };
});
parcelRegister("lIZQG", function(module, exports) {
    $parcel$export(module.exports, "toKeyWithModifiers", ()=>$ca3344250c7b7406$export$8cf0d2c3d060a0c2);
    $parcel$export(module.exports, "isValidShortcut", ()=>$ca3344250c7b7406$export$8e231506c5580162);
    $parcel$export(module.exports, "isShortcutCollision", ()=>$ca3344250c7b7406$export$4add9e50cb49d130);
    const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
    const $ca3344250c7b7406$var$modifiers = [
        {
            name: 'ctrl',
            test: (e)=>e.ctrlKey
        },
        {
            name: 'shift',
            test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
        },
        {
            name: 'meta',
            test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
        }
    ];
    const $ca3344250c7b7406$var$toKey = (e)=>{
        if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
        return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
    };
    const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
        if (!e || !e.key) return {
            sequence: '',
            e: e
        };
        return {
            sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
            e: e
        };
    };
    const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
    const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
    const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
    const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
    const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
        if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
        if (rightShortcut === leftShortcut) return true;
        if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
        if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
        return false;
    };
});
parcelRegister("k4r7E", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistry", ()=>$a65fecdbaed23de2$export$ca1c75b575abf5ff);
    $parcel$export(module.exports, "rootRegistry", ()=>$a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $FISJv = parcelRequire("FISJv");
    var $lIZQG;
    const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
        (0, ($parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
            const shortcuts = Object.keys(keyMap);
            (0, ($parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
                if (!(0, (0, parcelRequire("lIZQG")).isValidShortcut)(shortcut)) console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
                for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                    const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                    (0, ($parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                        if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(anotherShortcut, shortcut)) {
                            if ((0, ($parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, ($parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                        }
                    });
                }
                for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
            });
        });
    };
    const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>keyMapsToMerge.reduce((prev, keyMap)=>({
                ...prev,
                ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                    if (!(0, ($parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1)) return {
                        ...newAccumulator,
                        [newKey]: keyMap[newKey]
                    };
                    return newAccumulator;
                }, {})
            }), {});
    class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
        addChildRegistry(child) {
            this.children.push(child);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.children, child);
            };
        }
        addKeyMap(getKeyMap) {
            this.keyMapRetrievers.push(getKeyMap);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
            };
        }
        getActiveKeyMap() {
            const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
            return {
                ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
            };
        }
        getKeyMapInfo() {
            const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
            const flattenedInfo = [].concat(...info);
            return flattenedInfo;
        }
        constructor(){
            this.children = [];
            this.keyMapRetrievers = [];
        }
    }
    const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();
});
parcelRegister("9fuVs", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistryContext", ()=>$1dd87679d9ca363b$export$ebbb59327adb551a);
    $parcel$export(module.exports, "default", ()=>$1dd87679d9ca363b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4r7E;
    const $1dd87679d9ca363b$export$ebbb59327adb551a = (0, $5uXOq.createContext)((0, (0, parcelRequire("k4r7E")).rootRegistry));
    const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
        const registry = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("k4r7E")).ShortcutRegistry)(), []);
        const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        (0, $5uXOq.useEffect)(()=>{
            const removeRegistry = parentRegistry.addChildRegistry(registry);
            return removeRegistry;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
            value: registry
        }, children);
    };
    var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;
});
parcelRegister("kspvB", function(module, exports) {
    $parcel$export(module.exports, "bindKeyMapWithErrorHandling", ()=>$f9e30ab2465f6f16$export$77477772a9b904da);
    var $dJl1T;
    const $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
            try {
                callback(e);
            } catch (error) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
            }
        };
    const $f9e30ab2465f6f16$export$77477772a9b904da = (keyMap, location)=>Object.keys(keyMap).reduce((map, key)=>({
                ...map,
                [key]: {
                    ...keyMap[key],
                    callback: $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
                }
            }), {});
});
parcelRegister("1eYLN", function(module, exports) {
    $parcel$export(module.exports, "JiraCommandPaletteErrorBoundary", ()=>$68674be03655f689$export$4c089b36a27ad393);
    var $5uXOq = parcelRequire("5uXOq");
    var $d8lE2;
    var $7CMCs;
    const $68674be03655f689$export$4c089b36a27ad393 = ({ id: id, children: children })=>{
        const [data] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteRegistryCurrentAttribution)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: id,
            packageName: "jiraCommandPaletteIntegration",
            fallback: "unmount",
            teamName: data?.registryData?.teamName || 'deliveroo',
            attributes: data?.analyticsAttributes
        }, children);
    };
});
parcelRegister("7cx5l", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eu4Hk")
    ]).then(()=>parcelRequire('kfU2R'));
});
parcelRegister("bwLf9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a7ec252b6b084884$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $a7ec252b6b084884$export$2e2bcd8739ae039 = (conditionGetter, ComponentTrue, ComponentFalse)=>{
        const ComponentWithCondition = (props)=>conditionGetter() ? (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentTrue, props) : (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentFalse, props);
        if (conditionGetter.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${conditionGetter.name}]`;
        return ComponentWithCondition;
    };
});
parcelRegister("8Xodm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$733a4b99cb913235$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7LFSn;
    var $4041n;
    var $Le2jE;
    function $733a4b99cb913235$export$2e2bcd8739ae039(_props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4041n")).FavoriteChangeConsumer), null, (favoriteChangeContext)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7LFSn")).FavoriteAPISubscriber), null, (__, actions)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Le2jE")).default), {
                    items: favoriteChangeContext.items,
                    changeFavorite: favoriteChangeContext.changeFavorite,
                    callbackRegistry: actions
                })));
    }
});
parcelRegister("7LFSn", function(module, exports) {
    $parcel$export(module.exports, "FavoriteAPISubscriber", ()=>$2e05275831c00ad0$export$5f27f6398e1e9783);
    var $gg7kZ;
    var $51nlc;
    var $1kdX2;
    const $2e05275831c00ad0$export$5f27f6398e1e9783 = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("1kdX2")).default), {
        displayName: 'FavoriteAPISubscriber',
        selector: null
    });
    const $2e05275831c00ad0$export$e5f479962d73e3ca = (0, (0, parcelRequire("gg7kZ")).createContainer)((0, (0, parcelRequire("1kdX2")).default));
});
parcelRegister("1kdX2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b07d5f79deb8fae6$export$2e2bcd8739ae039);
    var $iXqE5;
    var $iYm0B;
    const $b07d5f79deb8fae6$var$initialState = {
        callbacks: new Set()
    };
    var $b07d5f79deb8fae6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'favourite-api-callbacks',
        initialState: $b07d5f79deb8fae6$var$initialState,
        actions: (0, parcelRequire("iYm0B")).default
    });
});
parcelRegister("iYm0B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f216e7ca926a6530$export$2e2bcd8739ae039);
    var $cIPJW;
    var $aUW0i;
    var $44KUn;
    var $5UAf7;
    const $f216e7ca926a6530$var$actions = {
        add: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("cIPJW")).default('callbacks', cb)),
        remove: (cb)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("44KUn")).default('callbacks', cb)),
        clear: ()=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("aUW0i")).default('callbacks')),
        run: (...args)=>({ dispatch: dispatch })=>dispatch((0, parcelRequire("5UAf7")).default('callbacks', ...args))
    };
    var $f216e7ca926a6530$export$2e2bcd8739ae039 = $f216e7ca926a6530$var$actions;
});
parcelRegister("Le2jE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6815cf6776899117$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9B86Q;
    class $6815cf6776899117$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                items: {
                    boards: {},
                    filters: {},
                    dashboards: {},
                    issues: {},
                    projects: {},
                    queues: {}
                },
                onAddClearImperativeApiCallback: ()=>{}
            };
        }
        constructor(){
            super();
            (0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/favouriteItems/bridge'
            }).then((bridge)=>{
                bridge(this.getImperativeAPI());
            });
        }
        shouldComponentUpdate(nextProps) {
            return this.props.items !== nextProps.items;
        }
        componentDidUpdate() {
            if (!this.props.items) return;
            this.props.callbackRegistry.run(this.props.items);
        }
        componentWillUnmount() {
            this.props.callbackRegistry.clear();
        }
        getImperativeAPI() {
            return {
                changeFavourite: async (item)=>this.props.changeFavorite(item),
                registerFavouriteChangeCallback: (callback)=>this.props.callbackRegistry.add(callback),
                unregisterFavouriteChangeCallback: (callback)=>this.props.callbackRegistry.remove(callback)
            };
        }
        render() {
            return null;
        }
    }
});
parcelRegister("9QpK7", function(module, exports) {
    $parcel$export(module.exports, "componentWithFF", ()=>$4adaf4a620447263$export$377d327ec8da8be);
    var $co1wz;
    var $7XYc4;
    const $4adaf4a620447263$export$377d327ec8da8be = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)(featureFlagName), ComponentTrue, ComponentFalse);
});
parcelRegister("jkz9m", function(module, exports) {
    $parcel$export(module.exports, "AsyncFeedbackCollectorRenderer", ()=>$8384608592a7ebba$export$af648acab555078b);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $8384608592a7ebba$var$LazyFeedbackCollectorRenderer = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("03hWr")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/feedback-collector/src/ui/feedback-renderer/index.tsx"
    });
    const $8384608592a7ebba$export$af648acab555078b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "asyncFeedbackCollector",
            packageName: "jiraFeedbackCollector",
            teamName: "magma"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-feedback-collector-renderer",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8384608592a7ebba$var$LazyFeedbackCollectorRenderer, null)));
});
parcelRegister("03hWr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("79o8U").then(()=>parcelRequire('649ic'));
});
parcelRegister("fq9Qs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$10e9a1afe54cfb74$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6BZYo;
    var $cQZXC;
    var $jcw0u;
    var $4R6GH;
    var $DVljb;
    var $4su49;
    var $6sEtc;
    var $gIfXe;
    const $10e9a1afe54cfb74$var$LoadGICResources = ()=>{
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const isModernPreferred = (0, (0, parcelRequire("gIfXe")).useIsModernGlobalIssueCreatePreferred)() && (0, (0, parcelRequire("4R6GH")).fg)('render_modern_global_issue_create_modal_experience');
        (0, $5uXOq.useEffect)(()=>{
            if (__SPA__) (isModernPreferred ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : (0, (0, parcelRequire("6BZYo")).loadBridge)({
                name: 'wrm/require'
            }))?.then(()=>(0, (0, parcelRequire("4su49")).asyncWrmRequire)([
                    'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue',
                    'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',
                    'wrc!jira.create.issue',
                    (0, (0, parcelRequire("6sEtc")).default)(locale),
                    'wrc!com.atlassian.jira.plugins.jira-dnd-attachment-plugin:shared-utility',
                    'wrc!com.pyxis.greenhopper.jira:gh-issue-type-whitelist',
                    'wrc!com.atlassian.jira.plugins.jira-wiki-editor:wiki-editor-resources-init',
                    'wrc!com.pyxis.greenhopper.jira:gh-view-issue',
                    'wrc!com.pyxis.greenhopper.jira:gh-custom-field-pickers',
                    'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
                ])).catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'LoadGICResources',
                        packageName: 'jiraGlobalIssueCreateResources',
                        teamName: 'gryffindor'
                    },
                    error: error
                });
            });
        }, [
            isModernPreferred,
            locale
        ]);
        return null;
    };
    var $10e9a1afe54cfb74$export$2e2bcd8739ae039 = $10e9a1afe54cfb74$var$LoadGICResources;
});
parcelRegister("6BZYo", function(module, exports) {
    $parcel$export(module.exports, "loadBridge", ()=>$ce95ee3fd66207c7$export$df8409da353bde5a);
    var $fqWWz;
    var $3GASE;
    var $ig88W;
    var $7T84i;
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $8JNtu;
    var $5Ik5Y;
    const $ce95ee3fd66207c7$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, (0, parcelRequire("fqWWz")).MAX_RETRIES), timeout: timeout = (0, (0, parcelRequire("fqWWz")).DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>{
        if (wrmKeys != null) return (0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
            name: name,
            wrmKeys: [].concat(wrmKeys),
            shouldLogError: shouldLogError
        });
        if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
        if (tentatives <= 1) return (0, (0, parcelRequire("3GASE")).loadBridgeBail)({
            name: name,
            shouldLogError: shouldLogError
        });
        return (0, (0, parcelRequire("ig88W")).loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError,
            timeout: (tentatives - 1) * timeout
        });
    };
});
parcelRegister("6sEtc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3196b461144533e$export$2e2bcd8739ae039);
    const $f3196b461144533e$var$calendarLocaleMap = {
        cs_CZ: 'calendar-cs',
        da_DK: 'calendar-da',
        de_DE: 'calendar-de',
        en_GB: 'calendar-en',
        en_UK: 'calendar-en',
        en_ZZ: 'calendar-en',
        en_US: 'calendar-en',
        es_ES: 'calendar-es',
        et_EE: 'calendar-en',
        fi_FI: 'calendar-fi',
        fr_FR: 'calendar-fr',
        hu_HU: 'calendar-hu',
        is_IS: 'calendar-en',
        it_IT: 'calendar-it',
        ja_JP: 'calendar-jp',
        ko_KR: 'calendar-ko',
        nb_NO: 'calendar-no',
        nl_NL: 'calendar-nl',
        pl_PL: 'calendar-pl',
        pt_BR: 'calendar-pt',
        pt_PT: 'calendar-pt',
        ro_RO: 'calendar-ro',
        ru_RU: 'calendar-ru',
        sk_SK: 'calendar-sk',
        sv_SE: 'calendar-sv',
        tr_TR: 'calendar-tr',
        zh_CN: 'calendar-zh',
        zh_TW: 'calendar-zh'
    };
    const $f3196b461144533e$var$getCalendarResource = (locale)=>$f3196b461144533e$var$calendarLocaleMap[locale] || $f3196b461144533e$var$calendarLocaleMap.en_US;
    var $f3196b461144533e$export$2e2bcd8739ae039 = (locale)=>`wrc!jira.webresources:${$f3196b461144533e$var$getCalendarResource(locale)}`;
});
parcelRegister("gIfXe", function(module, exports) {
    $parcel$export(module.exports, "useIsModernGlobalIssueCreatePreferred", ()=>$814e219f65019e51$export$92258d85324089e5);
    var $f5nIZ;
    var $2YP9W;
    const $814e219f65019e51$export$92258d85324089e5 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("f5nIZ")).gicOptInStatusResources)).data?.gicOptInStatus?.isEnabled ?? false;
});
parcelRegister("2ZFrq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d3962dec67800f9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $lfTZh;
    var $kxZPA;
    var $6Lg6A;
    var $ecbCU;
    const $5d3962dec67800f9$export$448e48d8961c824c = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("jHEUR")), {
        moduleId: "./src/packages/invite-people-drawer/src/ui/content/index.tsx"
    });
    const $5d3962dec67800f9$var$InvitePeopleDrawerInternal = ({ disableNoInviteError: disableNoInviteError })=>{
        const [{ isOpen: isOpen, inviteFlow: inviteFlow, continueUrl: continueUrl }, { closeDrawer: closeDrawer }] = (0, (0, parcelRequire("ecbCU")).useInvitePeopleDrawer)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Lg6A")).LazyWait), {
            until: isOpen
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "invite-people-drawer",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5d3962dec67800f9$export$448e48d8961c824c, {
            inviteFlow: inviteFlow,
            isOpen: isOpen,
            onClose: closeDrawer,
            continueUrl: continueUrl,
            displayModal: true,
            disableNoInviteError: disableNoInviteError
        })));
    };
    $5d3962dec67800f9$var$InvitePeopleDrawerInternal.displayName = 'InvitePeopleDrawerInternal';
    const $5d3962dec67800f9$var$InvitePeopleDrawerWithErrorBoundary = ({ disableNoInviteError: disableNoInviteError })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "invite-people-drawer",
            packageName: "jiraInvitePeopleDrawer"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5d3962dec67800f9$var$InvitePeopleDrawerInternal, {
            disableNoInviteError: disableNoInviteError
        }));
    var $5d3962dec67800f9$export$2e2bcd8739ae039 = $5d3962dec67800f9$var$InvitePeopleDrawerWithErrorBoundary;
});
parcelRegister("ecbCU", function(module, exports) {
    $parcel$export(module.exports, "useInvitePeopleDrawer", ()=>$6f07668563b12d68$export$48fb2d80745c5e67);
    $parcel$export(module.exports, "triggerOpenDrawer", ()=>$6f07668563b12d68$export$b7dab610045052db);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    var $bKpgX;
    var $2fX5x;
    const $6f07668563b12d68$var$CONTROLLER_NAME = 'invite-people-drawer';
    const $6f07668563b12d68$var$initialState = {
        isOpen: false,
        inviteFlow: 'unknown',
        continueUrl: undefined
    };
    const $6f07668563b12d68$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: $6f07668563b12d68$var$CONTROLLER_NAME,
        initialState: $6f07668563b12d68$var$initialState,
        actions: {
            openDrawer: (createAnalyticsEvent, { inviteFlow: inviteFlow, analyticsSource: analyticsSource, continueUrl: continueUrl })=>({ setState: setState })=>{
                    (0, (0, parcelRequire("2fX5x")).fireAddTeammatetoJiraAnalytics)(createAnalyticsEvent, analyticsSource);
                    (0, (0, parcelRequire("2fX5x")).fireModalTriggeredAnalytics)(createAnalyticsEvent, inviteFlow, analyticsSource);
                    setState({
                        isOpen: true,
                        inviteFlow: inviteFlow,
                        continueUrl: continueUrl
                    });
                },
            closeDrawer: ()=>({ setState: setState })=>setState($6f07668563b12d68$var$initialState)
        }
    });
    const $6f07668563b12d68$export$48fb2d80745c5e67 = (0, (0, parcelRequire("3sQ5x")).createHook)($6f07668563b12d68$var$Store);
    const $6f07668563b12d68$export$ac7fed664b4735b5 = (0, (0, parcelRequire("gg7kZ")).createContainer)($6f07668563b12d68$var$Store, {
        onInit: ()=>({ setState: setState }, { isOpen: isOpen })=>{
                setState({
                    isOpen: isOpen
                });
            }
    });
    const $6f07668563b12d68$export$4358742cbaf4a6d4 = (0, (0, parcelRequire("51nlc")).createSubscriber)($6f07668563b12d68$var$Store, {
        displayName: 'InvitePeopleDrawerSubscriber',
        selector: (state)=>state.isOpen
    });
    const $6f07668563b12d68$export$b7dab610045052db = (createAnalyticsEvent, contextConfig)=>{
        (0, (0, parcelRequire("bKpgX")).defaultRegistry).getStore($6f07668563b12d68$var$Store)?.actions.openDrawer(createAnalyticsEvent, contextConfig);
    };
});
parcelRegister("2fX5x", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsProvider", ()=>$b69ddc7a728288ef$export$1b581a2ec13e37f1);
    $parcel$export(module.exports, "fireModalTriggeredAnalytics", ()=>$b69ddc7a728288ef$export$6815765da918b983);
    $parcel$export(module.exports, "fireAddTeammatetoJiraAnalytics", ()=>$b69ddc7a728288ef$export$21b810258e82d438);
    var $5uXOq = parcelRequire("5uXOq");
    var $bvUB1;
    var $8zOmE;
    var $lhVtI;
    var $fjcgS;
    var $d3xqi;
    const $b69ddc7a728288ef$var$useAnalyticsClient = ()=>{
        const analyticsWebClientRef = (0, $5uXOq.useRef)((0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)());
        return {
            sendEvent: (analyticsEvent)=>{
                analyticsWebClientRef.current.then((webClient)=>webClient.sendEvent((0, (0, parcelRequire("lhVtI")).getEvent)(analyticsEvent)));
            }
        };
    };
    const $b69ddc7a728288ef$export$1b581a2ec13e37f1 = ({ children: children })=>{
        const { sendEvent: sendEvent } = $b69ddc7a728288ef$var$useAnalyticsClient();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bvUB1")).default), {
            channel: "peopleAndTeams",
            onEvent: sendEvent
        }, children);
    };
    const $b69ddc7a728288ef$var$sendAnalyticsClientUIEvent = async (createAnalyticsEvent, analyticsPayload)=>{
        if (createAnalyticsEvent) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), `${analyticsPayload.actionSubject} ${analyticsPayload.action}`, analyticsPayload?.actionSubjectId || '', analyticsPayload.attributes);
        else {
            const webAnalyticsClient = await (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)();
            const analyticsClient = webAnalyticsClient.getInstance();
            if (analyticsClient) analyticsClient.sendUIEvent(analyticsPayload);
        }
    };
    const $b69ddc7a728288ef$export$6815765da918b983 = async (createAnalyticsEvent, inviteFlow, source)=>{
        const analyticsPayload = {
            action: 'triggered',
            actionSubject: 'modal',
            actionSubjectId: 'invitePeopleModal',
            attributes: {
                source: (0, (0, parcelRequire("d3xqi")).getSourceByInviteFlow)(inviteFlow)
            },
            source: source != null && source !== '' ? source : 'unknown'
        };
        $b69ddc7a728288ef$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
    };
    const $b69ddc7a728288ef$export$21b810258e82d438 = async (createAnalyticsEvent, source)=>{
        const analyticsPayload = {
            action: 'clicked',
            actionSubject: 'addTeammatetoJira',
            product: 'jira',
            source: source != null && source !== '' ? source : 'unknown'
        };
        $b69ddc7a728288ef$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
    };
});
parcelRegister("d3xqi", function(module, exports) {
    $parcel$export(module.exports, "getSourceByInviteFlow", ()=>$1b54655f5f68975f$export$c35cd18e9d0123e3);
    const $1b54655f5f68975f$export$c35cd18e9d0123e3 = (inviteFlow)=>{
        let source = inviteFlow;
        if (inviteFlow === 'mention') source = 'mentionInEditor';
        else if (inviteFlow === 'assignee') source = 'assigneeField';
        return source;
    };
});
parcelRegister("jHEUR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("eO6OQ")
    ]).then(()=>parcelRequire('deBE2'));
});
parcelRegister("lMn99", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$106cbea13b7fe5ce$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $gc4aL;
    const $106cbea13b7fe5ce$var$runtimeProps = {};
    const $106cbea13b7fe5ce$var$entryPointParams = {};
    const $106cbea13b7fe5ce$var$AsyncArchiveIssueModal = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("gc4aL")).archiveModalEntryPoint), $106cbea13b7fe5ce$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
            return ()=>{
                entryPointActions.unload();
            };
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "jira-issue-archival-modal",
            packageName: "jiraIssueArchiveModal",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: $106cbea13b7fe5ce$var$runtimeProps
        });
    };
    var $106cbea13b7fe5ce$export$2e2bcd8739ae039 = $106cbea13b7fe5ce$var$AsyncArchiveIssueModal;
});
parcelRegister("gc4aL", function(module, exports) {
    $parcel$export(module.exports, "archiveModalEntryPoint", ()=>$15209f7818ab8211$export$30191a6aa5a8420a);
    var $eufEc;
    var $fEDBv;
    const $15209f7818ab8211$export$30191a6aa5a8420a = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("jO28V")), {
            moduleId: "95ca667b"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("jO28V", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7iVhq")
    ]).then(()=>parcelRequire('liXBd'));
});
parcelRegister("fU2ZY", function(module, exports) {
    $parcel$export(module.exports, "AsyncIssueCreateModal", ()=>$c26773da2cb29846$export$2eb2fdb04fff9db3);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $c26773da2cb29846$var$IssueCreateModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("dNJQw")), {
        ssr: false,
        moduleId: "./src/packages/issue-create/issue-create-modal/src/index.tsx"
    });
    const $c26773da2cb29846$export$2eb2fdb04fff9db3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "async.jira.issue-create-modal",
            packageName: "jiraIssueCreate",
            sendToPrivacyUnsafeSplunk: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issue-create-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c26773da2cb29846$var$IssueCreateModal, null)));
});
parcelRegister("dNJQw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("kWrFZ"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("9VUTJ")
    ]).then(()=>parcelRequire('inVNu'));
});
parcelRegister("dZCvp", function(module, exports) {
    $parcel$export(module.exports, "AsyncIssueTransitionModal", ()=>$ed5673cba74ec79b$export$5156c94e3e50c841);
    var $5uXOq = parcelRequire("5uXOq");
    var $aIZdc;
    var $ivDCs;
    var $4mO32;
    var $4R6GH;
    var $kDy8L;
    var $iy0TK;
    var $jpZIw;
    var $dXq4S;
    var $koeKL;
    var $DVljb;
    var $jyKjq;
    var $bhzcv;
    const $ed5673cba74ec79b$var$runtimeProps = {};
    const $ed5673cba74ec79b$export$5156c94e3e50c841 = ()=>{
        const [{ isModalOpen: isModalOpen, payload: payload, isBenefitsModalOpen: isBenefitsModalOpen }] = (0, (0, parcelRequire("jpZIw")).useTriggerIssueTransitionModal)();
        const { transitionId: transitionId, issueId: issueId, issueKey: issueKey } = payload;
        const siteContextARI = (0, (0, parcelRequire("bhzcv")).useSiteContextARI)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const defautIssueAri = (0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'issue',
            resourceId: ''
        });
        const updatedIssueAriId = issueId ?? defautIssueAri;
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const variables = (0, $5uXOq.useMemo)(()=>{
            const shouldUseIssueKey = !issueId;
            const issueInput = shouldUseIssueKey ? {
                issueKey: issueKey
            } : {
                issueId: issueId
            };
            return {
                transitionId: transitionId,
                issueId: updatedIssueAriId,
                issueKey: issueKey,
                cloudId: cloudId,
                contextId: siteContextARI,
                moveGicFieldToDecomp: (0, (0, parcelRequire("4R6GH")).fg)('modern-issue-transition-fields-rollout-batch-2') || (0, (0, parcelRequire("aIZdc")).isFedRamp)(),
                shouldUseIssueKey: !issueId,
                issueInput: issueInput,
                locale: locale
            };
        }, [
            transitionId,
            updatedIssueAriId,
            issueKey,
            cloudId,
            siteContextARI,
            issueId,
            locale
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("jyKjq")).asyncIssueTransitionModal), variables);
        (0, (0, parcelRequire("iy0TK")).useSubscribeOpenIssueTransitionModalPubSub)();
        (0, $5uXOq.useEffect)(()=>{
            if (isModalOpen && transitionId && (issueKey || issueId)) entryPointActions.load();
            else entryPointActions.unload();
        }, [
            entryPointActions,
            isModalOpen,
            issueKey,
            issueId,
            transitionId
        ]);
        const { entryPointActions: benefitsModalentryPointActions, entryPointReferenceSubject: benefitsModalEntryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("kDy8L")).asyncTransitionBenefitsModal), {});
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) return;
            if (isBenefitsModalOpen) benefitsModalentryPointActions.load();
            else benefitsModalentryPointActions.unload();
        }, [
            benefitsModalentryPointActions,
            isBenefitsModalOpen
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ivDCs")).ModalEntryPointContainer), {
            entryPointReferenceSubject: benefitsModalEntryPointReferenceSubject,
            id: "async.jira.benefits-transition-modal",
            packageName: "jiraIssueTransitionModal",
            teamName: "Gryffindor",
            runtimeProps: $ed5673cba74ec79b$var$runtimeProps,
            entryPointActions: benefitsModalentryPointActions,
            errorFallback: "flag"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ivDCs")).ModalEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "async.jira.issue-transition-modal",
            packageName: "jiraIssueTransitionModal",
            teamName: "Gryffindor",
            runtimeProps: $ed5673cba74ec79b$var$runtimeProps,
            entryPointActions: entryPointActions,
            errorFallback: "flag"
        }));
    };
});
parcelRegister("kDy8L", function(module, exports) {
    $parcel$export(module.exports, "asyncTransitionBenefitsModal", ()=>$a519999d17069978$export$5afe60117d97d43d);
    var $eufEc;
    var $fEDBv;
    const $a519999d17069978$export$5afe60117d97d43d = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("d01Fr")), {
            moduleId: "164e3e4b"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("d01Fr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cTBzb")
    ]).then(()=>parcelRequire('d311G'));
});
parcelRegister("iy0TK", function(module, exports) {
    $parcel$export(module.exports, "useSubscribeOpenIssueTransitionModalPubSub", ()=>$9f9def5afcaee323$export$6f604f2d83486070);
    var $5uXOq = parcelRequire("5uXOq");
    var $jpZIw;
    var $gjoNn;
    var $iXy8e;
    const $9f9def5afcaee323$export$6f604f2d83486070 = ()=>{
        const [{ isModalOpen: isModalOpen }] = (0, (0, parcelRequire("jpZIw")).default)();
        const { openIssueTransitionModal: openIssueTransitionModalAction } = (0, (0, parcelRequire("gjoNn")).useTriggerIssueTransitionModalActions)();
        (0, $5uXOq.useEffect)(()=>{
            const handleMessage = (message)=>{
                if (!isModalOpen) openIssueTransitionModalAction(message.payload, message.isEnabled);
            };
            (0, (0, parcelRequire("iXy8e")).ITSPubSub).subscribe((0, $10a759732c3f1985$export$283bfc4a4b25707a), handleMessage);
            return ()=>{
                (0, (0, parcelRequire("iXy8e")).ITSPubSub).unsubscribe((0, $10a759732c3f1985$export$283bfc4a4b25707a), handleMessage);
            };
        }, [
            isModalOpen,
            openIssueTransitionModalAction
        ]);
        return null;
    };
});
parcelRegister("jpZIw", function(module, exports) {
    $parcel$export(module.exports, "useOpenIssueTransitionModal", ()=>$f41d32ebe3d90af0$export$736bd10472c63b49);
    $parcel$export(module.exports, "useCloseIssueTransitionModal", ()=>$f41d32ebe3d90af0$export$4629f18d511ad32e);
    $parcel$export(module.exports, "useTriggerIssueTransitionModal", ()=>$f41d32ebe3d90af0$export$95a1e9702d78f223);
    $parcel$export(module.exports, "default", ()=>$f41d32ebe3d90af0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $4R6GH;
    var $6ikhl;
    var $2gCtH;
    var $ct2PA;
    var $3NlyR;
    var $8zOmE;
    var $2NMNM;
    var $9MiT2;
    var $fNOVA;
    var $1btwe;
    var $gjoNn;
    var $ipUU1;
    const $f41d32ebe3d90af0$export$736bd10472c63b49 = ()=>{
        const { openIssueTransitionModal: openIssueTransitionModalAction, openIssueTransitionModalNew: openIssueTransitionModalNew } = (0, (0, parcelRequire("gjoNn")).useTriggerIssueTransitionModalActions)();
        const { stateGet: { state: { isEnabled: isEnabled = true } = {} } = {} } = (0, (0, parcelRequire("fNOVA")).useIssueTransitionLabsOptIn)();
        const publish = (0, (0, parcelRequire("1btwe")).usePublishOpenIssueTransitionModalPubSub)();
        const source = (0, (0, parcelRequire("2gCtH")).useAnalyticsSource)();
        const { fireUIEvent: fireUIEvent } = (0, (0, parcelRequire("3NlyR")).useIssueTransitionUIAnalyticsEvent)();
        const { stateGet: { state: state } } = (0, (0, parcelRequire("9MiT2")).useIssueTransitionChangeboardingPreferences)();
        const { fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened } = (0, (0, parcelRequire("ct2PA")).useIssueTransitionsOperationalAnalyticsEvent)();
        const benefitsModal = typeof state !== 'number' ? state?.benefitsModal : undefined;
        const { isDisabled: isDisabled, nextDateToShowBenefitsModal: nextDateToShowBenefitsModal } = benefitsModal || {};
        return (0, $5uXOq.useCallback)((nextState)=>{
            try {
                if ((0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) {
                    fireOperationalAnalyticsTransitionScreenOpened({
                        actionSubject: 'issueTransition triggered',
                        isBenefitsModalFGEneabled: (0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal'),
                        preferNewIssueTransitionScreen: isEnabled,
                        issueViewAnalyticsSource: source,
                        isBenefitsModalDisabled: isDisabled,
                        dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined
                    });
                    openIssueTransitionModalNew({
                        nextState: nextState,
                        preferNewIssueTransitionScreen: isEnabled,
                        issueViewAnalyticsSource: source,
                        publishTriggerToOpenTransitions: publish,
                        isBenefitsModalDisabled: isDisabled,
                        dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined,
                        fireUIEvent: fireUIEvent
                    });
                    return;
                }
                if (source === 'connect-issue') {
                    fireUIEvent({
                        actionSubject: 'issueTransition',
                        actionSubjectId: 'connectIssue',
                        action: 'opened'
                    });
                    publish(nextState, isEnabled);
                } else openIssueTransitionModalAction(nextState, isEnabled);
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'transitionIssueTrigger',
                        packageName: 'jiraIssueTransitionTrigger',
                        teamName: 'gryffindor'
                    },
                    attributes: {
                        transitionModalVersion: 'NEW'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }, [
            fireOperationalAnalyticsTransitionScreenOpened,
            isEnabled,
            source,
            isDisabled,
            nextDateToShowBenefitsModal,
            openIssueTransitionModalNew,
            publish,
            fireUIEvent,
            openIssueTransitionModalAction
        ]);
    };
    const $f41d32ebe3d90af0$export$4629f18d511ad32e = ()=>{
        const [, { resetState: resetState }] = (0, (0, parcelRequire("6ikhl")).useInlineFieldsActions)();
        const { closeIssueTransitionModal: closeIssueTransitionModalAction } = (0, (0, parcelRequire("gjoNn")).useTriggerIssueTransitionModalActions)();
        const { payload: { issueKey: issueKey, transitionId: transitionId }, onDialogCancel: onDialogCancel, onDialogError: onDialogError, onDialogSuccess: onDialogSuccess } = (0, (0, parcelRequire("gjoNn")).useTriggerIssueTransitionModalState)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, $5uXOq.useCallback)((shouldOpenLegacyModal = false)=>{
            closeIssueTransitionModalAction();
            (0, (0, parcelRequire("4R6GH")).fg)('ditto-fcf-transition-view-forge-rendering') && resetState();
            if (shouldOpenLegacyModal) {
                const onOpenDialog = ()=>{
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'switch to legacy transition screen');
                };
                (0, (0, parcelRequire("ipUU1")).openLegacyIssueTransitionModal)({
                    issueKey: issueKey,
                    isReopenScenario: true,
                    transitionId: transitionId,
                    onDialogCancel: onDialogCancel,
                    onDialogError: onDialogError,
                    onDialogSuccess: onDialogSuccess,
                    onOpenDialog: onOpenDialog
                });
            }
        }, [
            closeIssueTransitionModalAction,
            createAnalyticsEvent,
            issueKey,
            onDialogCancel,
            onDialogError,
            onDialogSuccess,
            transitionId,
            resetState
        ]);
    };
    const $f41d32ebe3d90af0$export$95a1e9702d78f223 = ()=>{
        const state = (0, (0, parcelRequire("gjoNn")).useTriggerIssueTransitionModalState)();
        const actions = (0, (0, parcelRequire("gjoNn")).useTriggerIssueTransitionModalActions)();
        const { openIssueTransitionModalNew: openIssueTransitionModalNew, ...restActions } = actions;
        const openIssueTransitionModal = $f41d32ebe3d90af0$export$736bd10472c63b49();
        return [
            state,
            {
                ...restActions,
                openIssueTransitionModal: openIssueTransitionModal
            }
        ];
    };
    var $f41d32ebe3d90af0$export$2e2bcd8739ae039 = $f41d32ebe3d90af0$export$95a1e9702d78f223;
});
parcelRegister("6ikhl", function(module, exports) {
    $parcel$export(module.exports, "useInlineFields", ()=>$d56dd4f138add558$export$71d5b5acb7d7f5ce);
    $parcel$export(module.exports, "useInlineField", ()=>$d56dd4f138add558$export$14c9655e9d9e873c);
    $parcel$export(module.exports, "useInlineFieldsActions", ()=>$d56dd4f138add558$export$cdb4b503c6154b35);
    var $3sQ5x;
    var $iXqE5;
    var $5rCpD;
    const $d56dd4f138add558$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'forge.inline-fields-state',
        initialState: {},
        actions: (0, parcelRequire("5rCpD")).default
    });
    const $d56dd4f138add558$export$71d5b5acb7d7f5ce = (0, (0, parcelRequire("3sQ5x")).createHook)($d56dd4f138add558$var$store);
    const $d56dd4f138add558$export$14c9655e9d9e873c = (0, (0, parcelRequire("3sQ5x")).createHook)($d56dd4f138add558$var$store, {
        selector: (state, fieldId)=>state[fieldId]
    });
    const $d56dd4f138add558$export$cdb4b503c6154b35 = (0, (0, parcelRequire("3sQ5x")).createHook)($d56dd4f138add558$var$store, {
        selector: null
    });
});
parcelRegister("5rCpD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$02373df28193ad93$export$2e2bcd8739ae039);
    var $hPhpd;
    const $02373df28193ad93$var$actions = {
        setFieldState: (0, parcelRequire("hPhpd")).setFieldState,
        resetState: (0, parcelRequire("hPhpd")).resetState,
        dispatchRetryFunction: (0, parcelRequire("hPhpd")).dispatchRetryFunction,
        dispatchFormSubmits: (0, parcelRequire("hPhpd")).dispatchFormSubmits
    };
    var $02373df28193ad93$export$2e2bcd8739ae039 = $02373df28193ad93$var$actions;
});
parcelRegister("hPhpd", function(module, exports) {
    $parcel$export(module.exports, "setFieldState", ()=>$9eca433be421af07$export$80fd62d9217dd703);
    $parcel$export(module.exports, "resetState", ()=>$9eca433be421af07$export$8e84bad0b35de9e8);
    $parcel$export(module.exports, "dispatchRetryFunction", ()=>$9eca433be421af07$export$27c59f06a7c1fe26);
    $parcel$export(module.exports, "dispatchFormSubmits", ()=>$9eca433be421af07$export$42fd5e650971333b);
    var $9J85a;
    const $9eca433be421af07$export$80fd62d9217dd703 = (data)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const stateObject = {
                status: data.status !== undefined ? data.status : currentState[data.fieldId]?.status,
                formRef: data.formRef !== undefined ? data.formRef : currentState[data.fieldId]?.formRef,
                retryFunction: data.retryFunction !== undefined ? data.retryFunction : currentState[data.fieldId]?.retryFunction
            };
            setState({
                ...getState(),
                [data.fieldId]: stateObject
            });
        };
    const $9eca433be421af07$export$8e84bad0b35de9e8 = ()=>({ getState: getState, setState: setState })=>{
            const stateToOverride = {};
            Object.getOwnPropertyNames(getState()).forEach((fieldId)=>{
                stateToOverride[fieldId] = {
                    status: (0, $3e5c7761c2e3cf02$export$bbf78c43fa5268c8)
                };
            });
            setState(stateToOverride);
        };
    const $9eca433be421af07$export$27c59f06a7c1fe26 = (fieldId)=>async ({ getState: getState })=>{
            const currentState = getState();
            const fieldData = currentState[fieldId];
            const retryFunction = fieldData?.retryFunction;
            retryFunction && retryFunction();
        };
    const $9eca433be421af07$export$42fd5e650971333b = ()=>async ({ getState: getState })=>{
            const currentState = getState();
            Object.keys(currentState).forEach((fieldId)=>{
                if (currentState[fieldId]?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487)) {
                    const formRef = currentState[fieldId]?.formRef;
                    (0, (0, parcelRequire("9J85a")).dispatchFormSubmitAndBlurElements)(formRef);
                }
            });
        };
});
const $3e5c7761c2e3cf02$export$32bbcfb76243a487 = 'FOCUSED';
const $3e5c7761c2e3cf02$export$f81c1d6b9217380c = 'PENDING';
const $3e5c7761c2e3cf02$export$2ace7d3737836262 = 'RESOLVED';
const $3e5c7761c2e3cf02$export$9956c6a700e724c4 = 'STORED';
const $3e5c7761c2e3cf02$export$742c877aeb0f3dbd = 'FAILED';
const $3e5c7761c2e3cf02$export$bbf78c43fa5268c8 = 'IDLE';
const $3e5c7761c2e3cf02$export$ae7c16bdba5e2e15 = 10000;
const $3e5c7761c2e3cf02$export$30daef8830f2505d = 'WAIT';
const $3e5c7761c2e3cf02$export$f86e250f1a7b07c8 = 'PROCEED';
const $3e5c7761c2e3cf02$export$e784a07a62e2e0e5 = 'TIMEOUT';
parcelRegister("9J85a", function(module, exports) {
    $parcel$export(module.exports, "submitForgeFormField", ()=>$b1c36799aab2b39a$export$7e50fee868362aa2);
    $parcel$export(module.exports, "dispatchFormSubmitAndBlurElements", ()=>$b1c36799aab2b39a$export$4d639a8e0790daf2);
    $parcel$export(module.exports, "isBlurEventTriggeredOutsideTheField", ()=>$b1c36799aab2b39a$export$ee23412a8bea9333);
    const $b1c36799aab2b39a$export$7e50fee868362aa2 = (formRef)=>{
        formRef?.current?.requestSubmit();
    };
    const $b1c36799aab2b39a$export$4d639a8e0790daf2 = (formRef)=>{
        $b1c36799aab2b39a$export$7e50fee868362aa2(formRef);
        if (formRef?.current?.elements) Array.from(formRef.current.elements).forEach((element)=>{
            if ('blur' in element && typeof element.blur === 'function') element?.blur();
        });
    };
    const $b1c36799aab2b39a$export$ee23412a8bea9333 = (fieldState, event, divRef)=>fieldState?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487) && !divRef.current?.contains(event.relatedTarget);
});
parcelRegister("ct2PA", function(module, exports) {
    $parcel$export(module.exports, "useIssueTransitionsOperationalAnalyticsEvent", ()=>$539a3126b0b48d6d$export$4d10663856b750d0);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    const $539a3126b0b48d6d$export$4d10663856b750d0 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireOperationalEventIssueTransitionFieldsCount = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject, fieldCount: fieldCount })=>{
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
                fieldCount: fieldCount
            });
        }, [
            createAnalyticsEvent
        ]);
        const fireOperationalAnalyticsPermissionsUnAvailable = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject })=>{
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject);
        }, [
            createAnalyticsEvent
        ]);
        const fireOperationalAnalyticsTransitionScreenOpened = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject, isBenefitsModalFGEneabled: isBenefitsModalFGEneabled, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen, issueViewAnalyticsSource: issueViewAnalyticsSource, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal })=>{
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
                isBenefitsModalFGEneabled: isBenefitsModalFGEneabled,
                preferNewIssueTransitionScreen: preferNewIssueTransitionScreen,
                issueViewAnalyticsSource: issueViewAnalyticsSource,
                isBenefitsModalDisabled: isBenefitsModalDisabled,
                dateToShowBenefitsModal: dateToShowBenefitsModal
            });
        }, [
            createAnalyticsEvent
        ]);
        return {
            fireOperationalEventIssueTransitionFieldsCount: fireOperationalEventIssueTransitionFieldsCount,
            fireOperationalAnalyticsPermissionsUnAvailable: fireOperationalAnalyticsPermissionsUnAvailable,
            fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened
        };
    };
});
parcelRegister("3NlyR", function(module, exports) {
    $parcel$export(module.exports, "useIssueTransitionUIAnalyticsEvent", ()=>$5656c248adec15f1$export$d0823e3d2e087672);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    const $5656c248adec15f1$export$d0823e3d2e087672 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireUIEvent = (0, $5uXOq.useCallback)(({ analyticsEvent: analyticsEvent, actionSubjectId: actionSubjectId, action: action = 'clicked', actionSubject: actionSubject, attributes: attributes = {} })=>{
            if (analyticsEvent !== undefined) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, actionSubjectId, attributes);
            else {
                const createdAnalyticsEvent = createAnalyticsEvent({
                    action: action,
                    actionSubject: actionSubject
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createdAnalyticsEvent, actionSubjectId, attributes);
            }
        }, [
            createAnalyticsEvent
        ]);
        return {
            fireUIEvent: fireUIEvent
        };
    };
});
parcelRegister("1btwe", function(module, exports) {
    $parcel$export(module.exports, "usePublishOpenIssueTransitionModalPubSub", ()=>$9796b79be99bbec0$export$76b6328962c9935f);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXy8e;
    const $9796b79be99bbec0$export$76b6328962c9935f = ()=>(0, $5uXOq.useCallback)((payload, isEnabled)=>{
            (0, (0, parcelRequire("iXy8e")).ITSPubSub).publish((0, $10a759732c3f1985$export$283bfc4a4b25707a), {
                payload: payload,
                isEnabled: isEnabled
            });
        }, []);
});
const $10a759732c3f1985$export$283bfc4a4b25707a = 'open-issue-transition-modal';
parcelRegister("iXy8e", function(module, exports) {
    $parcel$export(module.exports, "ITSPubSub", ()=>$c6c4e897a3edd1a2$export$a3877931259d622e);
    var $da7iT;
    const $c6c4e897a3edd1a2$export$a3877931259d622e = new (0, (0, parcelRequire("da7iT")).PubSubHub)();
    const $c6c4e897a3edd1a2$export$58b86c4766378620 = ()=>({
            ...$c6c4e897a3edd1a2$export$a3877931259d622e
        });
});
parcelRegister("da7iT", function(module, exports) {
    $parcel$export(module.exports, "PubSubHub", ()=>$4d1dbccbbe967a62$export$e3607828f8f2c01e);
    class $4d1dbccbbe967a62$export$e3607828f8f2c01e {
        constructor(){
            this.subscribers = {};
            this.subscribe = (event, subscriber)=>{
                let subs = this.subscribers[event];
                if (!subs) {
                    subs = [];
                    this.subscribers[event] = subs;
                }
                subs?.push(subscriber);
                return ()=>this.unsubscribe(event, subscriber);
            };
            this.unsubscribe = (event, subscriber)=>{
                const subs = this.subscribers[event];
                if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
            };
            this.publish = (event, data)=>{
                const subs = this.subscribers[event];
                if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
            };
            this.clearAll = ()=>{
                this.subscribers = {};
            };
        }
    }
});
parcelRegister("gjoNn", function(module, exports) {
    $parcel$export(module.exports, "TriggerIssueTransitionModalContainer", ()=>$18f6c8628e84d111$export$8ad65e459a406a8a);
    $parcel$export(module.exports, "useTriggerIssueTransitionModalActions", ()=>$18f6c8628e84d111$export$68de001c738e4145);
    $parcel$export(module.exports, "useTriggerIssueTransitionModalState", ()=>$18f6c8628e84d111$export$d3aceeec551eaab5);
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $QnL9H;
    var $bpOxh;
    const $18f6c8628e84d111$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-transition.issue-transition-form.use-trigger-issue-transition-modal',
        initialState: (0, parcelRequire("QnL9H")).initialState,
        actions: (0, parcelRequire("bpOxh"))
    });
    const $18f6c8628e84d111$export$8ad65e459a406a8a = (0, (0, parcelRequire("gg7kZ")).createContainer)($18f6c8628e84d111$var$store);
    const $18f6c8628e84d111$export$68de001c738e4145 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($18f6c8628e84d111$var$store);
    const $18f6c8628e84d111$export$d3aceeec551eaab5 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($18f6c8628e84d111$var$store);
});
parcelRegister("QnL9H", function(module, exports) {
    $parcel$export(module.exports, "initialState", ()=>$b1651ed43432db50$export$d4c72bab9d6cc13a);
    $parcel$export(module.exports, "OPEN_MODERN_TRANSITION_MODAL", ()=>$b1651ed43432db50$export$7320afd6d2c7276d);
    $parcel$export(module.exports, "OPEN_LEGACY_TRANSITION_MODAL", ()=>$b1651ed43432db50$export$8ed7400ca8e89de2);
    var $7Jxgt = parcelRequire("7Jxgt");
    const $b1651ed43432db50$export$d4c72bab9d6cc13a = {
        inProgressTransitionID: (0, ($parcel$interopDefault($7Jxgt))).v4(),
        isModalOpen: false,
        isBenefitsModalOpen: false,
        isSubsequentLoad: false,
        payload: {
            issueId: '',
            issueKey: '',
            transitionId: ''
        },
        id: 'issue-transition-dialog',
        title: null,
        fetchedIssueId: '',
        triggerPointKey: (0, $b09837015a6d4fc3$export$8d987f6e80b74000),
        openLegacyTransitionsDialog: null,
        onDialogSuccess: null,
        onDialogCancel: null,
        onDialogError: null
    };
    const $b1651ed43432db50$export$7320afd6d2c7276d = 'OPEN_MODERN_TRANSITION_MODAL';
    const $b1651ed43432db50$export$8ed7400ca8e89de2 = 'OPEN_LEGACY_TRANSITION_MODAL';
});
const $b09837015a6d4fc3$export$ef94a84e2990361c = 'issue-transition-issue-view';
const $b09837015a6d4fc3$export$de11f84a7d32933b = 'issue-transition-board-card-transition';
const $b09837015a6d4fc3$export$6c46e4003e7b7e9c = 'issue-transition-advanced-roadmaps-jira-transition';
const $b09837015a6d4fc3$export$e77cd508fbc3b5ba = 'issue-transition-backlog-inline-transition';
const $b09837015a6d4fc3$export$4edf4c3eee5081f6 = 'issue-transition-issue-view-shortcut-dialog';
const $b09837015a6d4fc3$export$27b74e685c26e665 = 'issue-transition-command-palette-status-field-transition';
const $b09837015a6d4fc3$export$290710ac08f770c0 = 'issue-transition-issue-results-shortcut-transition';
const $b09837015a6d4fc3$export$ddade13ad1b89bf0 = 'issue-transition-status-field-trigger';
const $b09837015a6d4fc3$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $b09837015a6d4fc3$export$2bf0e335b815a90b = 'comment';
const $b09837015a6d4fc3$export$1b8cc53b37a62399 = 'worklog';
const $b09837015a6d4fc3$export$d624b8367eb730df = 'issuelinks';
parcelRegister("bpOxh", function(module, exports) {
    $parcel$export(module.exports, "closeIssueTransitionModal", ()=>(parcelRequire("3KYVT")).default);
    $parcel$export(module.exports, "openIssueTransitionModal", ()=>(parcelRequire("3cIaS")).default);
    $parcel$export(module.exports, "restoreState", ()=>(parcelRequire("keQtD")).default);
    $parcel$export(module.exports, "setFetchedIssueId", ()=>(parcelRequire("fb5Xn")).default);
    $parcel$export(module.exports, "hideBenefitsModal", ()=>(parcelRequire("bemkp")).default);
    $parcel$export(module.exports, "openIssueTransitionModalNew", ()=>(parcelRequire("bnv5t")).default);
    var $3KYVT;
    var $3cIaS;
    var $keQtD;
    var $fb5Xn;
    var $bemkp;
    var $bnv5t;
});
parcelRegister("3KYVT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09ddf425c332ed49$export$2e2bcd8739ae039);
    var $QnL9H;
    const $09ddf425c332ed49$var$closeIssueTransitionModal = ()=>({ setState: setState })=>{
            setState({
                ...(0, (0, parcelRequire("QnL9H")).initialState),
                isModalOpen: false,
                isSubsequentLoad: true
            });
        };
    var $09ddf425c332ed49$export$2e2bcd8739ae039 = $09ddf425c332ed49$var$closeIssueTransitionModal;
});
parcelRegister("3cIaS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc7e957c004b1c31$export$2e2bcd8739ae039);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $eVcDT;
    var $emTT1;
    var $jcw0u;
    var $jtjyW;
    var $jHYHS;
    const $cc7e957c004b1c31$var$openIssueTransitionModal = (nextState, preferNewIssueTransitionScreen = true)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
                payload: {}
            };
            let transitionModalVersion = '';
            const isNewITSEnabled = (0, (0, parcelRequire("jHYHS")).isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
            try {
                if (isNewITSEnabled) {
                    transitionModalVersion = 'NEW';
                    (0, (0, parcelRequire("jtjyW")).startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                    setState({
                        ...currentState,
                        isModalOpen: true,
                        fetchedIssueId: '',
                        ...nextState
                    });
                } else {
                    transitionModalVersion = 'OLD';
                    (0, (0, parcelRequire("emTT1")).timeToRenderTransitionModal).start();
                    new (0, (0, parcelRequire("eVcDT")).default)({
                        issueKey: issueKey,
                        transitionId: transitionId
                    }).onDialogSuccess(onDialogSuccess || (0, ($parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, ($parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, ($parcel$interopDefault($8Rkzz)))).show();
                }
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'transitionIssueTrigger',
                        packageName: 'jiraIssueTransitionTrigger',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    attributes: {
                        transitionModalVersion: transitionModalVersion
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };
    var $cc7e957c004b1c31$export$2e2bcd8739ae039 = $cc7e957c004b1c31$var$openIssueTransitionModal;
});
parcelRegister("eVcDT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$25bfe0b90f22578e$export$2e2bcd8739ae039);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $6BZYo;
    var $4tcSU;
    var $emTT1;
    class $25bfe0b90f22578e$export$2e2bcd8739ae039 {
        constructor({ issueId: issueId, transitionId: transitionId, issueKey: issueKey, issueKeys: issueKeys }){
            this.onDialogSuccessCallback = (0, ($parcel$interopDefault($8Rkzz)));
            this.onDialogErrorCallback = (0, ($parcel$interopDefault($8Rkzz)));
            this.onDialogCancelCallback = (0, ($parcel$interopDefault($8Rkzz)));
            this.issueId = issueId;
            this.transitionId = transitionId;
            this.issueKey = issueKey;
            this.issueKeys = issueKeys;
        }
        static{
            this.onDialogContentReady = ()=>{
                setTimeout(()=>{
                    (0, (0, parcelRequire("emTT1")).timeToRenderTransitionModal).stop();
                });
            };
        }
        onDialogSuccess(onDialogSuccessCallback) {
            this.onDialogSuccessCallback = onDialogSuccessCallback;
            return this;
        }
        onDialogError(onDialogErrorCallback) {
            this.onDialogErrorCallback = onDialogErrorCallback;
            return this;
        }
        onDialogCancel(onDialogCancelCallback) {
            this.onDialogCancelCallback = onDialogCancelCallback;
            return this;
        }
        getIssueParam() {
            if (this.issueId != null) return `id=${this.issueId}`;
            if (this.issueKey != null) return `key=${this.issueKey}`;
            return '';
        }
        getUrl() {
            const { issueKeys: issueKeys } = this;
            if (issueKeys != null) return `/secure/BulkTransitionIssue!default.jspa?keys=${issueKeys.join(',')}&key=${issueKeys[0]}&action=${this.transitionId}&atl_token=${(0, (0, parcelRequire("4tcSU")).default)() || ''}&decorator=dialog&inline=true&returnUrl=`;
            return `/secure/WorkflowUIDispatcher.jspa?${this.getIssueParam()}&action=${this.transitionId}&atl_token=${(0, (0, parcelRequire("4tcSU")).default)() || ''}&returnUrl=`;
        }
        async show() {
            document.addEventListener('legacyJiraDialogContentReady', $25bfe0b90f22578e$export$2e2bcd8739ae039.onDialogContentReady);
            const FormDialog = await (0, (0, parcelRequire("6BZYo")).loadBridge)({
                name: 'jira/dialog/form-dialog',
                wrmKeys: 'wrc!jira.webresources:dialogs'
            });
            const dialog = new FormDialog({
                id: 'edit-issue-dialog',
                ajaxOptions: {
                    url: this.getUrl(),
                    dataType: 'json'
                },
                autoClose: true,
                widthClass: 'large',
                onDialogFinished: this.onDialogSuccessCallback,
                onUnSuccessfulSubmit: this.onDialogErrorCallback,
                shouldLoadHeritageFormDialogContext: true
            });
            const cancelNativeHandler = (event)=>{
                if (!(event instanceof CustomEvent)) return;
                const dialogElement = event.detail.popup;
                const { reason: reason } = event.detail;
                if (dialogElement.is(dialog.get$popup())) {
                    if (reason === 'cancel' || reason === 'esc') this.onDialogCancelCallback(event, dialogElement, reason);
                    document.removeEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
                    document.removeEventListener('legacyJiraDialogContentReady', $25bfe0b90f22578e$export$2e2bcd8739ae039.onDialogContentReady);
                }
            };
            document.addEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
            dialog.show();
        }
    }
});
parcelRegister("emTT1", function(module, exports) {
    $parcel$export(module.exports, "timeToRenderTransitionModal", ()=>$4a78c80c71ff3414$export$9d20a86383e90d09);
    var $dGrdR;
    const $4a78c80c71ff3414$export$9d20a86383e90d09 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'issue.time-to.render-issue-transition-screen',
        histogram: {
            result: '500_1000_2500_4000_7000_10000'
        }
    });
});
parcelRegister("jtjyW", function(module, exports) {
    $parcel$export(module.exports, "startIssueTransitionMetrics", ()=>$1832266ecf87e128$export$3fc439100e136a52);
    var $eTXmK;
    var $4R6GH;
    var $lL2Jl;
    var $lP1Jn;
    var $fc6nm;
    const $1832266ecf87e128$export$3fc439100e136a52 = (isSubsequentLoad)=>{
        (0, (0, parcelRequire("lL2Jl")).IssueTransitionLoadUFOExperience).start();
        (0, (0, parcelRequire("lL2Jl")).IssueTransitionUFOExperience).start();
        const issueTransitionModalLoadMetric = isSubsequentLoad ? (0, (0, parcelRequire("lP1Jn")).issueTransittionModalLoadSubsequent) : (0, (0, parcelRequire("lP1Jn")).issueTransitionModalLoad);
        if (isSubsequentLoad) (0, (0, parcelRequire("eTXmK")).default)('issue-transition.transition-modal-subsequent');
        else (0, (0, parcelRequire("eTXmK")).default)('issue-transition.transition-modal');
        issueTransitionModalLoadMetric.start();
        if ((0, (0, parcelRequire("4R6GH")).fg)('ui-modifications-on-issue-transition-view_7z1g0')) (0, (0, parcelRequire("fc6nm")).startUimTTI)();
    };
});
parcelRegister("lL2Jl", function(module, exports) {
    $parcel$export(module.exports, "IssueTransitionLoadUFOExperience", ()=>$f07939f1a4892f29$export$8fb308d8abecd81a);
    $parcel$export(module.exports, "IssueTransitionSubmitUFOExpereince", ()=>$f07939f1a4892f29$export$bd3bf8b90a131c50);
    $parcel$export(module.exports, "IssueTransitionUFOExperience", ()=>$f07939f1a4892f29$export$2f3b26e8acf79182);
    var $atdLB;
    var $duUGa;
    const $f07939f1a4892f29$export$8fb308d8abecd81a = new (0, (0, parcelRequire("duUGa")).UFOExperience)('issue-transition-screen.transition-load', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'issue-transition-screen.transition-load'
    });
    const $f07939f1a4892f29$export$bd3bf8b90a131c50 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('issue-transition-screen.transition-submit', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'issue-transition-screen.transition-sumbit'
    });
    const $f07939f1a4892f29$export$2f3b26e8acf79182 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('issue-transition-screen.transition-issue', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'issue-transition-screen.transition-issue'
    });
});
parcelRegister("lP1Jn", function(module, exports) {
    $parcel$export(module.exports, "issueTransitionModalLoad", ()=>$e48205cb6c384272$export$772fb4a8bd181fd6);
    $parcel$export(module.exports, "issueTransittionModalLoadSubsequent", ()=>$e48205cb6c384272$export$afa89f024c56a00a);
    var $dGrdR;
    const $e48205cb6c384272$export$772fb4a8bd181fd6 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'issue-transition-modal'
    });
    const $e48205cb6c384272$export$afa89f024c56a00a = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'issue-transition-modal-subsequent'
    });
});
parcelRegister("fc6nm", function(module, exports) {
    $parcel$export(module.exports, "startUimTTI", ()=>$50f6a9f98192a4eb$export$ae34c17d9cd2c876);
    $parcel$export(module.exports, "markIssueTransitionLoaded", ()=>$50f6a9f98192a4eb$export$7cc1bb35860c7c25);
    $parcel$export(module.exports, "stopTTI", ()=>$50f6a9f98192a4eb$export$30ca4c461fab486c);
    $parcel$export(module.exports, "cancelTTI", ()=>$50f6a9f98192a4eb$export$27f2445288b528c);
    $parcel$export(module.exports, "markIframeLoad", ()=>$50f6a9f98192a4eb$export$7a2709fc1e33401a);
    $parcel$export(module.exports, "markFieldsRegistered", ()=>$50f6a9f98192a4eb$export$cf3893335c93e33b);
    $parcel$export(module.exports, "markOnInitResolved", ()=>$50f6a9f98192a4eb$export$d86f4868694f2aa7);
    var $dGrdR;
    var $a1HyB;
    const $50f6a9f98192a4eb$var$uimInIssueTransitionTTI = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'ui-modifications-in-issue-transition',
        timings: [
            {
                key: 'issue-transition-tti-delta',
                startMark: 'issue-transition-tti'
            },
            {
                key: 'script-execution',
                startMark: 'iframe-load'
            },
            {
                key: 'loading-indicators-visibility',
                startMark: 'fields-registered'
            },
            {
                key: 'time-until-oninit-resolved',
                endMark: 'oninit-resolved'
            }
        ],
        featureFlags: (0, (0, parcelRequire("a1HyB")).TTIFFs)
    });
    const $50f6a9f98192a4eb$export$ae34c17d9cd2c876 = ()=>{
        $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.start();
    };
    const $50f6a9f98192a4eb$export$7cc1bb35860c7c25 = ()=>$50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('issue-transition-tti');
    const $50f6a9f98192a4eb$export$30ca4c461fab486c = (customData)=>{
        $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.stop({
            customData: customData
        });
    };
    const $50f6a9f98192a4eb$export$27f2445288b528c = ()=>{
        $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.cancel();
    };
    const $50f6a9f98192a4eb$export$7a2709fc1e33401a = ()=>{
        $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('iframe-load');
    };
    const $50f6a9f98192a4eb$export$cf3893335c93e33b = ()=>{
        $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('fields-registered');
    };
    const $50f6a9f98192a4eb$export$d86f4868694f2aa7 = ()=>{
        $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('oninit-resolved');
    };
});
parcelRegister("a1HyB", function(module, exports) {
    $parcel$export(module.exports, "TTIFFs", ()=>$aec371b77b607203$export$c396ba1504d97f3f);
    const $aec371b77b607203$export$c396ba1504d97f3f = [];
});
parcelRegister("jHYHS", function(module, exports) {
    $parcel$export(module.exports, "isNewTransitionScreenEnabled", ()=>$5f3a7dc1f1182e00$export$1f5b72e7dbe0548d);
    var $aIZdc;
    var $4R6GH;
    const $5f3a7dc1f1182e00$export$3e9c47f2b27760a = (triggerPointKey)=>{
        const triggerPointsFlags = {
            'issue-transition-issue-view': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-issue-view'),
            'issue-transition-issue-view-shortcut-dialog': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-issue-view-shortcut'),
            'issue-transition-board-card-transition': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-board-card-transition'),
            'issue-transition-advanced-roadmaps-jira-transition': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-advanced-roadmaps-jira-transition'),
            'issue-transition-command-palette-status-field-transition': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-command-palette-status'),
            'issue-transition-issue-results-shortcut-transition': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-issue-results-shortcut-transition'),
            'issue-transition-backlog-inline-transition': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-backlog-inline-transition'),
            'issue-transition-status-field-trigger': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-status-field-trigger'),
            'trigger-point-key-not-defined': (0, (0, parcelRequire("4R6GH")).fg)('trigger-point-key-not-defined')
        };
        return triggerPointsFlags[triggerPointKey];
    };
    const $5f3a7dc1f1182e00$export$1f5b72e7dbe0548d = (preferNewIssueTransitionScreen, triggerPointKey)=>{
        if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return true;
        if (!(0, (0, parcelRequire("4R6GH")).fg)('render-modern-issue-transition')) return false;
        if (!triggerPointKey || !$5f3a7dc1f1182e00$export$3e9c47f2b27760a(triggerPointKey)) return false;
        return preferNewIssueTransitionScreen || (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-customisation-for-srb');
    };
});
parcelRegister("keQtD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9984214aecd9b0cd$export$2e2bcd8739ae039);
    const $9984214aecd9b0cd$var$restoreState = (stateToRestore)=>({ setState: setState })=>{
            setState(stateToRestore);
        };
    var $9984214aecd9b0cd$export$2e2bcd8739ae039 = $9984214aecd9b0cd$var$restoreState;
});
parcelRegister("fb5Xn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$58f04f71b4951234$export$2e2bcd8739ae039);
    const $58f04f71b4951234$var$setFetchedIssueId = (issueId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const { fetchedIssueId: fetchedIssueId } = currentState;
            if (issueId !== fetchedIssueId) setState({
                ...currentState,
                fetchedIssueId: issueId
            });
        };
    var $58f04f71b4951234$export$2e2bcd8739ae039 = $58f04f71b4951234$var$setFetchedIssueId;
});
parcelRegister("bemkp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66c42f9cd1814e06$export$2e2bcd8739ae039);
    var $QnL9H;
    var $jtjyW;
    const $66c42f9cd1814e06$var$hideBenefitsModal = (nextAction)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (nextAction === (0, (0, parcelRequire("QnL9H")).OPEN_MODERN_TRANSITION_MODAL)) {
                (0, (0, parcelRequire("jtjyW")).startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isBenefitsModalOpen: false,
                    isModalOpen: true
                });
            } else if (nextAction === (0, (0, parcelRequire("QnL9H")).OPEN_LEGACY_TRANSITION_MODAL)) {
                const { openLegacyTransitionsDialog: openLegacyTransitionsDialog } = getState();
                setState({
                    ...currentState,
                    isBenefitsModalOpen: false,
                    isModalOpen: false
                });
                openLegacyTransitionsDialog?.();
            }
        };
    var $66c42f9cd1814e06$export$2e2bcd8739ae039 = $66c42f9cd1814e06$var$hideBenefitsModal;
});
parcelRegister("bnv5t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0522276a96c69778$export$2e2bcd8739ae039);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $eVcDT;
    var $emTT1;
    var $jcw0u;
    var $4R6GH;
    var $jtjyW;
    var $jHYHS;
    const $0522276a96c69778$var$openIssueTransitionModalNew = ({ nextState: nextState, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen = true, issueViewAnalyticsSource: issueViewAnalyticsSource, publishTriggerToOpenTransitions: publishTriggerToOpenTransitions, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal, fireUIEvent: fireUIEvent })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
                payload: {}
            };
            let transitionModalVersion = '';
            const isNewITSEnabled = (0, (0, parcelRequire("jHYHS")).isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
            try {
                if (isNewITSEnabled) {
                    if (issueViewAnalyticsSource === 'connect-issue') {
                        publishTriggerToOpenTransitions?.(nextState, preferNewIssueTransitionScreen);
                        fireUIEvent?.({
                            actionSubject: 'issueTransition',
                            actionSubjectId: 'connectIssue',
                            action: 'opened'
                        });
                        return;
                    }
                    transitionModalVersion = 'NEW';
                    (0, (0, parcelRequire("jtjyW")).startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                    setState({
                        ...currentState,
                        isModalOpen: true,
                        fetchedIssueId: '',
                        ...nextState
                    });
                    return;
                }
                const currentDate = new Date();
                const showBenefitsModalOnDate = dateToShowBenefitsModal && dateToShowBenefitsModal !== 'null' ? new Date(dateToShowBenefitsModal) : new Date(-1);
                const isDateToShowBenefitsModalLessThanCurrentDate = currentDate >= showBenefitsModalOnDate;
                if (!isBenefitsModalDisabled && issueViewAnalyticsSource !== 'connect-issue' && isDateToShowBenefitsModalLessThanCurrentDate && (0, (0, parcelRequire("4R6GH")).fg)('render-modern-issue-transition')) {
                    transitionModalVersion = 'NEW';
                    const callback = ()=>{
                        (0, (0, parcelRequire("emTT1")).timeToRenderTransitionModal).start();
                        new (0, (0, parcelRequire("eVcDT")).default)({
                            issueKey: issueKey,
                            transitionId: transitionId
                        }).onDialogSuccess(onDialogSuccess || (0, ($parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, ($parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, ($parcel$interopDefault($8Rkzz)))).show();
                    };
                    setState({
                        ...currentState,
                        isBenefitsModalOpen: true,
                        fetchedIssueId: '',
                        ...nextState,
                        openLegacyTransitionsDialog: callback
                    });
                } else {
                    transitionModalVersion = 'OLD';
                    (0, (0, parcelRequire("emTT1")).timeToRenderTransitionModal).start();
                    new (0, (0, parcelRequire("eVcDT")).default)({
                        issueKey: issueKey,
                        transitionId: transitionId
                    }).onDialogSuccess(onDialogSuccess || (0, ($parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, ($parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, ($parcel$interopDefault($8Rkzz)))).show();
                }
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'transitionIssueTrigger',
                        packageName: 'jiraIssueTransitionTrigger',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    attributes: {
                        transitionModalVersion: transitionModalVersion
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };
    var $0522276a96c69778$export$2e2bcd8739ae039 = $0522276a96c69778$var$openIssueTransitionModalNew;
});
parcelRegister("ipUU1", function(module, exports) {
    $parcel$export(module.exports, "openLegacyIssueTransitionModal", ()=>$f258fa9a0604f29b$export$6bfef2005bd55204);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $eVcDT;
    var $emTT1;
    var $jcw0u;
    const $f258fa9a0604f29b$export$6bfef2005bd55204 = ({ issueKey: issueKey, transitionId: transitionId, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, isReopenScenario: isReopenScenario = false, onOpenDialog: onOpenDialog })=>{
        try {
            (0, (0, parcelRequire("emTT1")).timeToRenderTransitionModal).start();
            new (0, (0, parcelRequire("eVcDT")).default)({
                issueKey: issueKey,
                transitionId: transitionId
            }).onDialogSuccess(onDialogSuccess || (0, ($parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, ($parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, ($parcel$interopDefault($8Rkzz)))).show();
            onOpenDialog?.();
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: 'OLD',
                    isReopenScenario: isReopenScenario
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
parcelRegister("jyKjq", function(module, exports) {
    $parcel$export(module.exports, "asyncIssueTransitionModal", ()=>$038cdec1423499c4$export$d06e6b324c2d867a);
    var $hbFya;
    var $eufEc;
    var $fEDBv;
    const $038cdec1423499c4$var$resource = (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("ainYw")), {
        moduleId: "ae3ffdfd"
    });
    const $038cdec1423499c4$var$getPreloadProps = (variables)=>({
            queries: {
                issueTransitionInitialQueryRef: {
                    parameters: (0, (0, parcelRequire("hbFya")).default),
                    variables: variables,
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        });
    const $038cdec1423499c4$export$d06e6b324c2d867a = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: $038cdec1423499c4$var$resource,
        getPreloadProps: $038cdec1423499c4$var$getPreloadProps
    });
});
parcelRegister("hbFya", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50f3db47c6c0511b$export$2e2bcd8739ae039);
    var $geiHG;
    var $6JKcD;
    const $50f3db47c6c0511b$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "e88f840ffaf5621cb6f194a447d091a7620a2aaececfd071e5be5efdd3a1e3e1",
            "metadata": {},
            "name": "main_getIssueTransitionByIdRootQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcfcfitswithaccessnarrowingrelayprovider": (0, (0, parcelRequire("geiHG")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcuimitstimetrackingoriginalestimatesupportrelayprovider": (0, (0, parcelRequire("6JKcD")).default)
            }
        }
    };
    var $50f3db47c6c0511b$export$2e2bcd8739ae039 = $50f3db47c6c0511b$var$node;
});
parcelRegister("geiHG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe349bc6e6a85f5e$export$2e2bcd8739ae039);
    var $4R6GH;
    var $fe349bc6e6a85f5e$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('fcf_in_issue_transition_with_access_narrowing');
        }
    };
});
parcelRegister("6JKcD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ee0b5fbdf82ff11$export$2e2bcd8739ae039);
    var $4R6GH;
    var $2ee0b5fbdf82ff11$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('uim-its-original-estimate-field-support');
        }
    };
});
parcelRegister("ainYw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("2XrBg")
    ]).then(()=>parcelRequire('cR6q4'));
});
parcelRegister("bhzcv", function(module, exports) {
    $parcel$export(module.exports, "useSiteContextARI", ()=>$a3cbfb3269314b4e$export$66718c2aeae88580);
    var $dXq4S;
    var $koeKL;
    const $a3cbfb3269314b4e$export$66718c2aeae88580 = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        return (0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira',
            resourceType: 'site',
            resourceId: cloudId
        });
    };
});
parcelRegister("fW7zE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0784bd5d04ab578e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $9B86Q;
    var $dJl1T;
    var $g5X3G;
    var $aos25;
    var $mSBKp;
    var $8sOt6;
    var $1OqgT;
    var $hdBMw;
    var $6aENA;
    var $1cYdf;
    var $f1zRs;
    var $4UM60;
    const $0784bd5d04ab578e$export$87d0ca22edb7493a = 'page-container.navigation.legacy-async-modals';
    class $0784bd5d04ab578e$export$ca935a4305b90cfe extends (0, $5uXOq.Component) {
        constructor(props){
            super(props), this.state = {
                ModalComponent: undefined
            };
            const createHandler = (ModalComponent, method)=>(options)=>this.showModal((modalProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement(ModalComponent, {
                            ...options,
                            ...modalProps
                        }), undefined, method);
            this.api = {
                showCreateDashboardModal: (0, ($parcel$interopDefault($8Rkzz))),
                showCopyDashboardModal: (0, ($parcel$interopDefault($8Rkzz))),
                showEditDashboardModal: (0, ($parcel$interopDefault($8Rkzz))),
                showEditFilterModal: createHandler((0, (0, parcelRequire("6aENA")).default), 'showEditFilterModal'),
                showEditPriorityMappingModal: createHandler((0, (0, parcelRequire("1cYdf")).default), 'showEditPriorityMappingModal'),
                showHardDeleteProjectModal: createHandler((0, (0, parcelRequire("f1zRs")).default), 'showHardDeleteProjectModal'),
                showConfigureMailServerModal: createHandler((0, (0, parcelRequire("mSBKp")).default), 'showConfigureMailServerModal'),
                showSoftDeleteProjectModal: createHandler((0, (0, parcelRequire("4UM60")).default), 'showSoftDeleteProjectModal'),
                showArchiveProjectModal: createHandler((0, (0, parcelRequire("aos25")).default), 'showArchiveProjectModal'),
                showConnectIssueModal: createHandler((0, (0, parcelRequire("8sOt6")).default), 'showConnectIssueModal'),
                showCustomFieldContextDeleteModal: createHandler((0, (0, parcelRequire("hdBMw")).default), 'showCustomFieldContextDeleteModal'),
                showCreateDashboardGadgetModal: createHandler((0, (0, parcelRequire("1OqgT")).default), 'showCreateDashboardGadgetModal')
            };
        }
        componentDidMount() {
            (0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/async-modals/bridge'
            }).then((bridge)=>bridge(this.api)).catch((e)=>{
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($0784bd5d04ab578e$export$87d0ca22edb7493a, 'Cannot load the bridge', e);
            });
        }
        showModal(ModalComponent, mountingPromise, method) {
            (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData($0784bd5d04ab578e$export$87d0ca22edb7493a, 'showModal', {
                method: method
            });
            if (this.state.ModalComponent) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($0784bd5d04ab578e$export$87d0ca22edb7493a, 'Tried to show the modal while another one is open');
                return undefined;
            }
            if (ModalComponent) {
                this.setState({
                    ModalComponent: ModalComponent
                });
                return {
                    close: ()=>this.closeModal(ModalComponent),
                    mountingPromise: mountingPromise
                };
            }
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($0784bd5d04ab578e$export$87d0ca22edb7493a, 'Tried to show the modal which does not exist');
            return undefined;
        }
        closeModal(ModalComponent) {
            if (this.state.ModalComponent === ModalComponent) this.setState({
                ModalComponent: undefined
            });
            else (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($0784bd5d04ab578e$export$87d0ca22edb7493a, 'Tried to close the modal which is not open');
        }
        render() {
            const { ModalComponent: ModalComponent } = this.state;
            const { baseUrl: baseUrl } = this.props;
            if (!ModalComponent) return null;
            const onClose = ()=>this.closeModal(ModalComponent);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ModalComponent, {
                baseUrl: (0, (0, parcelRequire("g5X3G")).toBaseUrl)(baseUrl),
                onClose: onClose
            });
        }
    }
    var $0784bd5d04ab578e$export$2e2bcd8739ae039 = $0784bd5d04ab578e$export$ca935a4305b90cfe;
});
parcelRegister("aos25", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$887636b773b484a9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $9VIxU;
    var $itmJb;
    const $887636b773b484a9$var$ArchiveProject = ({ baseUrl: baseUrl, onClose: onClose, projectName: projectName, projectId: projectId, projectType: projectType })=>{
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const onArchiveSuccess = ()=>{
            if (isAdmin) window.location.replace('/jira/settings/projects/manage');
            else window.location.replace('/jira/projects');
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "EditProjectDetails",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9VIxU")).default), {
            isProjectSimplified: false,
            onClose: onClose,
            baseUrl: baseUrl,
            projectName: projectName,
            projectId: projectId,
            projectType: projectType,
            onArchiveSuccess: onArchiveSuccess,
            onArchiveSuccessFlagRestore: undefined
        }));
    };
    var $887636b773b484a9$export$2e2bcd8739ae039 = $887636b773b484a9$var$ArchiveProject;
});
parcelRegister("9VIxU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa41bf898ba80cf6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $fa41bf898ba80cf6$var$LazyComponent = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("ePR83")), {
        moduleId: "./src/packages/project-pages/project-archive/project-archive-modal/src/index.tsx"
    });
    const $fa41bf898ba80cf6$var$Component = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "flag",
            id: "bundle-async-project-archive-modal",
            packageName: "jira-project-archive-modal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "project-archive-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
                metricKey: (0, $9294230cd5827edc$export$37312a67c3e314c6)
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($fa41bf898ba80cf6$var$LazyComponent, props)));
    var $fa41bf898ba80cf6$export$2e2bcd8739ae039 = $fa41bf898ba80cf6$var$Component;
});
const $9294230cd5827edc$export$37312a67c3e314c6 = 'PROJECT_ARCHIVE_MODAL_LOAD_START_MARK_KEY';
const $9294230cd5827edc$export$515f0dec8945cffc = 'div[data-test-id="project-archive-modal.ui.archive-modal.modal-footer.close-button-wrapper"]';
const $9294230cd5827edc$export$a374d20c3b9d9d28 = 'div[data-test-id="project-archive-modal.ui.archive-modal.modal-footer.archive-button-wrapper"]';
parcelRegister("ePR83", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4fsYb")
    ]).then(()=>parcelRequire('7F6ST'));
});
parcelRegister("mSBKp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5702682e9375f52a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $DLwRO;
    const $5702682e9375f52a$var$ConfigureMailServerModal = (props)=>{
        const { onClose: onClose, action: action, id: id, name: name, authenticationType: authenticationType } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("DLwRO")).default), {
            onClose: onClose,
            action: action,
            id: id,
            name: name,
            authenticationType: authenticationType
        });
    };
    var $5702682e9375f52a$export$2e2bcd8739ae039 = $5702682e9375f52a$var$ConfigureMailServerModal;
});
parcelRegister("DLwRO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a90d675c59ad13e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $heNNl;
    var $lfTZh;
    var $kxZPA;
    var $7TrIZ;
    const $4a90d675c59ad13e$var$AsyncLazyConfigureMailServerModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("hOlkz")), {
        moduleId: "./src/packages/admin-pages/incoming-mail/configure-mail-server-modal/src/ui/index.tsx"
    });
    var $4a90d675c59ad13e$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "configure-mail-server-modal",
            packageName: "jira-configure-mail-server-modal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "configure-mail-service-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
                metricKey: (0, (0, parcelRequire("7TrIZ")).LOAD_START_MARK_KEY)
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4a90d675c59ad13e$var$AsyncLazyConfigureMailServerModal, props)));
});
parcelRegister("7TrIZ", function(module, exports) {
    $parcel$export(module.exports, "LOAD_START_MARK_KEY", ()=>$d27b4bfc3c4f2465$export$37312a67c3e314c6);
    $parcel$export(module.exports, "OAUTH__UPDATE_SERVER_MODAL_ERROR_FLAG", ()=>$d27b4bfc3c4f2465$export$a792a4590d58b241);
    $parcel$export(module.exports, "OAUTH_SAVE_AND_REAUTHORIZE_SERVER_MODAL_SUCCESS_FLAG", ()=>$d27b4bfc3c4f2465$export$5eac226c393e310c);
    $parcel$export(module.exports, "OAUTH__SAVE_AND_REAUTHORIZE_SERVER_MODAL_ERROR_FLAG", ()=>$d27b4bfc3c4f2465$export$94d27d38e0820c0b);
    $parcel$export(module.exports, "CUSTOM_SERVER_MODAL_SUCCESS_FLAG", ()=>$d27b4bfc3c4f2465$export$53e713d2a98cd747);
    $parcel$export(module.exports, "CUSTOM_SERVER_MODAL_ERROR_FLAG", ()=>$d27b4bfc3c4f2465$export$a01d1307b4719d5f);
    $parcel$export(module.exports, "ADD_MAIL_SERVER_MODAL", ()=>$d27b4bfc3c4f2465$export$3ca722c2d79959e0);
    $parcel$export(module.exports, "EDIT_CUSTOM_MAIL_SERVER_MODAL", ()=>$d27b4bfc3c4f2465$export$7a0bad9b8f7f5f49);
    $parcel$export(module.exports, "EDIT_OAUTH_MAIL_SERVER_MODAL", ()=>$d27b4bfc3c4f2465$export$76d6a02740ddbf15);
    $parcel$export(module.exports, "ADD_CUSTOM_MAIL_SERVER_MODAL", ()=>$d27b4bfc3c4f2465$export$be66491207659cf9);
    $parcel$export(module.exports, "DELETE_MAIL_SERVER_MODAL", ()=>$d27b4bfc3c4f2465$export$d3334283d631bf5e);
    $parcel$export(module.exports, "SAVE_AND_REAUTHORIZE_MAIL_SERVER_MODAL", ()=>$d27b4bfc3c4f2465$export$2ff390148e621d72);
    $parcel$export(module.exports, "BASIC_DETAILS_MAIL_SERVER_CANCEL_BTN", ()=>$d27b4bfc3c4f2465$export$43eff1520f004691);
    $parcel$export(module.exports, "SAVE_AND_REAUTHORIZE_MAIL_SERVER_SUBMIT_BTN", ()=>$d27b4bfc3c4f2465$export$e7833cf4fbffefad);
    $parcel$export(module.exports, "SAVE_AND_REAUTHORIZE_MAIL_SERVER_CANCEL_BTN", ()=>$d27b4bfc3c4f2465$export$2834c8c25257c0a);
    $parcel$export(module.exports, "DELETE_SERVER_SUBMIT_BTN", ()=>$d27b4bfc3c4f2465$export$ee89d62be837cb5c);
    $parcel$export(module.exports, "DELETE_SERVER_CANCEL_BTN", ()=>$d27b4bfc3c4f2465$export$9cf43e929a820b51);
    $parcel$export(module.exports, "CUSTOM_DETAILS_MAIL_SERVER_SAVE_BTN", ()=>$d27b4bfc3c4f2465$export$a4061de68765281e);
    $parcel$export(module.exports, "CUSTOM_DETAILS_MAIL_SERVER_CANCEL_BTN", ()=>$d27b4bfc3c4f2465$export$469099411a8b9fdd);
    $parcel$export(module.exports, "GMAIL_SERVICE_KEY", ()=>$d27b4bfc3c4f2465$export$9d7fb5252c105003);
    $parcel$export(module.exports, "MICROSOFT_SERVICE_KEY", ()=>$d27b4bfc3c4f2465$export$55b35aa2fcc524dc);
    $parcel$export(module.exports, "getOAuth3LOProvider", ()=>$d27b4bfc3c4f2465$export$9624c6d13bd08f09);
    var $kTK0a;
    var $aIZdc;
    const $d27b4bfc3c4f2465$export$37312a67c3e314c6 = 'PROJECT_CONFIGURE_MAIL_SERVER_MODAL_LOAD_START_MARK_KEY';
    const $d27b4bfc3c4f2465$export$1af8dc0354a1479f = 'configure-mailserver-modal.ui.delete-mailserver-modal.flags.delete-success';
    const $d27b4bfc3c4f2465$export$ac16863eedc66f9f = 'configure-mailserver-modal.ui.delete-mailserver-modal.flags.delete-failure';
    const $d27b4bfc3c4f2465$export$a792a4590d58b241 = 'configure-mailserver-modal.ui.update-oauth-mailserver-modal.flags.create-failure';
    const $d27b4bfc3c4f2465$export$5eac226c393e310c = 'configure-mailserver-modal.ui.update-oauth-save-and-reauthorize-mailserver-modal.flags.create-success';
    const $d27b4bfc3c4f2465$export$94d27d38e0820c0b = 'configure-mailserver-modal.ui.update-oauth-save-and-reauthorize-mailserver-modal.flags.create-failure';
    const $d27b4bfc3c4f2465$export$53e713d2a98cd747 = 'configure-mailserver-modal.ui.basic-mailserver-modal.flags.create-success';
    const $d27b4bfc3c4f2465$export$a01d1307b4719d5f = 'configure-mailserver-modal.ui.basic-mailserver-modal.flags.create-failure';
    const $d27b4bfc3c4f2465$export$22ea0ea53d2d0fa4 = 'configure-mail-server-modal.custom-mailserver-modal.inline-error';
    const $d27b4bfc3c4f2465$export$3ca722c2d79959e0 = 'addMailServer';
    const $d27b4bfc3c4f2465$export$7a0bad9b8f7f5f49 = 'editCustomMailServer';
    const $d27b4bfc3c4f2465$export$76d6a02740ddbf15 = 'editOAUTHMailServer';
    const $d27b4bfc3c4f2465$export$be66491207659cf9 = 'addCustomMailServer';
    const $d27b4bfc3c4f2465$export$d3334283d631bf5e = 'deleteMailServer';
    const $d27b4bfc3c4f2465$export$2ff390148e621d72 = 'saveChanges';
    const $d27b4bfc3c4f2465$export$43eff1520f004691 = 'cancelSaveMailServerButton';
    const $d27b4bfc3c4f2465$export$e7833cf4fbffefad = 'saveMailServerButton';
    const $d27b4bfc3c4f2465$export$2834c8c25257c0a = 'cancelSaveMailServerButton';
    const $d27b4bfc3c4f2465$export$ee89d62be837cb5c = 'confirmDeleteMailServerButton';
    const $d27b4bfc3c4f2465$export$9cf43e929a820b51 = 'cancelDeleteMailServerButton';
    const $d27b4bfc3c4f2465$export$a4061de68765281e = 'saveCustomMailServerButton';
    const $d27b4bfc3c4f2465$export$469099411a8b9fdd = 'cancelSaveCustomMailServerButton';
    const $d27b4bfc3c4f2465$export$9d7fb5252c105003 = 'jira-email-service-gmail';
    const $d27b4bfc3c4f2465$export$55b35aa2fcc524dc = 'jira-email-service-microsoft';
    const $d27b4bfc3c4f2465$export$9624c6d13bd08f09 = ()=>{
        if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return {
            [$d27b4bfc3c4f2465$export$55b35aa2fcc524dc]: {
                prod: {
                    containerId: 'f09c06db-0957-4ede-8d6d-daceccc22995',
                    threeLOUrl: `https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id', [
                        'prod',
                        'fedramp-moderate'
                    ])}/outboundAuth/v2/start`
                },
                staging: {
                    containerId: 'aadbeed2-cccd-4596-a61d-f1f8e4924769',
                    threeLOUrl: `https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id', [
                        'stg',
                        'fedramp-moderate'
                    ])}/outboundAuth/v2/start`
                },
                dev: {
                    containerId: 'aadbeed2-cccd-4596-a61d-f1f8e4924769',
                    threeLOUrl: `https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id', [
                        'stg',
                        'fedramp-moderate'
                    ])}/outboundAuth/v2/start`
                },
                local: {
                    containerId: 'aadbeed2-cccd-4596-a61d-f1f8e4924769',
                    threeLOUrl: `https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id', [
                        'dev',
                        'fedramp-moderate'
                    ])}/outboundAuth/v2/start`
                }
            },
            [$d27b4bfc3c4f2465$export$9d7fb5252c105003]: {
                prod: {
                    containerId: 'f09c06db-0957-4ede-8d6d-daceccc22995',
                    threeLOUrl: `https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id', [
                        'prod',
                        'fedramp-moderate'
                    ])}/outboundAuth/v2/start`
                },
                staging: {
                    containerId: 'aadbeed2-cccd-4596-a61d-f1f8e4924769',
                    threeLOUrl: `https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id', [
                        'stg',
                        'fedramp-moderate'
                    ])}/outboundAuth/v2/start`
                },
                dev: {
                    containerId: 'aadbeed2-cccd-4596-a61d-f1f8e4924769',
                    threeLOUrl: `https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id', [
                        'stg',
                        'fedramp-moderate'
                    ])}/outboundAuth/v2/start`
                },
                local: {
                    containerId: 'aadbeed2-cccd-4596-a61d-f1f8e4924769',
                    threeLOUrl: `https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id', [
                        'dev',
                        'fedramp-moderate'
                    ])}/outboundAuth/v2/start`
                }
            }
        };
        return {
            [$d27b4bfc3c4f2465$export$55b35aa2fcc524dc]: {
                prod: {
                    containerId: '4236689d-d21d-4741-ab4f-71892b2d55f9',
                    threeLOUrl: `https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id')}/outboundAuth/v2/start`
                },
                staging: {
                    containerId: 'e1b53a56-0a21-419e-a258-ee1d435ea0b8',
                    threeLOUrl: `https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id', [
                        'stg',
                        'commercial'
                    ])}/outboundAuth/v2/start`
                },
                dev: {
                    containerId: 'e1b53a56-0a21-419e-a258-ee1d435ea0b8',
                    threeLOUrl: `https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id', [
                        'stg',
                        'commercial'
                    ])}/outboundAuth/v2/start`
                },
                local: {
                    containerId: 'e1b53a56-0a21-419e-a258-ee1d435ea0b8',
                    threeLOUrl: `https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id', [
                        'dev',
                        'commercial'
                    ])}/outboundAuth/v2/start`
                }
            },
            [$d27b4bfc3c4f2465$export$9d7fb5252c105003]: {
                prod: {
                    containerId: 'c16a389e-0776-44b3-9528-19c82119a022',
                    threeLOUrl: `https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id')}/outboundAuth/v2/start`
                },
                staging: {
                    containerId: 'f4b08e22-5fdf-43c0-b33b-5178bbae4caf',
                    threeLOUrl: `https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id', [
                        'stg',
                        'commercial'
                    ])}/outboundAuth/v2/start`
                },
                dev: {
                    containerId: 'f4b08e22-5fdf-43c0-b33b-5178bbae4caf',
                    threeLOUrl: `https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id', [
                        'stg',
                        'commercial'
                    ])}/outboundAuth/v2/start`
                },
                local: {
                    containerId: 'f4b08e22-5fdf-43c0-b33b-5178bbae4caf',
                    threeLOUrl: `https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id', [
                        'dev',
                        'commercial'
                    ])}/outboundAuth/v2/start`
                }
            }
        };
    };
});
parcelRegister("hOlkz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bWjj8").then(()=>parcelRequire('58Y6J'));
});
parcelRegister("8sOt6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4ac2a9543ccb39cd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gNtqu;
    var $60eX6;
    const $4ac2a9543ccb39cd$var$ConnectIssueModal = ({ issueKey: issueKey, onClose: onClose, onCancel: onCancel, onError: onError })=>{
        const onCloseCallback = (0, $5uXOq.useCallback)((props)=>{
            onClose();
            onCancel?.(props);
        }, [
            onCancel,
            onClose
        ]);
        (0, (0, parcelRequire("60eX6")).useNavigationEffect)(()=>{
            setTimeout(()=>onCloseCallback(issueKey));
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gNtqu")).AsyncConnectModal), {
            issueKey: issueKey,
            onClose: onCloseCallback,
            onError: onError
        });
    };
    var $4ac2a9543ccb39cd$export$2e2bcd8739ae039 = $4ac2a9543ccb39cd$var$ConnectIssueModal;
});
parcelRegister("gNtqu", function(module, exports) {
    $parcel$export(module.exports, "AsyncConnectModal", ()=>$7eab21d6e189639a$export$114a56bd5931fa2a);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $7eab21d6e189639a$var$ConnectModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("6S68r")).then(({ ConnectIssueModal: ConnectIssueModal })=>ConnectIssueModal), {
        moduleId: "./src/packages/issue/connect-modal/src/index.tsx"
    });
    const $7eab21d6e189639a$export$114a56bd5931fa2a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "connect-issue-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7eab21d6e189639a$var$ConnectModal, props));
});
parcelRegister("6S68r", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3z8RG")
    ]).then(()=>parcelRequire('VXphi'));
});
parcelRegister("60eX6", function(module, exports) {
    $parcel$export(module.exports, "useNavigationEffect", ()=>$4ec67608f7cb5167$export$619befab0baf5dd8);
    var $5uXOq = parcelRequire("5uXOq");
    var $1XJ20;
    var $lODMY;
    const $4ec67608f7cb5167$var$useRouteLocation = (0, (0, parcelRequire("lODMY")).createRouterSelector)(({ location: location })=>`${location.pathname}?${location.search}`);
    const $4ec67608f7cb5167$export$619befab0baf5dd8 = (callback)=>{
        const locationKey = $4ec67608f7cb5167$var$useRouteLocation();
        const callbackRef = (0, $5uXOq.useRef)(callback);
        callbackRef.current = callback;
        const previousLocationKey = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(locationKey);
        (0, $5uXOq.useEffect)(()=>{
            if (previousLocationKey !== locationKey) callbackRef.current();
        }, [
            previousLocationKey,
            locationKey
        ]);
    };
});
parcelRegister("1OqgT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1093f59887932ee3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5mPDN;
    var $lVJAU;
    const $1093f59887932ee3$var$CreateDashboardGadgetModal = ({ onClose: onClose, baseUrl: _, onInitiateFailed: __, onInitiateSuccess: ___, ...filterIdOrJql })=>{
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const onSuccess = (dashboardId)=>{
            onClose();
            push(`/jira/dashboards/${dashboardId}/edit`);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5mPDN")).default), {
            onSuccess: onSuccess,
            onCancel: onClose,
            ...filterIdOrJql
        });
    };
    var $1093f59887932ee3$export$2e2bcd8739ae039 = $1093f59887932ee3$var$CreateDashboardGadgetModal;
});
parcelRegister("5mPDN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61873313b5b3f151$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $j55bS;
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $61873313b5b3f151$var$LazyCreateDashboardGadgetModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("aulb0")), {
        moduleId: "./src/packages/global-pages/dashboard/create-dashboard-gadget-modal/src/main.tsx"
    });
    var $61873313b5b3f151$export$2e2bcd8739ae039 = ({ onFailed: onFailed = ()=>undefined, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "AsyncCreateDashboardGadgetModal",
            packageName: "jiraDashboardCreateDashboardGadgetModal",
            fallback: "flag",
            onError: onFailed
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-create-dashboard-gadget-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j55bS")).default), {
                isTinted: true
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($61873313b5b3f151$var$LazyCreateDashboardGadgetModal, props)));
});
parcelRegister("aulb0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("fBBWl")
    ]).then(()=>parcelRequire('8N43S'));
});
parcelRegister("hdBMw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07b0f9b2d7d13070$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $9ENzx;
    var $iXVV6;
    const $07b0f9b2d7d13070$var$AsyncCustomFieldContextDelete = ({ baseUrl: baseUrl, onClose: onClose, customFieldId: customFieldId, fieldConfigSchemeId: fieldConfigSchemeId, ContextualAnalyticsData: ContextualAnalyticsData = (0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), AsyncCustomFieldContextDeleteModal: AsyncCustomFieldContextDeleteModal = (0, (0, parcelRequire("9ENzx")).default) })=>{
        const onContextDeleteSuccess = ()=>{
            onClose();
            window.location.reload();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ContextualAnalyticsData, {
            sourceName: "CustomFieldContextDetails",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(AsyncCustomFieldContextDeleteModal, {
            baseUrl: baseUrl,
            customFieldId: customFieldId,
            fieldConfigSchemeId: fieldConfigSchemeId,
            onDeleteSuccess: onContextDeleteSuccess,
            onDeleteFailure: (0, ($parcel$interopDefault($8Rkzz))),
            onClose: onClose
        }));
    };
    var $07b0f9b2d7d13070$export$2e2bcd8739ae039 = $07b0f9b2d7d13070$var$AsyncCustomFieldContextDelete;
});
parcelRegister("9ENzx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ee670782eae9ebf4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $7CMCs;
    var $iqr2y;
    var $lfTZh;
    var $kxZPA;
    const $ee670782eae9ebf4$var$ErrorComponent = ({ error: error })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqr2y")).ErrorFlagRenderer), {
            id: "bundle-async-custom-field-context-delete-modal",
            error: error
        });
    const $ee670782eae9ebf4$var$preloadComponent = ()=>(parcelRequire("5ORrD"));
    const $ee670782eae9ebf4$var$LazyFieldContextDeleteModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>$ee670782eae9ebf4$var$preloadComponent(), {});
    function $ee670782eae9ebf4$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "asyncFieldContextDeleteModal",
            packageName: "jiraCustomFieldContextDeleteModal",
            teamName: "morphinecake",
            fallback: $ee670782eae9ebf4$var$ErrorComponent,
            sendToPrivacyUnsafeSplunk: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "field-context-delete-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
                metricKey: (0, $34e557ab47e26832$export$37312a67c3e314c6)
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ee670782eae9ebf4$var$LazyFieldContextDeleteModal, props)));
    }
});
const $34e557ab47e26832$export$37312a67c3e314c6 = 'CUSTOM_FIELD_CONTEXT_DELETE_MODAL_LOAD_START_MARK_KEY';
parcelRegister("5ORrD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3gzep")
    ]).then(()=>parcelRequire('19u51'));
});
parcelRegister("6aENA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ba9942bc933cf50d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $bzokN;
    const $ba9942bc933cf50d$var$EditFilter = ({ sharePermissions: sharePermissions, editPermissions: editPermissions, id: id, name: name, description: description, baseUrl: baseUrl, onClose: onClose })=>{
        const onSuccess = ()=>{
            onClose();
            window.location.reload();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bzokN")).default), {
            id: id,
            sharePermissions: sharePermissions,
            editPermissions: editPermissions,
            name: name,
            description: description,
            baseUrl: baseUrl,
            onInitiateSuccess: (0, ($parcel$interopDefault($8Rkzz))),
            onCancel: onClose,
            onEdited: onSuccess
        });
    };
    var $ba9942bc933cf50d$export$2e2bcd8739ae039 = $ba9942bc933cf50d$var$EditFilter;
});
parcelRegister("bzokN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a65c7409abb3f6db$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $a65c7409abb3f6db$var$RLLAsyncEditFilterModal = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("84YvD")), {
        moduleId: "./src/packages/global-pages/directories/filters-directory-v2/edit-filters-modal/src/index.tsx"
    });
    const $a65c7409abb3f6db$var$RLLAsyncEditFilterModalContainer = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "edit-filter-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a65c7409abb3f6db$var$RLLAsyncEditFilterModal, props));
    var $a65c7409abb3f6db$export$2e2bcd8739ae039 = $a65c7409abb3f6db$var$RLLAsyncEditFilterModalContainer;
});
parcelRegister("84YvD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("htTGY")
    ]).then(()=>parcelRequire('l6Ke4'));
});
parcelRegister("1cYdf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b440ce806750f9c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ibLiq;
    const $b440ce806750f9c1$var$EditPriorityMapping = ({ cloudId: cloudId, onClose: onClose, priorities: priorities, defaultPriorityId: defaultPriorityId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ibLiq")).AsyncEditPriorityMappingModal), {
            cloudId: cloudId,
            onClose: onClose,
            jiraPriorities: priorities,
            defaultJiraPriorityId: defaultPriorityId
        });
    var $b440ce806750f9c1$export$2e2bcd8739ae039 = $b440ce806750f9c1$var$EditPriorityMapping;
});
parcelRegister("ibLiq", function(module, exports) {
    $parcel$export(module.exports, "AsyncEditPriorityMappingModal", ()=>$4d66ab5f8d5533b1$export$209a6ab110d0e343);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $4d66ab5f8d5533b1$var$EditPriorityMappingModal = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("diM5e")).then((module)=>module.EditPriorityMappingModalApp), {
        moduleId: "./src/packages/servicedesk/incident-management/edit-priority-mapping-modal/src/main.tsx"
    });
    const $4d66ab5f8d5533b1$export$209a6ab110d0e343 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "edit-priority-mapping-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4d66ab5f8d5533b1$var$EditPriorityMappingModal, props));
});
parcelRegister("diM5e", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("jjtbn")
    ]).then(()=>parcelRequire('4qNxg'));
});
parcelRegister("f1zRs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$679e17408e069be2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $iXVV6;
    var $5Esj0;
    const $679e17408e069be2$var$AsyncHardDeleteProject = ({ baseUrl: baseUrl, onClose: onClose, projectName: projectName, projectId: projectId, projectType: projectType, isProjectSimplified: isProjectSimplified, ContextualAnalyticsData: ContextualAnalyticsData = (0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), AsyncHardDeleteProjectModal: AsyncHardDeleteProjectModal = (0, (0, parcelRequire("5Esj0")).default) })=>{
        const onProjectActionSuccess = ()=>{
            onClose();
            window.location.replace(`${baseUrl}/jira/your-work`);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ContextualAnalyticsData, {
            sourceName: "EditProjectDetails",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(AsyncHardDeleteProjectModal, {
            onClose: onClose,
            baseUrl: baseUrl,
            projectName: projectName,
            projectType: projectType,
            projectId: projectId,
            isProjectSimplified: isProjectSimplified,
            onProjectDeleteSuccess: onProjectActionSuccess,
            onProjectDeleteFailure: (0, ($parcel$interopDefault($8Rkzz)))
        }));
    };
    var $679e17408e069be2$export$2e2bcd8739ae039 = $679e17408e069be2$var$AsyncHardDeleteProject;
});
parcelRegister("5Esj0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f757831b128c5f9a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $f757831b128c5f9a$var$LazyComponent = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("3pXJi")), {
        moduleId: "./src/packages/project-pages/project-restore/project-permanent-delete-modal/src/index.tsx"
    });
    const $f757831b128c5f9a$var$Component = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "flag",
            id: "bundle-async-project-permanent-delete-modal",
            packageName: "jira-project-permanent-delete-modal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "project-permanent-delete-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
                metricKey: (0, $31116cfa91c28463$export$37312a67c3e314c6)
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f757831b128c5f9a$var$LazyComponent, props)));
    var $f757831b128c5f9a$export$2e2bcd8739ae039 = $f757831b128c5f9a$var$Component;
});
const $31116cfa91c28463$export$37312a67c3e314c6 = 'PROJECT_PERMANENT_DELETE_MODAL_LOAD_START_MARK_KEY';
parcelRegister("3pXJi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("gSb1A")
    ]).then(()=>parcelRequire('fHKZN'));
});
parcelRegister("4UM60", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$05d0e78c2a4a9ffb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $iXVV6;
    var $9M6pR;
    var $itmJb;
    const $05d0e78c2a4a9ffb$var$AsyncSoftDeleteProject = ({ baseUrl: baseUrl, onClose: onClose, projectName: projectName, projectId: projectId, projectType: projectType, isProjectSimplified: isProjectSimplified })=>{
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const onDeleteProjectSuccess = ()=>{
            onClose();
            if (isAdmin) window.location.replace('/jira/settings/projects/manage');
            else window.location.replace('/jira/projects');
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "EditProjectDetails",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9M6pR")).default), {
            onClose: onClose,
            baseUrl: baseUrl,
            projectName: projectName,
            projectType: projectType,
            projectId: projectId,
            isProjectSimplified: isProjectSimplified,
            onDeleteProjectSuccess: onDeleteProjectSuccess,
            onDeleteProjectFailure: (0, ($parcel$interopDefault($8Rkzz))),
            onDeleteSuccessFlagRestore: undefined
        }));
    };
    var $05d0e78c2a4a9ffb$export$2e2bcd8739ae039 = $05d0e78c2a4a9ffb$var$AsyncSoftDeleteProject;
});
parcelRegister("9M6pR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8edb5aab869d07ff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $8edb5aab869d07ff$var$LazyComponent = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("2tTWT")), {
        moduleId: "./src/packages/project-pages/project-restore/project-soft-delete-modal/src/index.tsx"
    });
    const $8edb5aab869d07ff$var$Component = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            fallback: "flag",
            id: "bundle-async-project-soft-delete-modal-errors",
            packageName: "jira-project-soft-delete-modal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "project-soft-delete-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
                metricKey: (0, $6dcc48d441963929$export$37312a67c3e314c6)
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8edb5aab869d07ff$var$LazyComponent, props)));
    var $8edb5aab869d07ff$export$2e2bcd8739ae039 = $8edb5aab869d07ff$var$Component;
});
const $6dcc48d441963929$export$37312a67c3e314c6 = 'PROJECT_SOFT_DELETE_MODAL_LOAD_START_MARK_KEY';
parcelRegister("2tTWT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("9quHp")
    ]).then(()=>parcelRequire('akNnn'));
});
parcelRegister("5o7us", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ea8d0dfb0537a61$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $lfTZh;
    var $kxZPA;
    const $3ea8d0dfb0537a61$var$NewIssueCreateTrigger = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("cpw9v")), {
        ssr: false,
        moduleId: "./src/packages/issue-create/new-issue-create-trigger/src/index.tsx"
    });
    var $3ea8d0dfb0537a61$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.jira.new-issue-create-trigger",
            packageName: "jiraNewIssueCreateTrigger"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "new-issue-create-trigger",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3ea8d0dfb0537a61$var$NewIssueCreateTrigger, null)));
});
parcelRegister("cpw9v", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3sWSo").then(()=>parcelRequire('dF2GM'));
});
parcelRegister("v8jPJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7478bb7f9d529e4c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $9kPzn;
    var $lLLkM;
    var $bgrar;
    var $8CUq3;
    var $eZJjh;
    var $7iJwP;
    var $koVbs;
    var $1nUas;
    var $lfTZh;
    var $4ENQh;
    var $kxZPA;
    var $gD5Z0;
    var $ce9SK;
    const $7478bb7f9d529e4c$var$CrossIconMedium = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))), {
            size: "medium",
            label: formatMessage((0, (0, parcelRequire("ce9SK")).default).close)
        });
    };
    const $7478bb7f9d529e4c$export$3039dc74ce32c9c8 = (0, (0, parcelRequire("kxZPA")).lazy)(()=>{
        (0, (0, parcelRequire("4ENQh")).monitor).startTask((0, $08d1cd363c5f7148$export$9a977208af30ffae));
        return (parcelRequire("bxHf8")).then((module)=>module.default);
    }, {
        ssr: false,
        moduleId: "./src/packages/portfolio-3/create-new-plan-wizard-drawer/src/ui/content/index.tsx"
    });
    const $7478bb7f9d529e4c$var$CreateNewPlanWizardDrawer = ({ PlanWizard: PlanWizard = $7478bb7f9d529e4c$export$3039dc74ce32c9c8 })=>{
        const [{ isOpen: isOpen, plan: plan }, { closeDrawer: closeDrawer }] = (0, (0, parcelRequire("gD5Z0")).useCreateNewPlanWizardDrawer)();
        const { loading: loading, intlMessages: intlMessages, locale: locale } = (0, (0, parcelRequire("gD5Z0")).useImportedMessagesForLocale)();
        const keepMounted = (0, $5uXOq.useRef)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (!keepMounted.current && !isOpen) return null;
        if (!keepMounted.current) keepMounted.current = true;
        const handleRequestClose = (e)=>{
            if (e.key === 'Escape') return;
            closeDrawer();
        };
        const spinner = (0, ($parcel$interopDefault($5uXOq))).createElement($7478bb7f9d529e4c$var$Center, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "xlarge"
        }));
        const content = (()=>{
            if (loading) return spinner;
            if (!intlMessages) return (0, ($parcel$interopDefault($5uXOq))).createElement(PlanWizard, {
                plan: plan
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1nUas")).IntlProvider), {
                messages: intlMessages,
                locale: locale
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(PlanWizard, {
                plan: plan
            }));
        })();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "create-new-plan-wizard",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9kPzn")).default), {
            isOpen: isOpen,
            width: "full",
            onClose: handleRequestClose,
            icon: $7478bb7f9d529e4c$var$CrossIconMedium,
            label: formatMessage((0, (0, parcelRequire("ce9SK")).default).dialogLabel)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bgrar")).default), {
            xcss: $7478bb7f9d529e4c$var$containerStylesCentred,
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            id: (0, $08d1cd363c5f7148$export$b8b9d90f9e5bd72b),
            packageName: (0, $08d1cd363c5f7148$export$b8b9d90f9e5bd72b),
            teamName: (0, $08d1cd363c5f7148$export$cfeee2ee86ead336),
            sendToPrivacyUnsafeSplunk: true
        }, content))));
    };
    var $7478bb7f9d529e4c$export$2e2bcd8739ae039 = $7478bb7f9d529e4c$var$CreateNewPlanWizardDrawer;
    const $7478bb7f9d529e4c$var$containerStylesCentred = (0, (0, parcelRequire("8CUq3")).xcss)({
        minHeight: '100%',
        paddingTop: 'space.300',
        paddingBottom: 'space.300'
    });
    const $7478bb7f9d529e4c$var$Center = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3id81e _c71l1w2c",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4ENQh", function(module, exports) {
    $parcel$export(module.exports, "SPA_APP_NAME", ()=>$7022219d2d87e7c6$export$3121747bb6e73d1c);
    $parcel$export(module.exports, "TTI_SLO", ()=>$7022219d2d87e7c6$export$748427380a6493b0);
    $parcel$export(module.exports, "ARJ_EARLY_PRELOAD_PREFIX", ()=>$7022219d2d87e7c6$export$1b60784a15ad91a9);
    $parcel$export(module.exports, "monitor", ()=>$7022219d2d87e7c6$export$ec5b303098bc4b7f);
    var $99gkn;
    var $aOr3t;
    var $bFU4G;
    var $21pfT;
    var $dGrdR;
    var $4dRjY;
    var $2SVPM;
    var $fdim1;
    var $6NgSc;
    const $7022219d2d87e7c6$export$3121747bb6e73d1c = 'advanced-roadmaps';
    const $7022219d2d87e7c6$export$748427380a6493b0 = 4000;
    const $7022219d2d87e7c6$export$2a97570d48bcd64d = 1000;
    const $7022219d2d87e7c6$export$1b60784a15ad91a9 = 'jira.fe-spa.advanced-roadmaps.early-preload';
    const $7022219d2d87e7c6$var$INTERACTION_PREFIX = $7022219d2d87e7c6$export$3121747bb6e73d1c;
    const $7022219d2d87e7c6$var$ARJ_EARLY_PRELOAD = 'arj-early-preload';
    const $7022219d2d87e7c6$var$PRODUCT_PREFIX = 'jira.fe-spa.advanced-roadmaps.product';
    const $7022219d2d87e7c6$var$taskKeyToInteractionKey = (taskKey)=>`${$7022219d2d87e7c6$var$INTERACTION_PREFIX}.${taskKey.toLowerCase()}`;
    const $7022219d2d87e7c6$export$4726438eb4db5074 = '__initial_render__';
    const $7022219d2d87e7c6$var$MAX_ENTRIES_PER_MARK = 5;
    class $7022219d2d87e7c6$export$3de16b9a4e4a99f4 {
        constructor(options){
            this.featureFlags = [];
            this.profiles = new Map();
            this.timings = [];
            this.tasks = new Map();
            this.contextualAnalyticsData = {
                planId: '',
                scenarioId: ''
            };
            this.browserMetrics = (options || {}).browserMetrics || (0, (0, parcelRequire("21pfT")).browserMetrics);
            this.metrics = (options || {}).metrics || (0, (0, parcelRequire("dGrdR")).metrics);
            this.resetInitialRenderTask();
            (0, (0, parcelRequire("fdim1")).injectCallbackIntoGetBooleanFeatureFlag)((flag)=>{
                this.registerBooleanFeatureFlag(flag);
            });
        }
        initializeContextualAnalyticsData(data) {
            this.contextualAnalyticsData = {
                ...data
            };
        }
        addContextualAnalyticsData(newData) {
            this.contextualAnalyticsData = {
                ...this.contextualAnalyticsData,
                ...newData
            };
        }
        finishInitialRender(options) {
            const task = this.tasks.get($7022219d2d87e7c6$export$4726438eb4db5074);
            if (!task) return;
            this.recordEarlyPreloadTimings();
            const bm3Marks = {};
            this.timings.forEach(({ key: key, startTime: startTime, endTime: endTime })=>{
                bm3Marks[`${key}:start`] = startTime;
                bm3Marks[`${key}:end`] = endTime;
            });
            const bm3CustomTimings = this.timings.map(({ key: key })=>({
                    key: key,
                    startMark: `${key}:start`,
                    endMark: `${key}:end`
                }));
            (0, (0, parcelRequire("aOr3t")).addBM3TimingsToUFO)(bm3Marks, bm3CustomTimings);
            (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
            const { scalingFactors: scalingFactors } = options;
            const customData = this.collectCustomData({
                scalingFactors: scalingFactors
            }, task.executionTimes, task.marks);
            (0, (0, parcelRequire("99gkn")).addUFOCustomData)(customData);
            (0, (0, parcelRequire("bFU4G")).addApdexToAll)({
                key: 'plans',
                stopTime: performance.now()
            });
            this.resetInitialRenderTask();
        }
        startTask(taskKey, options, customStartTime) {
            if (this.tasks.has(taskKey)) return;
            const interaction = this.metrics.custom({
                key: $7022219d2d87e7c6$var$taskKeyToInteractionKey(taskKey),
                featureFlags: this.featureFlags,
                slo: {
                    threshold: $7022219d2d87e7c6$export$2a97570d48bcd64d
                }
            });
            customStartTime !== undefined ? interaction.start({
                startTime: customStartTime
            }) : interaction.start();
            const justOptions = options || {
                scalingFactors: {}
            };
            const executionTimes = new Map();
            const marks = new Set();
            const task = {
                interaction: interaction,
                options: justOptions,
                executionTimes: executionTimes,
                marks: marks
            };
            this.tasks.set(taskKey, task);
            this.setMark(`${taskKey}_start`);
        }
        finishTask(taskKey, options) {
            const task = this.tasks.get(taskKey);
            if (!task) return;
            const { sloSuccessThreshold: sloSuccessThreshold = $7022219d2d87e7c6$export$2a97570d48bcd64d, scalingFactors: scalingFactors } = options || {};
            if (typeof task.interaction.config !== 'undefined') task.interaction.config.slo.threshold = sloSuccessThreshold;
            if (scalingFactors) Object.assign(task.options.scalingFactors, scalingFactors);
            const customData = this.collectCustomData(task.options, task.executionTimes, task.marks);
            task.interaction.stop({
                customData: customData
            });
            this.tasks.delete(taskKey);
            this.setMark(`${taskKey}_end`);
        }
        timeTask(task, taskKey, options) {
            return (...args)=>{
                this.startTask(taskKey, options);
                const result = task(...args);
                this.finishTask(taskKey);
                return result;
            };
        }
        timeFunction(fn, fnKey) {
            return (...args)=>{
                this.startProfile(fnKey);
                const result = fn(...args);
                this.finishProfile(fnKey);
                return result;
            };
        }
        startProfile(profileKey) {
            if (this.profiles.has(profileKey)) return;
            this.profiles.set(profileKey, {
                start: performance.now()
            });
        }
        finishProfile(profileKey) {
            const profile = this.profiles.get(profileKey);
            if (!profile) return;
            this.recordProfile(profileKey, profile);
            this.profiles.delete(profileKey);
        }
        startProfileConcurrent(profileKey) {
            const profile = {
                start: performance.now()
            };
            return ()=>this.recordProfile(profileKey, profile);
        }
        registerBooleanFeatureFlag(flag) {
            this.featureFlags.push(flag);
        }
        setMark(markKey) {
            if (!performance.mark) return;
            performance.mark(markKey);
            for (const { marks: marks } of this.tasks.values())marks.add(markKey);
        }
        resetInitialRenderTask() {
            const executionTimes = new Map();
            const marks = new Set();
            const task = {
                interaction: {},
                options: {
                    scalingFactors: {}
                },
                executionTimes: executionTimes,
                marks: marks
            };
            this.tasks.set($7022219d2d87e7c6$export$4726438eb4db5074, task);
        }
        recordProfile(profileKey, profile) {
            const profileEnd = performance.now();
            const measurement = {
                start: profile.start,
                end: profileEnd
            };
            for (const { executionTimes: executionTimes } of this.tasks.values()){
                const times = executionTimes.get(profileKey);
                if (times) times.push(measurement);
                else executionTimes.set(profileKey, [
                    measurement
                ]);
            }
        }
        recordCustomProfile(profileKey, customProfile) {
            const measurement = {
                ...customProfile
            };
            for (const { executionTimes: executionTimes } of this.tasks.values()){
                const times = executionTimes.get(profileKey);
                if (times) times.push(measurement);
                else executionTimes.set(profileKey, [
                    measurement
                ]);
            }
        }
        recordEarlyPreloadTimings() {
            const resources = [
                '',
                'backlog',
                'info-metadata',
                'initial-checks-for-report',
                'plan-info-for-report'
            ];
            this.timings.push(...resources.map((resource)=>{
                const start = Math.floor((0, (0, parcelRequire("6NgSc")).extractStartTime)(`${$7022219d2d87e7c6$export$1b60784a15ad91a9}${resource ? `.${resource}` : ''}:start`));
                const end = Math.ceil((0, (0, parcelRequire("6NgSc")).extractStartTime)(`${$7022219d2d87e7c6$export$1b60784a15ad91a9}${resource ? `.${resource}` : ''}:end`));
                return {
                    key: resource ? `${$7022219d2d87e7c6$var$ARJ_EARLY_PRELOAD}/${resource}` : $7022219d2d87e7c6$var$ARJ_EARLY_PRELOAD,
                    startTime: start,
                    endTime: end
                };
            }));
        }
        recordProductTimings() {
            const resources = [
                'parse-json'
            ];
            this.timings.push(...resources.map((resource)=>{
                const start = Math.floor((0, (0, parcelRequire("6NgSc")).extractStartTime)(`${$7022219d2d87e7c6$var$PRODUCT_PREFIX}.${resource}:start`));
                const end = Math.ceil((0, (0, parcelRequire("6NgSc")).extractStartTime)(`${$7022219d2d87e7c6$var$PRODUCT_PREFIX}.${resource}:end`));
                return {
                    key: `product/${resource}`,
                    startTime: start,
                    endTime: end
                };
            }));
        }
        collectCustomData(options, executionTimes, marks) {
            const pageStart = this.pageStart();
            const report = {
                ...this.contextualAnalyticsData,
                scalingFactors: {},
                executionTimes: {},
                marks: {}
            };
            const scalingFactors = options.scalingFactors || {};
            for (const factor of Object.keys(scalingFactors))report.scalingFactors[factor] = scalingFactors[factor];
            for (const [fnKey, allTimes] of executionTimes){
                const times = allTimes.filter(({ start: start })=>start >= pageStart);
                const n = times.length;
                if (n > 0) {
                    const start = times[0].start;
                    let lastEnd = start;
                    let min = Infinity;
                    let max = -Infinity;
                    let sum = 0;
                    for (const { start: start, end: end } of times){
                        const duration = end - start;
                        sum += duration;
                        min = Math.min(min, duration);
                        max = Math.max(max, duration);
                        lastEnd = Math.max(lastEnd, end);
                    }
                    const mean = sum / n;
                    let devSum = 0;
                    for (const { start: start, end: end } of times){
                        const dev = end - start - mean;
                        devSum += dev * dev;
                    }
                    const stddev = n > 1 ? Math.sqrt(devSum / (n - 1)) : 0;
                    report.executionTimes[fnKey] = {
                        start: start - pageStart,
                        end: lastEnd - pageStart,
                        min: min,
                        max: max,
                        mean: mean,
                        stddev: stddev,
                        count: n,
                        sum: sum
                    };
                }
            }
            if (performance.getEntriesByName) for (const mark of marks){
                let i = 0;
                for (const m of performance.getEntriesByName(mark) || []){
                    if (i > $7022219d2d87e7c6$var$MAX_ENTRIES_PER_MARK) break;
                    const start = m.startTime - pageStart;
                    if (start >= 0) {
                        report.marks[`${mark}_${i}`] = start;
                        i++;
                    }
                }
            }
            return report;
        }
        pageStart() {
            return this.browserMetrics.getPageLoadMetric()?.startTime || 0;
        }
    }
    const $7022219d2d87e7c6$export$ec5b303098bc4b7f = new $7022219d2d87e7c6$export$3de16b9a4e4a99f4();
});
parcelRegister("aOr3t", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$a3e67858f0c2f8da$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("bFU4G")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
parcelRegister("fdim1", function(module, exports) {
    $parcel$export(module.exports, "injectCallbackIntoGetBooleanFeatureFlag", ()=>$944db6b8bf5461ba$export$fe8eedb8c1059343);
    $parcel$export(module.exports, "getBooleanFeatureFlag", ()=>$944db6b8bf5461ba$export$a4658325ccb88f03);
    var $co1wz;
    const $944db6b8bf5461ba$var$callbacks = [];
    const $944db6b8bf5461ba$export$fe8eedb8c1059343 = (callback)=>{
        $944db6b8bf5461ba$var$callbacks.push(callback);
    };
    const $944db6b8bf5461ba$export$d930a8564fce9bcd = (flag)=>{
        const urlParams = new URLSearchParams(window.location.search);
        const ffOverrides = urlParams.get('ffOverrides');
        if (ffOverrides === undefined || ffOverrides === null) return null;
        const item = ffOverrides.split(',').find((item)=>item.startsWith(`${flag}:`));
        return item !== undefined && item.split(':')[1] || null;
    };
    const $944db6b8bf5461ba$export$a4658325ccb88f03 = (flag, defaultValue = false, storybookDefault = true)=>{
        for (const cb of $944db6b8bf5461ba$var$callbacks)cb(flag, defaultValue, storybookDefault);
        if (window?.STORYBOOK_ENV) {
            const overrideValue = $944db6b8bf5461ba$export$d930a8564fce9bcd(flag);
            if (overrideValue !== null) return overrideValue === 'true';
            return storybookDefault;
        }
        return (0, (0, parcelRequire("co1wz")).ff)(flag, defaultValue);
    };
    const $944db6b8bf5461ba$export$757bc67afadef4a0 = (featureFlagName, defaultValue, possibleValues = [], storybookDefault)=>{
        if (window?.STORYBOOK_ENV) {
            const overrideValue = $944db6b8bf5461ba$export$d930a8564fce9bcd(featureFlagName);
            if (overrideValue !== null) return overrideValue;
            return typeof storybookDefault === 'string' ? storybookDefault : defaultValue;
        }
        return (0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)(featureFlagName, defaultValue, possibleValues);
    };
});
parcelRegister("6NgSc", function(module, exports) {
    $parcel$export(module.exports, "extractStartTime", ()=>$b554ac6908eada1d$export$97ed9769a496ce6e);
    const $b554ac6908eada1d$export$97ed9769a496ce6e = (markName)=>(performance.getEntriesByName(markName, 'mark')[0] || {
            startTime: 0
        }).startTime;
});
const $08d1cd363c5f7148$export$b8b9d90f9e5bd72b = 'jiraPortfolio3CreateNewPlanWizardDrawer';
const $08d1cd363c5f7148$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $08d1cd363c5f7148$export$f27a837467ec20e5 = 'planWizard';
const $08d1cd363c5f7148$export$6afdd25b4da87159 = 30;
const $08d1cd363c5f7148$export$9a977208af30ffae = 'create-plan-wizard.load-time';
const $08d1cd363c5f7148$export$a8e537ef0c1e2586 = 'Days';
const $08d1cd363c5f7148$export$2a59d0fbc784e5c1 = '1';
const $08d1cd363c5f7148$export$7288711b5316ff78 = 'YYYY-MM-DD';
const $08d1cd363c5f7148$export$14ae725d0cc7daa1 = 'DD/MMM/YY';
parcelRegister("gD5Z0", function(module, exports) {
    $parcel$export(module.exports, "useCreateNewPlanWizardDrawer", ()=>$13f82bb8cfc1f7f2$export$f3e7d3fc94eda89a);
    $parcel$export(module.exports, "useImportedMessagesForLocale", ()=>$13f82bb8cfc1f7f2$export$52303468eeac3ad0);
    var $5uXOq = parcelRequire("5uXOq");
    var $eTXmK;
    var $4R6GH;
    var $koVbs;
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $13f82bb8cfc1f7f2$var$CONTROLLER_NAME = 'create-new-plan-wizard-drawer';
    const $13f82bb8cfc1f7f2$var$initialState = {
        isOpen: false,
        plan: undefined
    };
    const $13f82bb8cfc1f7f2$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: $13f82bb8cfc1f7f2$var$CONTROLLER_NAME,
        initialState: $13f82bb8cfc1f7f2$var$initialState,
        actions: {
            openDrawer: (plan)=>{
                if ((0, (0, parcelRequire("4R6GH")).fg)('add_analytic_to_create_plan')) (0, (0, parcelRequire("eTXmK")).default)('arj-create-plan-wizard-drawer');
                return ({ setState: setState })=>setState({
                        isOpen: true,
                        plan: plan
                    });
            },
            closeDrawer: ()=>({ setState: setState })=>setState({
                        isOpen: false,
                        plan: undefined
                    })
        }
    });
    const $13f82bb8cfc1f7f2$export$f3e7d3fc94eda89a = (0, (0, parcelRequire("3sQ5x")).createHook)($13f82bb8cfc1f7f2$var$Store);
    const $13f82bb8cfc1f7f2$export$9ec7b5762fb72de2 = (0, (0, parcelRequire("gg7kZ")).createContainer)($13f82bb8cfc1f7f2$var$Store, {
        onInit: ()=>({ setState: setState }, { isOpen: isOpen, plan: plan })=>{
                setState({
                    isOpen: isOpen,
                    plan: plan
                });
            }
    });
    const $13f82bb8cfc1f7f2$var$EXCLUDED_I18N_FILES = [
        'index',
        'languages',
        'en'
    ];
    const $13f82bb8cfc1f7f2$var$FALLBACK_INTL_MESSAGES = Object.freeze({});
    const $13f82bb8cfc1f7f2$export$19442c17ab279a67 = async (rawlocale = 'en')=>{
        const locale = rawlocale.split('-')[0];
        if (!locale || $13f82bb8cfc1f7f2$var$EXCLUDED_I18N_FILES.includes(locale)) return {
            default: $13f82bb8cfc1f7f2$var$FALLBACK_INTL_MESSAGES
        };
        try {
            {
                const i18nModule = await (parcelRequire("jUfDk"));
                const result = i18nModule[locale]();
                return result;
            }
            const result = await import(`@atlassian/jira-portfolio-plan-wizard/dist/cjs/i18n/${locale}`);
            return result;
        } catch  {
            return {
                default: $13f82bb8cfc1f7f2$var$FALLBACK_INTL_MESSAGES
            };
        }
    };
    const $13f82bb8cfc1f7f2$export$52303468eeac3ad0 = ()=>{
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        const [state, setState] = (0, $5uXOq.useState)({
            locale: locale,
            loading: true,
            intlMessages: undefined
        });
        (0, $5uXOq.useEffect)(()=>{
            let mounted = true;
            const load = async ()=>{
                setState((state)=>({
                        ...state,
                        loading: true
                    }));
                const { default: intlMessages } = await $13f82bb8cfc1f7f2$export$19442c17ab279a67(locale);
                if (!mounted) return;
                setState((state)=>({
                        ...state,
                        loading: false,
                        intlMessages: intlMessages
                    }));
            };
            load();
            return ()=>{
                mounted = false;
            };
        }, [
            locale
        ]);
        return state;
    };
});
parcelRegister("jUfDk", function(module, exports) {
    module.exports = {};
});
parcelRegister("ce9SK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f7080c2d79bc731c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f7080c2d79bc731c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        close: {
            "id": "portfolio-3-create-new-plan-wizard-drawer.ui.close",
            "defaultMessage": "Close"
        },
        dialogLabel: {
            "id": "portfolio-3-create-new-plan-wizard-drawer.ui.dialogLabel",
            "defaultMessage": "Create a plan"
        }
    });
});
parcelRegister("bxHf8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("3bJtY")
    ]).then(()=>parcelRequire('6pgGe'));
});
parcelRegister("eQ4Jx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$182af5a33f7faffa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $i8Qvm;
    var $7iJwP;
    var $pa9q9;
    var $lfTZh;
    var $1XJ20;
    var $cYlk7;
    var $doZTA;
    var $lVJAU;
    var $e0K2C;
    var $4LAva;
    var $lqgYo;
    const $182af5a33f7faffa$var$CreateSamplePlan = ()=>{
        const [{ isOpen: isOpen }, { close: close }] = (0, (0, parcelRequire("4LAva")).useCreateSamplePlan)();
        const [{ location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const initialLocation = (0, (0, parcelRequire("1XJ20")).usePrevious)(location);
        (0, $5uXOq.useEffect)(()=>{
            if (initialLocation && initialLocation !== location) close();
        }, [
            close,
            initialLocation,
            location
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "create-sample-plan",
            fallback: null
        }, isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lqgYo")).default), null)));
    };
    const $182af5a33f7faffa$var$CreateSamplePlanContainer = ({ isOpen: isOpen = false })=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const { data: { user: currentUser } } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        const redirectToPlan = (0, $5uXOq.useCallback)((planId)=>{
            push(`/jira/plans/${planId}`);
        }, [
            push
        ]);
        if (!currentUser.accountId) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4LAva")).CreateSamplePlanProvider), {
            isGlobal: true,
            isOpen: isOpen,
            showFlag: showFlag,
            redirectToPlan: redirectToPlan,
            leadAccountId: currentUser.accountId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            id: (0, (0, parcelRequire("e0K2C")).ERROR_REPORTING_PACKAGE),
            packageName: (0, (0, parcelRequire("e0K2C")).ERROR_REPORTING_PACKAGE),
            teamName: (0, (0, parcelRequire("e0K2C")).ERROR_REPORTING_TEAM),
            sendToPrivacyUnsafeSplunk: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($182af5a33f7faffa$var$CreateSamplePlan, null)));
    };
    var $182af5a33f7faffa$export$2e2bcd8739ae039 = $182af5a33f7faffa$var$CreateSamplePlanContainer;
});
parcelRegister("e0K2C", function(module, exports) {
    $parcel$export(module.exports, "ERROR_REPORTING_PACKAGE", ()=>$3613c4dc2e67ca96$export$f27a837467ec20e5);
    $parcel$export(module.exports, "ERROR_REPORTING_TEAM", ()=>$3613c4dc2e67ca96$export$cfeee2ee86ead336);
    $parcel$export(module.exports, "MAX_PLAN_NAME_LENGTH", ()=>$3613c4dc2e67ca96$export$62da4a2465b3b309);
    $parcel$export(module.exports, "CREATE_SUCCESS_FLAG_ID", ()=>$3613c4dc2e67ca96$export$d526356745046017);
    $parcel$export(module.exports, "CREATE_ERROR_FLAG_ID", ()=>$3613c4dc2e67ca96$export$abd17266df221a92);
    $parcel$export(module.exports, "UNKNOWN_EXCEPTION", ()=>$3613c4dc2e67ca96$export$cfba07bc71f884c1);
    $parcel$export(module.exports, "USER_SETTINGS_ERRORS", ()=>$3613c4dc2e67ca96$export$4a3e779cd3c10125);
    $parcel$export(module.exports, "ERROR_CODE_TITLE_MAPPING", ()=>$3613c4dc2e67ca96$export$91ec80863c2c2030);
    $parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING", ()=>$3613c4dc2e67ca96$export$c43e20911e13ca0);
    $parcel$export(module.exports, "ERROR_LINK_MAPPING", ()=>$3613c4dc2e67ca96$export$2c5a783ab3215ce1);
    var $2L5wO;
    const $3613c4dc2e67ca96$export$f27a837467ec20e5 = 'jiraPortfolio3CreateSamplePlan';
    const $3613c4dc2e67ca96$export$cfeee2ee86ead336 = 'advanced-roadmaps';
    const $3613c4dc2e67ca96$export$2c16bd1d8b68b11f = 'https://support.atlassian.com/contact';
    const $3613c4dc2e67ca96$export$af6d68522cb370b8 = 'https://support.atlassian.com/jira-software-cloud/docs/view-a-sample-advanced-roadmaps-plan/';
    const $3613c4dc2e67ca96$export$62da4a2465b3b309 = 255;
    const $3613c4dc2e67ca96$export$d526356745046017 = 'samplePlanCreatedSuccessfully';
    const $3613c4dc2e67ca96$export$abd17266df221a92 = 'samplePlanError';
    const $3613c4dc2e67ca96$export$e6515d2009b1dba7 = 'REQUIRED_FIELDS_CONFIGURED_ON_ISSUE';
    const $3613c4dc2e67ca96$export$80ecb4d853a9f09b = 'EMPTY_ISSUE_LINKS';
    const $3613c4dc2e67ca96$export$f31def2c4daaefc0 = 'NO_BROWSE_PROJECTS_PERMISSION';
    const $3613c4dc2e67ca96$export$530d46555d7ccbb = 'NO_CREATE_ISSUES_PERMISSION';
    const $3613c4dc2e67ca96$export$8c852ea52ca9ebe = 'NO_TRANSITION_ISSUES_PERMISSION';
    const $3613c4dc2e67ca96$export$855d898b7009ad1c = 'NO_EDIT_ISSUES_PERMISSION';
    const $3613c4dc2e67ca96$export$5c8703f47a29c462 = 'WATCHING_DISABLED';
    const $3613c4dc2e67ca96$export$cfba07bc71f884c1 = 'UNKNOWN_EXCEPTION';
    const $3613c4dc2e67ca96$export$4a3e779cd3c10125 = [
        $3613c4dc2e67ca96$export$e6515d2009b1dba7,
        $3613c4dc2e67ca96$export$80ecb4d853a9f09b,
        $3613c4dc2e67ca96$export$f31def2c4daaefc0,
        $3613c4dc2e67ca96$export$530d46555d7ccbb,
        $3613c4dc2e67ca96$export$8c852ea52ca9ebe,
        $3613c4dc2e67ca96$export$855d898b7009ad1c,
        $3613c4dc2e67ca96$export$5c8703f47a29c462
    ];
    const $3613c4dc2e67ca96$export$91ec80863c2c2030 = {
        [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: (0, (0, parcelRequire("2L5wO")).default).configurationErrorTitle,
        [$3613c4dc2e67ca96$export$80ecb4d853a9f09b]: (0, (0, parcelRequire("2L5wO")).default).configurationErrorTitle,
        [$3613c4dc2e67ca96$export$f31def2c4daaefc0]: (0, (0, parcelRequire("2L5wO")).default).permissionErrorTitle,
        [$3613c4dc2e67ca96$export$530d46555d7ccbb]: (0, (0, parcelRequire("2L5wO")).default).permissionErrorTitle,
        [$3613c4dc2e67ca96$export$8c852ea52ca9ebe]: (0, (0, parcelRequire("2L5wO")).default).permissionErrorTitle,
        [$3613c4dc2e67ca96$export$855d898b7009ad1c]: (0, (0, parcelRequire("2L5wO")).default).permissionErrorTitle,
        [$3613c4dc2e67ca96$export$5c8703f47a29c462]: (0, (0, parcelRequire("2L5wO")).default).configurationErrorTitle,
        [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: (0, (0, parcelRequire("2L5wO")).default).tryAgainErrorTitle
    };
    const $3613c4dc2e67ca96$export$c43e20911e13ca0 = {
        [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: (0, (0, parcelRequire("2L5wO")).default).requiredFieldsConfiguredOnIssueError,
        [$3613c4dc2e67ca96$export$80ecb4d853a9f09b]: (0, (0, parcelRequire("2L5wO")).default).emptyIssueLinksError,
        [$3613c4dc2e67ca96$export$f31def2c4daaefc0]: (0, (0, parcelRequire("2L5wO")).default).noBrowseProjectsPermissionError,
        [$3613c4dc2e67ca96$export$530d46555d7ccbb]: (0, (0, parcelRequire("2L5wO")).default).noCreateIssuesPermissionError,
        [$3613c4dc2e67ca96$export$8c852ea52ca9ebe]: (0, (0, parcelRequire("2L5wO")).default).noTransitionIssuesPermissionError,
        [$3613c4dc2e67ca96$export$855d898b7009ad1c]: (0, (0, parcelRequire("2L5wO")).default).noEditIssuesPermissionError,
        [$3613c4dc2e67ca96$export$5c8703f47a29c462]: (0, (0, parcelRequire("2L5wO")).default).watchingDisabledError,
        [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: (0, (0, parcelRequire("2L5wO")).default).unknownExceptionError
    };
    const $3613c4dc2e67ca96$export$2c5a783ab3215ce1 = {
        [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: {
            text: (0, (0, parcelRequire("2L5wO")).default).learnMore,
            href: $3613c4dc2e67ca96$export$af6d68522cb370b8
        },
        [$3613c4dc2e67ca96$export$80ecb4d853a9f09b]: {
            text: (0, (0, parcelRequire("2L5wO")).default).learnMore,
            href: $3613c4dc2e67ca96$export$af6d68522cb370b8
        },
        [$3613c4dc2e67ca96$export$f31def2c4daaefc0]: {
            text: (0, (0, parcelRequire("2L5wO")).default).learnMore,
            href: $3613c4dc2e67ca96$export$af6d68522cb370b8
        },
        [$3613c4dc2e67ca96$export$530d46555d7ccbb]: {
            text: (0, (0, parcelRequire("2L5wO")).default).learnMore,
            href: $3613c4dc2e67ca96$export$af6d68522cb370b8
        },
        [$3613c4dc2e67ca96$export$8c852ea52ca9ebe]: {
            text: (0, (0, parcelRequire("2L5wO")).default).learnMore,
            href: $3613c4dc2e67ca96$export$af6d68522cb370b8
        },
        [$3613c4dc2e67ca96$export$855d898b7009ad1c]: {
            text: (0, (0, parcelRequire("2L5wO")).default).learnMore,
            href: $3613c4dc2e67ca96$export$af6d68522cb370b8
        },
        [$3613c4dc2e67ca96$export$5c8703f47a29c462]: {
            text: (0, (0, parcelRequire("2L5wO")).default).learnMore,
            href: $3613c4dc2e67ca96$export$af6d68522cb370b8
        },
        [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: {
            text: (0, (0, parcelRequire("2L5wO")).default).contactSupport,
            href: $3613c4dc2e67ca96$export$2c16bd1d8b68b11f
        }
    };
});
parcelRegister("2L5wO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4969e0d482b1a0a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e4969e0d482b1a0a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        configurationErrorTitle: {
            "id": "portfolio-3-create-sample-plan.common.configuration-error-title",
            "defaultMessage": "Your demo plan couldn't be created because of a configuration error"
        },
        permissionErrorTitle: {
            "id": "portfolio-3-create-sample-plan.common.permission-error-title",
            "defaultMessage": "Your demo plan couldn't be created because you\u2019re missing a required permission"
        },
        tryAgainErrorTitle: {
            "id": "portfolio-3-create-sample-plan.common.try-again-error-title",
            "defaultMessage": "Try to create your demo plan again"
        },
        requiredFieldsConfiguredOnIssueError: {
            "id": "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error",
            "defaultMessage": "Your issues have required fields which blocked your demo plan from being created. {readMoreLink}"
        },
        emptyIssueLinksError: {
            "id": "portfolio-3-create-sample-plan.common.empty-issue-links-error",
            "defaultMessage": "Your site doesn't have issue links configured, which are required to create a demo plan. {readMoreLink}"
        },
        noBrowseProjectsPermissionError: {
            "id": "portfolio-3-create-sample-plan.common.no-browse-projects-permission-error",
            "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Browse Projects</permission-type> permission. {readMoreLink}"
        },
        noCreateIssuesPermissionError: {
            "id": "portfolio-3-create-sample-plan.common.no-create-issues-permission-error",
            "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Create Issues</permission-type> permission. {readMoreLink}"
        },
        noTransitionIssuesPermissionError: {
            "id": "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error",
            "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Transition Issues</permission-type> permission. {readMoreLink}"
        },
        noEditIssuesPermissionError: {
            "id": "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error",
            "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Edit Issues</permission-type> permission. {readMoreLink}"
        },
        watchingDisabledError: {
            "id": "portfolio-3-create-sample-plan.common.watching-disabled-error",
            "defaultMessage": "Your demo plan couldn't be created because you have issue watching disabled. {readMoreLink}"
        },
        unknownExceptionError: {
            "id": "portfolio-3-create-sample-plan.common.unknown-exception-error",
            "defaultMessage": "Your demo plan couldn't be created, but we\u2019re not sure why. If the problem persists, contact Atlassian support. {readMoreLink}"
        },
        learnMore: {
            "id": "portfolio-3-create-sample-plan.common.learn-more",
            "defaultMessage": "Learn more"
        },
        contactSupport: {
            "id": "portfolio-3-create-sample-plan.common.contact-support",
            "defaultMessage": "Contact Atlassian support"
        }
    });
});
parcelRegister("4LAva", function(module, exports) {
    $parcel$export(module.exports, "useCreateSamplePlan", ()=>$8f6b3552bc4c872c$export$53d6fde96f096b86);
    $parcel$export(module.exports, "CreateSamplePlanProvider", ()=>$8f6b3552bc4c872c$export$88b99aa46c223622);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $e0K2C;
    var $hK1fQ;
    const $8f6b3552bc4c872c$var$CONTROLLER_NAME = 'create-sample-plan';
    const $8f6b3552bc4c872c$var$initialState = {
        isOpen: false,
        planId: null,
        taskId: null,
        progressPercentage: null,
        hasBeenInitialised: false
    };
    const $8f6b3552bc4c872c$var$actions = {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                const nextState = (({ hasBeenInitialised: hasBeenInitialised, ...rest })=>rest)($8f6b3552bc4c872c$var$initialState);
                setState(nextState);
            },
        setPlanId: (planId)=>({ setState: setState })=>{
                setState({
                    planId: planId
                });
            },
        setTaskId: (taskId)=>({ setState: setState })=>{
                setState({
                    taskId: taskId
                });
            },
        setProgressPercentage: (progressPercentage)=>({ setState: setState })=>{
                setState({
                    progressPercentage: progressPercentage
                });
            },
        submitSamplePlan: ({ planName: planName, flags: { success: SuccessFlag, error: ErrorFlag } })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { showFlag: showFlag, redirectToPlan: redirectToPlan, leadAccountId: leadAccountId })=>{
                try {
                    const taskId = await (0, (0, parcelRequire("hK1fQ")).createSamplePlanAsync)({
                        body: JSON.stringify({
                            title: planName,
                            leadAccountId: leadAccountId
                        })
                    });
                    setState({
                        taskId: taskId
                    });
                    const response = await (0, (0, parcelRequire("hK1fQ")).pollCreateSamplePlan)(taskId, (progressPercentage)=>{
                        const { taskId: latestTaskId } = getState();
                        if (taskId !== latestTaskId) return;
                        setState({
                            progressPercentage: progressPercentage
                        });
                    });
                    const { plan: plan } = response.samplePlan;
                    const currentState = getState();
                    if (currentState.isOpen && taskId === currentState.taskId) {
                        redirectToPlan(plan.id);
                        dispatch($8f6b3552bc4c872c$var$actions.close());
                    } else {
                        const flagId = (0, (0, parcelRequire("e0K2C")).CREATE_SUCCESS_FLAG_ID) + plan.id;
                        showFlag({
                            id: flagId,
                            render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement(SuccessFlag, {
                                    id: flagId,
                                    planName: plan.name,
                                    planId: plan.id
                                })
                        });
                    }
                } catch (err) {
                    if (!(0, (0, parcelRequire("e0K2C")).USER_SETTINGS_ERRORS).includes(err.message)) (0, (0, parcelRequire("jcw0u")).default)({
                        error: err,
                        meta: {
                            id: `${(0, (0, parcelRequire("e0K2C")).ERROR_REPORTING_PACKAGE)}SubmitFailed`,
                            packageName: (0, (0, parcelRequire("e0K2C")).ERROR_REPORTING_PACKAGE),
                            teamName: (0, (0, parcelRequire("e0K2C")).ERROR_REPORTING_TEAM)
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    const props = {
                        id: (0, (0, parcelRequire("e0K2C")).CREATE_ERROR_FLAG_ID),
                        errorCode: err.message
                    };
                    showFlag({
                        id: (0, (0, parcelRequire("e0K2C")).CREATE_ERROR_FLAG_ID),
                        render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement(ErrorFlag, props)
                    });
                    dispatch($8f6b3552bc4c872c$var$actions.close());
                }
            }
    };
    const $8f6b3552bc4c872c$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: $8f6b3552bc4c872c$var$CONTROLLER_NAME,
        initialState: $8f6b3552bc4c872c$var$initialState,
        actions: $8f6b3552bc4c872c$var$actions
    });
    const $8f6b3552bc4c872c$export$53d6fde96f096b86 = (0, (0, parcelRequire("3sQ5x")).createHook)($8f6b3552bc4c872c$var$Store);
    const $8f6b3552bc4c872c$export$88b99aa46c223622 = (0, (0, parcelRequire("gg7kZ")).createContainer)($8f6b3552bc4c872c$var$Store, {
        onInit: ()=>({ setState: setState }, { isOpen: isOpen = false })=>{
                setState({
                    isOpen: isOpen,
                    hasBeenInitialised: true
                });
            }
    });
});
parcelRegister("hK1fQ", function(module, exports) {
    $parcel$export(module.exports, "createSamplePlanAsync", ()=>$4a753946a320d2b7$export$fed9130b90cf6213);
    $parcel$export(module.exports, "pollCreateSamplePlan", ()=>$4a753946a320d2b7$export$5d240a69af545c0d);
    var $jcw0u;
    var $fnyT4;
    var $jJZqs;
    var $eusud;
    var $e0K2C;
    const $4a753946a320d2b7$var$throwIfNotOk = async (response)=>{
        if (response.ok) return response;
        if (response.status === 500) throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, (0, (0, parcelRequire("e0K2C")).UNKNOWN_EXCEPTION), response.headers.get((0, (0, parcelRequire("fnyT4")).TRACE_ID_HEADER)) ?? undefined, response);
    };
    const $4a753946a320d2b7$var$throwIfFailed = (result)=>{
        if (result.samplePlan && !result.samplePlan.success) throw new Error(result.samplePlan.error);
    };
    const $4a753946a320d2b7$var$delay = (ms = 3000)=>new Promise((res)=>setTimeout(res, ms));
    const $4a753946a320d2b7$export$fed9130b90cf6213 = async (data)=>{
        const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/jpo/1.0/plans/sampleplan/async', data);
        const { taskId: taskId } = response;
        if (!taskId) throw new Error('Invalid response from createSamplePlan');
        return taskId;
    };
    const $4a753946a320d2b7$export$5d240a69af545c0d = async (taskId, onUpdate)=>{
        const url = `/rest/jpo/1.0/plans/sampleplan/async/${taskId}`;
        try {
            const response = await fetch(url);
            await $4a753946a320d2b7$var$throwIfNotOk(response);
            const raw = await response.json();
            $4a753946a320d2b7$var$throwIfFailed(raw);
            onUpdate(raw.progressPercent);
            if (raw.done) return raw;
            await $4a753946a320d2b7$var$delay();
            return $4a753946a320d2b7$export$5d240a69af545c0d(taskId, onUpdate);
        } catch (error) {
            if (!(0, (0, parcelRequire("e0K2C")).USER_SETTINGS_ERRORS).includes(error.message)) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: `${(0, (0, parcelRequire("e0K2C")).ERROR_REPORTING_PACKAGE)}PollingFailed`,
                    packageName: (0, (0, parcelRequire("e0K2C")).ERROR_REPORTING_PACKAGE),
                    teamName: (0, (0, parcelRequire("e0K2C")).ERROR_REPORTING_TEAM)
                },
                attributes: {
                    message: 'Polling create sample plan failed'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
parcelRegister("lqgYo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$708c534f5cd6b2f8$export$2e2bcd8739ae039);
    var $kxZPA;
    const $708c534f5cd6b2f8$var$CreateSamplePlanContent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("cb3D6")).then((module)=>module.default), {
        moduleId: "./src/packages/portfolio-3/create-sample-plan/src/ui/content/index.tsx"
    });
    var $708c534f5cd6b2f8$export$2e2bcd8739ae039 = $708c534f5cd6b2f8$var$CreateSamplePlanContent;
});
parcelRegister("cb3D6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("bg9Ex")
    ]).then(()=>parcelRequire('4Ozjr'));
});
parcelRegister("fd1WD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe1f91e73ae780e6$export$2e2bcd8739ae039);
    var $iQv12;
    var $9sGI6;
    var $4R6GH;
    var $bKCrm;
    var $7xJTg;
    var $dKIHf;
    var $98fXa;
    const $fe1f91e73ae780e6$var$conditionallyNarrowType = (value, condition)=>condition;
    const $fe1f91e73ae780e6$var$getProjectCreateComponent = ()=>{
        return $fe1f91e73ae780e6$var$conditionallyNarrowType((0, (0, parcelRequire("dKIHf")).default), (0, (0, parcelRequire("4R6GH")).fg)('hix-3234-project-create-retooling-enabled')) ? (0, (0, parcelRequire("7xJTg")).default) : (0, (0, parcelRequire("dKIHf")).default);
    };
    const $fe1f91e73ae780e6$var$ProjectCreate = $fe1f91e73ae780e6$var$getProjectCreateComponent();
    var $fe1f91e73ae780e6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("iQv12")).default)({
        onClose: ({ screen: screen, canCreateClassicProject: canCreateClassicProject, canCreateNextGenProject: canCreateNextGenProject, isAdmin: isAdmin, projectComparisonScreen: projectComparisonScreen })=>({
                name: 'projectCreate',
                screen: screen,
                canCreateClassic: canCreateClassicProject,
                canCreateNextGen: canCreateNextGenProject,
                isAdmin: isAdmin,
                projectComparisonScreen: projectComparisonScreen
            })
    })((0, (0, parcelRequire("9sGI6")).default)((0, (0, parcelRequire("98fXa")).default), {
        Consumer: (0, (0, parcelRequire("bKCrm")).ProjectCreateDrawerConsumer),
        ProjectCreate: $fe1f91e73ae780e6$var$ProjectCreate
    }));
});
parcelRegister("iQv12", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$945500a9598c3ac2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gvRPW;
    const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
        const providedKeys = Object.keys(ConnectedProps).sort();
        const cachedMappedProps = {};
        const cachedConnectedProps = {};
        const getStateFromMappedProps = (mapped)=>{
            providedKeys.forEach((key, index)=>{
                const prop = mapped[index];
                if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
                cachedMappedProps[key] = prop;
                cachedConnectedProps[key] = (...attrs)=>{
                    const analyticsEvent = attrs[attrs.length - 1].clone();
                    const connectedProp = ConnectedProps[key];
                    if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                        name: connectedProp,
                        analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
                    }).fire();
                    else if (typeof connectedProp === 'function') {
                        const update = connectedProp(...attrs);
                        analyticsEvent.update({
                            ...update,
                            analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
                        }).fire();
                    }
                    if (typeof prop === 'function') prop(...attrs);
                };
            });
            return cachedConnectedProps;
        };
        return (WrappedComponent)=>class WithAnalytics extends (0, $5uXOq.Component) {
                static{
                    this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
                }
                render() {
                    const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                        ...this.props,
                        ...newMappedProps
                    });
                }
            };
    };
    var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;
});
parcelRegister("7xJTg", function(module, exports) {
    $parcel$export(module.exports, "loadProjectCreateBundle", ()=>$26901125e03391b8$export$cb6ba161267f8f0c);
    $parcel$export(module.exports, "AsyncProjectCreate", ()=>$26901125e03391b8$export$b283b23d37290b6a);
    $parcel$export(module.exports, "default", ()=>$26901125e03391b8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eZJjh;
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $26901125e03391b8$export$cb6ba161267f8f0c = ()=>(parcelRequire("gIsbD"));
    const $26901125e03391b8$var$LazyComponent = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("gIsbD")), {
        moduleId: "./src/packages/project-create/main/src/index.tsx"
    });
    const $26901125e03391b8$export$b283b23d37290b6a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "bundle-async-project-create",
            fallback: "flag",
            packageName: "jira-project-create-main"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "project-create",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($26901125e03391b8$var$Center, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: "large"
            }))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($26901125e03391b8$var$LazyComponent, props)));
    var $26901125e03391b8$export$2e2bcd8739ae039 = $26901125e03391b8$export$b283b23d37290b6a;
    const $26901125e03391b8$var$Center = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1kxc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("gIsbD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("561Jq"),
        $6fhBS("1QYl5"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("ktBRC")
    ]).then(()=>parcelRequire('8GeEd'));
});
parcelRegister("dKIHf", function(module, exports) {
    $parcel$export(module.exports, "loadProjectCreateBundle", ()=>$e900f6ee1175436c$export$cb6ba161267f8f0c);
    $parcel$export(module.exports, "AsyncProjectCreate", ()=>$e900f6ee1175436c$export$b283b23d37290b6a);
    $parcel$export(module.exports, "default", ()=>$e900f6ee1175436c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eZJjh;
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $e900f6ee1175436c$export$cb6ba161267f8f0c = ()=>(parcelRequire("idnDM"));
    const $e900f6ee1175436c$var$LazyComponent = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("idnDM")), {
        moduleId: "./src/packages/project-create-old/src/index.tsx"
    });
    const $e900f6ee1175436c$export$b283b23d37290b6a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "bundle-async-project-create",
            fallback: "flag",
            packageName: "jira-project-create",
            teamName: "helix"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "project-create",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($e900f6ee1175436c$var$Center, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: "large"
            }))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e900f6ee1175436c$var$LazyComponent, props)));
    var $e900f6ee1175436c$export$2e2bcd8739ae039 = $e900f6ee1175436c$export$b283b23d37290b6a;
    const $e900f6ee1175436c$var$Center = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1kxc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("idnDM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("561Jq"),
        $6fhBS("1QYl5"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("gqyMH")
    ]).then(()=>parcelRequire('22cWF'));
});
parcelRegister("98fXa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb5e0519cc67d1f1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jzjy1;
    var $x9xyg;
    var $fz3fB;
    var $kYpAp;
    var $4TsDt;
    const $cb5e0519cc67d1f1$var$PreloadAsyncProjectCreateDrawer = ()=>{
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("4TsDt")).preloadAsyncProjectCreateDrawer)();
        }, []);
        return null;
    };
    const $cb5e0519cc67d1f1$var$View = class ProjectCreateDrawer extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isAdmin: false,
                isOnboarding: false
            };
        }
        render() {
            const { Consumer: Consumer } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, Consumer ? (0, ($parcel$interopDefault($5uXOq))).createElement(Consumer, null, ({ data: data, methods: methods })=>data.shouldRenderDrawer ? this.renderContent(data, methods) : null) : null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fz3fB")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($cb5e0519cc67d1f1$var$PreloadAsyncProjectCreateDrawer, null)));
        }
        constructor(...args){
            super(...args), this.onScreenChange = (screen)=>{
                this.screen = screen;
            }, this.onPermissionsFetched = ({ canCreateClassicProject: canCreateClassicProject, canCreateNextGenProject: canCreateNextGenProject })=>{
                this.permissions = {
                    canCreateClassicProject: canCreateClassicProject,
                    canCreateNextGenProject: canCreateNextGenProject
                };
            }, this.screen = '', this.permissions = {
                canCreateClassicProject: null,
                canCreateNextGenProject: null
            }, this.renderContent = (data, methods)=>{
                const { isAdmin: isAdmin, baseUrl: baseUrl, locale: locale, isOnboarding: isOnboarding, appEditions: appEditions, ProjectCreate: ProjectCreate } = this.props;
                if (data.isOpen) (0, (0, parcelRequire("x9xyg")).setMark)((0, (0, parcelRequire("kYpAp")).PROJECT_CREATE_LOAD_START_MARK_KEY));
                const onClose = (e, analyticsEvent)=>{
                    methods.close();
                    this.props.onClose && this.props.onClose({
                        screen: this.screen,
                        isAdmin: this.props.isAdmin,
                        canCreateClassicProject: this.permissions.canCreateClassicProject,
                        canCreateNextGenProject: this.permissions.canCreateNextGenProject
                    }, analyticsEvent);
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4TsDt")).AsyncProjectCreateDrawerContent), {
                    onClose: onClose,
                    baseUrl: baseUrl,
                    isAdmin: isAdmin,
                    isOnboarding: isOnboarding,
                    data: data,
                    methods: methods,
                    locale: locale,
                    appEditions: appEditions,
                    onScreenChange: this.onScreenChange,
                    onPermissionsFetched: this.onPermissionsFetched,
                    ProjectCreate: ProjectCreate
                });
            };
        }
    };
    var $cb5e0519cc67d1f1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("jzjy1")).AnalyticsSource)('ProjectCreate', (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5))($cb5e0519cc67d1f1$var$View);
});
parcelRegister("fz3fB", function(module, exports) {
    $parcel$export(module.exports, "NonCritical", ()=>$a1827329dcbac5c8$export$20fd89b1bf707b1a);
    $parcel$export(module.exports, "default", ()=>$a1827329dcbac5c8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $6yXtV;
    const $a1827329dcbac5c8$export$83d969795398ec56 = ({ children: children, timerThreshold: timerThreshold })=>{
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const [isFirstRun, setFirstRun] = (0, $5uXOq.useState)(true);
        const [hasThresholdTimerExpired, setHasThresholdTimerExpired] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (timerThreshold != null) setTimeout(()=>{
                setHasThresholdTimerExpired(true);
            }, timerThreshold);
        }, [
            timerThreshold
        ]);
        if (!isFirstRun || isReady || hasThresholdTimerExpired) {
            isFirstRun && setFirstRun(false);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        }
        return null;
    };
    const $a1827329dcbac5c8$export$5b2f4b62d18632 = ({ id: id = 'non-critical-with-timer', teamName: teamName, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: id,
            teamName: teamName,
            packageName: "jiraPlatformNonCritical",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a1827329dcbac5c8$export$83d969795398ec56, props));
    const $a1827329dcbac5c8$var$NonCriticalComponent = (props)=>{
        const [{ isReady: isReady }] = (0, (0, parcelRequire("6yXtV")).useSpaStatePageReady)();
        const [isFirstRun, setFirstRun] = (0, $5uXOq.useState)(true);
        if (!isFirstRun || isReady) {
            isFirstRun && setFirstRun(false);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        }
        return null;
    };
    const $a1827329dcbac5c8$export$20fd89b1bf707b1a = ({ id: id = 'non-critical', teamName: teamName, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: id,
            teamName: teamName,
            packageName: "jiraPlatformNonCritical",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a1827329dcbac5c8$var$NonCriticalComponent, props));
    var $a1827329dcbac5c8$export$2e2bcd8739ae039 = $a1827329dcbac5c8$var$NonCriticalComponent;
});
parcelRegister("kYpAp", function(module, exports) {
    $parcel$export(module.exports, "TEAM_NAME", ()=>$3779d49ccdc66101$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "PROJECT_CREATE_APP_NAME", ()=>$3779d49ccdc66101$export$8f0c4426531e762);
    $parcel$export(module.exports, "PROJECT_CREATE_LOAD_START_MARK_KEY", ()=>$3779d49ccdc66101$export$59fe870bc818978d);
    $parcel$export(module.exports, "PROJECT_CREATE_LOAD_END_MARK_KEY", ()=>$3779d49ccdc66101$export$c31bdc8313c39f72);
    $parcel$export(module.exports, "PROJECT_CREATE_READY_MARK_KEY", ()=>$3779d49ccdc66101$export$5dc4f809336ac7c3);
    $parcel$export(module.exports, "PROJECT_CREATE_JWM_ONBOARDING", ()=>$3779d49ccdc66101$export$def2f343237303e5);
    $parcel$export(module.exports, "NTH_PROJECT_CREATE", ()=>$3779d49ccdc66101$export$fde004f68299c66e);
    $parcel$export(module.exports, "defaultProps", ()=>$3779d49ccdc66101$export$9c21a3269931e1e6);
    var $8Rkzz = parcelRequire("8Rkzz");
    const $3779d49ccdc66101$export$d57b6b390e78d90f = 'helix';
    const $3779d49ccdc66101$export$8f0c4426531e762 = 'project-create';
    const $3779d49ccdc66101$export$739ce3adec75fd20 = {
        FORM: 'FORM',
        FORM_WITH_PROJECT_TYPE_DROPDOWN: 'FORM_WITH_PROJECT_TYPE_DROPDOWN',
        ERROR_PAGE: 'ERROR_PAGE',
        CONTAINER_LINKING: 'CONTAINER_LINKING',
        NEW_TEMPLATE_CHOICE: 'NEW_TEMPLATE_CHOICE'
    };
    const $3779d49ccdc66101$export$59fe870bc818978d = 'PROJECT_CREATE_LOAD_START_MARK_KEY';
    const $3779d49ccdc66101$export$c31bdc8313c39f72 = 'PROJECT_CREATE_LOAD_END_MARK_KEY';
    const $3779d49ccdc66101$export$5dc4f809336ac7c3 = 'PROJECT_CREATE_READY_MARK_KEY';
    const $3779d49ccdc66101$export$def2f343237303e5 = 'projectCreateJwmOnboarding';
    const $3779d49ccdc66101$export$fde004f68299c66e = 'nthProjectCreate';
    const $3779d49ccdc66101$export$9c21a3269931e1e6 = {
        isImportProjectOpenInitially: false,
        isTemplatePickerOpenInitially: false,
        isJswOnboarding: false,
        isOnboarding: false,
        isConnectedProjectScenario: false,
        isJiraCoreOnboarding: false,
        skipTemplateSelection: false,
        recommendedTemplate: undefined,
        defaultSelectedTemplateKey: '',
        source: '',
        selectedProjectType: null,
        onPermissionsFetched: (0, ($parcel$interopDefault($8Rkzz))),
        onDrawerClose: (0, ($parcel$interopDefault($8Rkzz))),
        onCreateStarted: (0, ($parcel$interopDefault($8Rkzz))),
        isBusinessUser: false
    };
});
parcelRegister("4TsDt", function(module, exports) {
    $parcel$export(module.exports, "preloadAsyncProjectCreateDrawer", ()=>$2c0fe078cbf19b80$export$bf40786982237798);
    $parcel$export(module.exports, "AsyncProjectCreateDrawerContent", ()=>$2c0fe078cbf19b80$export$975ae959df433581);
    var $5uXOq = parcelRequire("5uXOq");
    var $j55bS;
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $2c0fe078cbf19b80$export$bf40786982237798 = ()=>(parcelRequire("lMstD"));
    const $2c0fe078cbf19b80$var$LazyComponent = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("lMstD")), {
        moduleId: "./src/packages/navigation-apps/project-create-drawer/src/view/index.tsx"
    });
    const $2c0fe078cbf19b80$var$newComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "bundle-async-project-create-drawer",
            fallback: "flag",
            packageName: "jira-project-create-drawer",
            teamName: "helix"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-project-create-drawer",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j55bS")).default), {
                isTinted: true
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2c0fe078cbf19b80$var$LazyComponent, props)));
    const $2c0fe078cbf19b80$export$975ae959df433581 = $2c0fe078cbf19b80$var$newComponent;
});
parcelRegister("lMstD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("h3vyp").then(()=>parcelRequire('11r5h'));
});
parcelRegister("1Siv7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$984cbc7bfbbac04d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $iXVV6;
    var $5oFIy;
    var $a0UwL;
    var $34WON;
    const $984cbc7bfbbac04d$var$Dialog = ()=>{
        const [, { setShortcutsDialogVisibility: setShortcutsDialogVisibility }] = (0, (0, parcelRequire("a0UwL")).useShortcutsActions)();
        const onClose = (0, $5uXOq.useCallback)(()=>setShortcutsDialogVisibility(false), [
            setShortcutsDialogVisibility
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "dotDialog",
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("34WON")).default), {
            onClose: onClose
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            attributes: {
                name: 'dotDialog'
            }
        }));
    };
    const $984cbc7bfbbac04d$var$ShortcutsDialog = ()=>{
        const [{ isShortcutsDialogVisible: isShortcutsDialogVisible }] = (0, (0, parcelRequire("a0UwL")).useShortcuts)();
        return isShortcutsDialogVisible ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "shortcuts-dialog",
            packageName: "jira-shortcuts-dialog",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($984cbc7bfbbac04d$var$Dialog, null)) : null;
    };
    var $984cbc7bfbbac04d$export$2e2bcd8739ae039 = $984cbc7bfbbac04d$var$ShortcutsDialog;
});
parcelRegister("a0UwL", function(module, exports) {
    $parcel$export(module.exports, "useShortcuts", ()=>$991d4b7077d5c717$export$a1ca853c6e4bb6fb);
    $parcel$export(module.exports, "useShortcutsActions", ()=>$991d4b7077d5c717$export$b331ee6e87b9104c);
    var $axjlw;
    const $991d4b7077d5c717$export$a1ca853c6e4bb6fb = ()=>(0, (0, parcelRequire("axjlw")).useShortcutsStore)();
    const $991d4b7077d5c717$export$b331ee6e87b9104c = ()=>{
        const [, actions] = (0, (0, parcelRequire("axjlw")).useShortcutsActionsStore)();
        return [
            undefined,
            actions
        ];
    };
});
parcelRegister("axjlw", function(module, exports) {
    $parcel$export(module.exports, "useShortcutsStore", ()=>$fefbe59bb1ce22b9$export$a14646bfc7ba8d81);
    $parcel$export(module.exports, "useShortcutsActionsStore", ()=>$fefbe59bb1ce22b9$export$1a29bfef7fa09838);
    var $3sQ5x;
    var $iXqE5;
    var $f0R9h;
    const $fefbe59bb1ce22b9$export$d4c72bab9d6cc13a = {
        shortcuts: {
            admin: {
                key: 'admin',
                label: 'ADMIN',
                options: [],
                isLoaded: false
            }
        },
        isShortcutsDialogVisible: false,
        isShortcutsLoading: false,
        hasError: false,
        isAdminLoading: false,
        selectedItemKey: null,
        header: null,
        title: undefined
    };
    const $fefbe59bb1ce22b9$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'shortcuts',
        initialState: $fefbe59bb1ce22b9$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("f0R9h"))
    });
    const $fefbe59bb1ce22b9$export$a14646bfc7ba8d81 = (0, (0, parcelRequire("3sQ5x")).createHook)($fefbe59bb1ce22b9$export$6f57813fe9f31bf9);
    const $fefbe59bb1ce22b9$export$1a29bfef7fa09838 = (0, (0, parcelRequire("3sQ5x")).createHook)($fefbe59bb1ce22b9$export$6f57813fe9f31bf9, {
        selector: null
    });
});
parcelRegister("f0R9h", function(module, exports) {
    $parcel$export(module.exports, "registerShortcuts", ()=>$d845eb212fa1ca53$export$598ec0e6047cbdca);
    $parcel$export(module.exports, "setShortcutsDialogVisibility", ()=>$d845eb212fa1ca53$export$80ab1e79e32c3021);
    $parcel$export(module.exports, "setShortcutsLoading", ()=>$d845eb212fa1ca53$export$7ed2ac8328423043);
    $parcel$export(module.exports, "setHasError", ()=>$d845eb212fa1ca53$export$645a7c7453685186);
    $parcel$export(module.exports, "setHeader", ()=>$d845eb212fa1ca53$export$604ed74fb893f0e2);
    $parcel$export(module.exports, "fetchAdminSections", ()=>$d845eb212fa1ca53$export$aec87c8c9bde62e6);
    $parcel$export(module.exports, "setSelectedItemKey", ()=>$d845eb212fa1ca53$export$249c9d5b49cd9712);
    $parcel$export(module.exports, "dropShortcutsByKeys", ()=>$d845eb212fa1ca53$export$9cf39adf0dec984);
    var $k8IPx = parcelRequire("k8IPx");
    var $1qfyE;
    var $8mrJC;
    const $d845eb212fa1ca53$export$598ec0e6047cbdca = (shortcuts)=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const newShortcuts = shortcuts.reduce((acc, current)=>{
                acc[current.key] = current;
                return acc;
            }, {
                ...currentState.shortcuts
            });
            setState({
                ...currentState,
                shortcuts: newShortcuts,
                isShortcutsLoading: false
            });
        };
    const $d845eb212fa1ca53$export$80ab1e79e32c3021 = (isVisible)=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isShortcutsDialogVisible: isVisible
            });
        };
    const $d845eb212fa1ca53$export$7ed2ac8328423043 = (isLoading)=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isShortcutsLoading: isLoading
            });
        };
    const $d845eb212fa1ca53$export$645a7c7453685186 = (hasError)=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                hasError: hasError
            });
        };
    const $d845eb212fa1ca53$export$604ed74fb893f0e2 = (header, title)=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                header: header,
                title: title
            });
        };
    const $d845eb212fa1ca53$export$aec87c8c9bde62e6 = ()=>async ({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                isAdminLoading: true
            });
            const result = await (0, (0, parcelRequire("1qfyE")).default)();
            const shortcuts = result ? (0, (0, parcelRequire("8mrJC")).buildAdminSections)(result) : [];
            const newState = getState();
            setState({
                ...newState,
                shortcuts: {
                    ...newState.shortcuts,
                    admin: {
                        ...newState.shortcuts.admin,
                        key: 'admin',
                        options: shortcuts,
                        isLoaded: true
                    }
                },
                hasError: currentState.hasError || !result,
                isAdminLoading: false
            });
        };
    const $d845eb212fa1ca53$export$249c9d5b49cd9712 = (item)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                selectedItemKey: item
            });
        };
    const $d845eb212fa1ca53$export$9cf39adf0dec984 = (keys)=>({ getState: getState, setState: setState })=>{
            if (!keys.length) return;
            const { shortcuts: shortcuts, ...rest } = getState();
            const newShortcuts = (0, ($parcel$interopDefault($k8IPx)))(Object.keys(shortcuts), keys).reduce((acc, key)=>{
                acc[key] = shortcuts[key];
                return acc;
            }, {});
            setState({
                ...rest,
                shortcuts: newShortcuts,
                isShortcutsLoading: false
            });
        };
});
parcelRegister("k8IPx", function(module, exports) {
    var $55pzo = parcelRequire("55pzo");
    var $ekcP3 = parcelRequire("ekcP3");
    var $g7i7g = parcelRequire("g7i7g");
    var $f3SOL = parcelRequire("f3SOL");
    var $ea975459f1938a58$var$difference = $g7i7g(function(array, values) {
        return $f3SOL(array) ? $55pzo(array, $ekcP3(values, 1, $f3SOL, true)) : [];
    });
    module.exports = $ea975459f1938a58$var$difference;
});
parcelRegister("55pzo", function(module, exports) {
    var $ijRUK = parcelRequire("ijRUK");
    var $fUP98 = parcelRequire("fUP98");
    var $dA3tP = parcelRequire("dA3tP");
    var $1nIHN = parcelRequire("1nIHN");
    var $cW28x = parcelRequire("cW28x");
    var $40I25 = parcelRequire("40I25");
    var $3b41410a547f22d2$var$LARGE_ARRAY_SIZE = 200;
    function $3b41410a547f22d2$var$baseDifference(array, values, iteratee, comparator) {
        var index = -1, includes = $fUP98, isCommon = true, length = array.length, result = [], valuesLength = values.length;
        if (!length) return result;
        if (iteratee) values = $1nIHN(values, $cW28x(iteratee));
        if (comparator) {
            includes = $dA3tP;
            isCommon = false;
        } else if (values.length >= $3b41410a547f22d2$var$LARGE_ARRAY_SIZE) {
            includes = $40I25;
            isCommon = false;
            values = new $ijRUK(values);
        }
        outer: while(++index < length){
            var value = array[index], computed = iteratee == null ? value : iteratee(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
                var valuesIndex = valuesLength;
                while(valuesIndex--){
                    if (values[valuesIndex] === computed) continue outer;
                }
                result.push(value);
            } else if (!includes(values, computed, comparator)) result.push(value);
        }
        return result;
    }
    module.exports = $3b41410a547f22d2$var$baseDifference;
});
parcelRegister("1qfyE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0636f27c00094fd3$export$2e2bcd8739ae039);
    var $dJl1T;
    var $7f4tk;
    var $0636f27c00094fd3$export$2e2bcd8739ae039 = async ()=>{
        try {
            return await (0, (0, parcelRequire("7f4tk")).default)('/rest/adminquicksearch/latest/links/default');
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('shortcuts-dialog.fetch-admin-links', error.toString());
            return null;
        }
    };
});
parcelRegister("8mrJC", function(module, exports) {
    $parcel$export(module.exports, "buildAdminSections", ()=>$9289773ab8ca36d5$export$5f8c94ecd4c9eb76);
    const $9289773ab8ca36d5$export$5f8c94ecd4c9eb76 = (parent, result = [])=>{
        if (parent.sections && parent.sections.length) parent.sections.forEach((s)=>$9289773ab8ca36d5$export$5f8c94ecd4c9eb76(s, result));
        if (parent.items && parent.items.length) parent.items.forEach((i)=>result.push({
                key: i.key,
                label: i.label,
                onClick: ()=>{
                    window.location.href = i.linkUrl;
                }
            }));
        return result;
    };
});
parcelRegister("34WON", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$671ffa1cbbdd8d2e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $cgL5K;
    var $92Z2l;
    var $ctz0s;
    var $d8lE2;
    var $2f2jJ;
    var $9fuVs;
    var $koVbs;
    var $1ppIJ;
    var $dqpi2;
    var $a0UwL;
    var $hQdsQ;
    var $h3bYX;
    const $671ffa1cbbdd8d2e$var$CommandPaletteSectionMessage = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isEmbed = (0, (0, parcelRequire("h3bYX")).useIsEmbed)();
        const { open: open } = (0, (0, parcelRequire("d8lE2")).useActionsCommandPalette)();
        const [, { setShortcutsDialogVisibility: setShortcutsDialogVisibility }] = (0, (0, parcelRequire("a0UwL")).useShortcutsActions)();
        const onClick = (0, $5uXOq.useCallback)(()=>{
            setShortcutsDialogVisibility(false);
            open();
        }, [
            open,
            setShortcutsDialogVisibility
        ]);
        const strong = (0, $5uXOq.useCallback)((...chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                as: "strong"
            }, chunks), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            "data-testid": "shortcuts-dialog.ui.modal.section-message",
            appearance: isEmbed ? 'information' : 'discovery',
            title: isEmbed ? undefined : formatMessage((0, (0, parcelRequire("hQdsQ")).default).dotMenuRemovalTitle),
            actions: [
                ...!isEmbed ? [
                    (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ctz0s")).default), {
                        key: "try-now",
                        onClick: onClick
                    }, formatMessage((0, (0, parcelRequire("hQdsQ")).default).tryNowButton))
                ] : [],
                (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ctz0s")).default), {
                    key: "learn-more",
                    href: "https://community.atlassian.com/t5/Jira-Command-Palette-Beta-Group/We-re-removing-Jira-s-dot-menu-to-make-way-for-a-new-and/ba-p/2754322"
                }, formatMessage((0, (0, parcelRequire("hQdsQ")).default).learnMoreButton))
            ]
        }, formatMessage((0, (0, parcelRequire("hQdsQ")).default).dotMenuRemovalDescription, {
            strong: strong,
            isMac: (0, (0, parcelRequire("2f2jJ")).isMacOs)(),
            isEmbed: isEmbed
        }));
    };
    const $671ffa1cbbdd8d2e$var$ModalFooterContainer = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            padding: "space.200"
        }, children);
    const $671ffa1cbbdd8d2e$var$ModalFooterWrapper = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($671ffa1cbbdd8d2e$var$ModalFooterContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($671ffa1cbbdd8d2e$var$CommandPaletteSectionMessage, null));
    const $671ffa1cbbdd8d2e$var$Modal = (props)=>{
        const { onClose: onClose } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1ppIJ")).ModalDialog), {
            width: `${(0, (0, parcelRequire("dqpi2")).DIALOG_WIDTH)}px`,
            onClose: onClose
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($671ffa1cbbdd8d2e$var$ModalFooterWrapper, null)));
    };
    var $671ffa1cbbdd8d2e$export$2e2bcd8739ae039 = $671ffa1cbbdd8d2e$var$Modal;
});
parcelRegister("92Z2l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a97355a0cc6aeb06$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $l1N8i;
    var $dC5iT;
    var $f5TWP;
    var $luBm6;
    var $8CUq3;
    var $3HeRx;
    const $a97355a0cc6aeb06$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        wordBreak: 'break-word',
        borderRadius: 'border.radius'
    });
    const $a97355a0cc6aeb06$var$bleedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        marginBlock: 'space.negative.025'
    });
    const $a97355a0cc6aeb06$var$contentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text',
        font: 'font.body'
    });
    const $a97355a0cc6aeb06$var$SectionMessage = (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
        const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, (0, parcelRequire("3HeRx")).getAppearanceIconStyles)(appearance, icon);
        const actionElements = actions && actions.type === (0, ($parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
        const actionsArray = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "section",
            backgroundColor: $a97355a0cc6aeb06$var$appearanceMap[appearance],
            padding: "space.200",
            testId: testId,
            ref: ref,
            xcss: $a97355a0cc6aeb06$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.200",
            alignBlock: "stretch"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $a97355a0cc6aeb06$var$bleedStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
            size: "medium",
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            LEGACY_size: "medium",
            color: primaryColor,
            spacing: "spacious"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            testId: testId && `${testId}--content`
        }, !!title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            as: "h2",
            size: "small"
        }, title), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $a97355a0cc6aeb06$var$contentStyles
        }, children), actionsArray.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            shouldWrap: true,
            testId: testId && `${testId}--actions`,
            separator: "\xb7",
            space: "space.100",
            rowSpace: "space.0",
            role: "list"
        }, actionsArray.map((action, id)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                role: "listitem",
                key: id
            }, action))))));
    });
    const $a97355a0cc6aeb06$var$appearanceMap = {
        information: 'color.background.information',
        warning: 'color.background.warning',
        error: 'color.background.danger',
        success: 'color.background.success',
        discovery: 'color.background.discovery'
    };
    $a97355a0cc6aeb06$var$SectionMessage.displayName = 'SectionMessage';
    var $a97355a0cc6aeb06$export$2e2bcd8739ae039 = $a97355a0cc6aeb06$var$SectionMessage;
});
parcelRegister("3HeRx", function(module, exports) {
    $parcel$export(module.exports, "getAppearanceIconStyles", ()=>$d1d7dced94bb00f5$export$e9b82d2e21ac0c1f);
    var $5uXOq = parcelRequire("5uXOq");
    var $btivG;
    var $7nnPp;
    var $2hXfb;
    var $eJS47;
    var $gtreQ;
    const $d1d7dced94bb00f5$export$faa35441caff5bb6 = {
        information: {
            backgroundColor: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("2hXfb"))))),
            primaryIconColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
        },
        warning: {
            backgroundColor: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))),
            primaryIconColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
        },
        error: {
            backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))),
            primaryIconColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
        },
        success: {
            backgroundColor: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("btivG"))))),
            primaryIconColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
        },
        discovery: {
            backgroundColor: `var(--ds-background-discovery, ${(0, $829f609a65d26a98$export$363e4475840015bb)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("eJS47"))))),
            primaryIconColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$147899de772240ec)})`
        }
    };
    function $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f(appearance, icon) {
        const appearanceIconStyles = $d1d7dced94bb00f5$export$faa35441caff5bb6[appearance] || $d1d7dced94bb00f5$export$faa35441caff5bb6.information;
        const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>(0, ($parcel$interopDefault($5uXOq))).createElement(appearanceIconStyles.Icon, {
                size: size,
                primaryColor: primaryColor,
                secondaryColor: secondaryColor,
                label: appearance
            });
        const Icon = icon || AppearanceIcon;
        return {
            ...appearanceIconStyles,
            Icon: Icon
        };
    }
});
parcelRegister("btivG", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $85a0c2d39fdb2976$var$_react = $85a0c2d39fdb2976$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $85a0c2d39fdb2976$var$_success = $85a0c2d39fdb2976$var$_interopRequireDefault((parcelRequire("b0JGA")));
    function $85a0c2d39fdb2976$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $85a0c2d39fdb2976$var$CheckCircleIcon = (props)=>$85a0c2d39fdb2976$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
        }, props, {
            newIcon: $85a0c2d39fdb2976$var$_success.default
        }));
    $85a0c2d39fdb2976$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
    var $85a0c2d39fdb2976$var$_default = module.exports.default = $85a0c2d39fdb2976$var$CheckCircleIcon;
});
parcelRegister("b0JGA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8043220a46fa3485$var$_react = $8043220a46fa3485$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8043220a46fa3485$var$_UNSAFE_baseNew = $8043220a46fa3485$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $8043220a46fa3485$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8043220a46fa3485$var$SuccessIcon = (props)=>$8043220a46fa3485$var$_react.default.createElement($8043220a46fa3485$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $8043220a46fa3485$var$SuccessIcon.displayName = 'SuccessIcon';
    var $8043220a46fa3485$var$_default = module.exports.default = $8043220a46fa3485$var$SuccessIcon;
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("ctz0s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e844da07d79ea04$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    const $2e844da07d79ea04$var$SectionMessageAction = (0, $5uXOq.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
        return onClick || href ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            testId: testId,
            appearance: "link",
            spacing: "none",
            onClick: onClick,
            href: href,
            component: href ? linkComponent : undefined
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    });
    $2e844da07d79ea04$var$SectionMessageAction.displayName = 'SectionMessageAction';
    var $2e844da07d79ea04$export$2e2bcd8739ae039 = $2e844da07d79ea04$var$SectionMessageAction;
});
parcelRegister("1ppIJ", function(module, exports) {
    $parcel$export(module.exports, "ModalDialog", ()=>$8fbdebf88f199b98$export$1fa217be60c2f188);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $lu5k0;
    const $8fbdebf88f199b98$export$1fa217be60c2f188 = ({ shouldReturnFocus: shouldReturnFocus, ...rest })=>{
        const returnFocusTarget = (0, (0, parcelRequire("lu5k0")).useReturnFocusTo)();
        const { setReturnFocusTo: setReturnFocusTo } = (0, (0, parcelRequire("lu5k0")).useModalDialogActions)();
        (0, $5uXOq.useEffect)(()=>()=>{
                if (returnFocusTarget?.current) {
                    !shouldReturnFocus && returnFocusTarget.current.focus();
                    setReturnFocusTo(null);
                }
            }, [
            returnFocusTarget,
            setReturnFocusTo,
            shouldReturnFocus
        ]);
        const returnFocus = shouldReturnFocus ?? !returnFocusTarget;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            shouldReturnFocus: returnFocus,
            ...rest
        });
    };
});
parcelRegister("lu5k0", function(module, exports) {
    $parcel$export(module.exports, "useModalDialogActions", ()=>$5f429bdcb9dbbc95$export$3cf2e4b6d3541465);
    $parcel$export(module.exports, "useReturnFocusTo", ()=>$5f429bdcb9dbbc95$export$217308a4ece853b2);
    var $3sQ5x;
    var $iXqE5;
    var $49R2H;
    var $a3Qjd;
    var $kIxMH;
    const $5f429bdcb9dbbc95$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'JiraSoftwareModalDialog',
        initialState: (0, parcelRequire("49R2H")).initialState,
        actions: (0, parcelRequire("a3Qjd")).actions
    });
    const $5f429bdcb9dbbc95$export$3cf2e4b6d3541465 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($5f429bdcb9dbbc95$var$Store);
    const $5f429bdcb9dbbc95$export$217308a4ece853b2 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($5f429bdcb9dbbc95$var$Store, {
        selector: (0, (0, parcelRequire("kIxMH")).getReturnFocusTo)
    });
});
parcelRegister("49R2H", function(module, exports) {
    $parcel$export(module.exports, "initialState", ()=>$1a3a816977643252$export$d4c72bab9d6cc13a);
    const $1a3a816977643252$export$d4c72bab9d6cc13a = {
        returnFocusTo: null
    };
});
parcelRegister("a3Qjd", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$1886bc9c17d47b9b$export$e324594224ef24da);
    const $1886bc9c17d47b9b$export$b263d1e638b131c2 = (returnFocusTo)=>({ setState: setState })=>{
            setState({
                returnFocusTo: returnFocusTo
            });
        };
    const $1886bc9c17d47b9b$export$e324594224ef24da = {
        setReturnFocusTo: $1886bc9c17d47b9b$export$b263d1e638b131c2
    };
});
parcelRegister("kIxMH", function(module, exports) {
    $parcel$export(module.exports, "getReturnFocusTo", ()=>$cd4eb273a1fc9e15$export$d5f8692765ccd209);
    const $cd4eb273a1fc9e15$export$d5f8692765ccd209 = (state)=>state.returnFocusTo;
});
parcelRegister("dqpi2", function(module, exports) {
    $parcel$export(module.exports, "DIALOG_WIDTH", ()=>$002fb2db591eeac3$export$ee46b8a74d6c94d3);
    var $gwIPs;
    const $002fb2db591eeac3$export$ee46b8a74d6c94d3 = 360;
    const $002fb2db591eeac3$export$cce92f86982e3109 = (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    const $002fb2db591eeac3$export$7161360d412e14eb = $002fb2db591eeac3$export$ee46b8a74d6c94d3 - $002fb2db591eeac3$export$cce92f86982e3109;
    const $002fb2db591eeac3$export$c09f4880e00b72de = 'component';
});
parcelRegister("hQdsQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61b3b3b5aaed0c1c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $61b3b3b5aaed0c1c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sunsetDotMenuWarningTitle: {
            "id": "shortcuts-dialog.modal.sunset-dot-menu-warning-title",
            "defaultMessage": "We\u2019re removing the dot menu"
        },
        sunsetDotMenuWarningDescription: {
            "id": "shortcuts-dialog.modal.sunset-dot-menu-warning-description",
            "defaultMessage": "From August 19, we\u2019ll remove this menu to make way for an improved command palette. Press <strong>{isMac, select, true {Cmd + K} other {Ctrl + K}}</strong> on your keyboard to try it now."
        },
        tryNowButton: {
            "id": "shortcuts-dialog.modal.sunset-dot-menu-warning-try-now-button",
            "defaultMessage": "Try now"
        },
        learnMoreButton: {
            "id": "shortcuts-dialog.modal.sunset-dot-menu-warning-learn-more-button",
            "defaultMessage": "Why remove the dot menu?"
        },
        dotMenuRemovalTitle: {
            "id": "shortcuts-dialog.modal.dot-menu-removal-title",
            "defaultMessage": "Try the improved command palette"
        },
        dotMenuRemovalDescription: {
            "id": "shortcuts-dialog.modal.dot-menu-removal-description",
            "defaultMessage": "We removed the dot menu to make way for the command palette.{isEmbed, select, true {} other { Press <strong>{isMac, select, true {Cmd + K} other {Ctrl + K}}</strong> on your keyboard to try it now.}}"
        }
    });
});
parcelRegister("h3bYX", function(module, exports) {
    $parcel$export(module.exports, "useIsEmbed", ()=>$4283664912e38c16$export$ce94463dec1ccebd);
    var $doZTA;
    const $4283664912e38c16$export$ce94463dec1ccebd = ()=>{
        const [{ location: { pathname: pathname } }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        if (pathname.endsWith('/embed')) return true;
        return false;
    };
});
parcelRegister("SdVQy", function(module, exports) {
    $parcel$export(module.exports, "FlagIssueWithCommentModal", ()=>$3703170aad80cd81$export$dc5402e0014db7d2);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $kz2lw;
    var $ivDCs;
    var $4mO32;
    var $7CMCs;
    var $jcw0u;
    var $pa9q9;
    var $8zOmE;
    var $2NMNM;
    var $69fcl;
    var $ae5j7;
    var $hY88a;
    var $jNNUm;
    const $3703170aad80cd81$var$entryPointParams = {};
    const $3703170aad80cd81$var$FlagIssueWithCommentModalBase = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("69fcl")).asyncFlagWithCommentModal), $3703170aad80cd81$var$entryPointParams);
        const [initialized, setInitialized] = (0, $5uXOq.useState)(false);
        const [{ flagAction: flagAction, issues: issues, forcePreload: forcePreload, callback: callback, analyticsArgs: analyticsArgs }, { close: close }] = (0, (0, parcelRequire("ae5j7")).useFlagIssueModal)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        (0, $5uXOq.useEffect)(()=>{
            if (forcePreload && !initialized) {
                setInitialized(true);
                entryPointActions.preload();
            }
        }, [
            entryPointActions,
            forcePreload,
            initialized
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (flagAction !== undefined) {
                entryPointActions.load();
                if (!initialized) setInitialized(true);
            } else if (initialized) entryPointActions.unload();
        }, [
            flagAction,
            initialized,
            entryPointActions
        ]);
        const issueIds = (0, $5uXOq.useMemo)(()=>issues.map(({ issueId: issueId })=>issueId), [
            issues
        ]);
        const handleSaveWithComment = (0, $5uXOq.useCallback)(async (_, flag, comment)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            const extendedAnalyticsArgs = {
                hasComment: !(0, ($parcel$interopDefault($ajpes)))(comment, (0, (0, parcelRequire("kz2lw")).getEmptyADF)()),
                ...analyticsArgs
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'confirmButton', extendedAnalyticsArgs);
            close();
            try {
                await (0, (0, parcelRequire("hY88a")).saveFlagWithComment)(issueIds, flag, comment);
                analyticsEvent.update({
                    action: 'flagged',
                    actionSubject: 'cards'
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'cards flagged', {
                    ...extendedAnalyticsArgs,
                    numCards: issueIds.length,
                    flagAction: flag ? 'added' : 'removed'
                });
                if (callback) callback({
                    issueIds: issueIds,
                    flag: flag,
                    comment: comment
                });
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Unknown error');
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'jira.addCommentOnFlagSaveAction',
                        packageName: 'jiraSoftwareAddIssueFlagWithComment',
                        teamName: 'deliveroo'
                    }
                });
                showFlag({
                    key: 'flag-issue-with-comment-modal-error',
                    type: 'error',
                    title: flag ? (0, (0, parcelRequire("jNNUm")).messages).addFlagFailedTitle : (0, (0, parcelRequire("jNNUm")).messages).removeFlagFailedTitle,
                    description: flag ? (0, (0, parcelRequire("jNNUm")).messages).addFlagFailedDescription : (0, (0, parcelRequire("jNNUm")).messages).removeFlagFailedDescription
                });
            }
        }, [
            createAnalyticsEvent,
            analyticsArgs,
            close,
            issueIds,
            callback,
            showFlag
        ]);
        const handleOnClose = ()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'cancelButton', {
                ...analyticsArgs
            });
            close();
        };
        const modalProps = {
            flagAction: flagAction,
            cards: issues.map(({ issueId: issueId, issueKey: issueKey, summary: summary, type: type })=>({
                    id: +issueId,
                    key: issueKey,
                    summary: summary ?? '',
                    type: type
                })),
            onClose: handleOnClose,
            onFlagWithComment: handleSaveWithComment
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ivDCs")).ModalEntryPointContainer), {
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "flag-issue-with-comment-modal",
            packageName: "jira-software-add-issue-flag-with-comment",
            runtimeProps: modalProps
        });
    };
    const $3703170aad80cd81$export$dc5402e0014db7d2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "jira-software-add-issue-flag-with-comment-entrypoint",
            packageName: "JiraSoftwareAddIssueFlagWithComment",
            fallback: "unmount",
            teamName: "deliveroo"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3703170aad80cd81$var$FlagIssueWithCommentModalBase, null));
});
parcelRegister("kz2lw", function(module, exports) {
    $parcel$export(module.exports, "getEmptyADF", ()=>$06167b6274ea84aa$export$d109ab46c9575565);
    var $ebjue;
    const $06167b6274ea84aa$export$d109ab46c9575565 = ()=>({
            type: 'doc',
            version: 1,
            content: []
        });
});
parcelRegister("ebjue", function(module, exports) {
    $parcel$export(module.exports, "isEmpty", ()=>$9e55b7d6fded4629$export$dd1bc94b04021eeb);
    const $9e55b7d6fded4629$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;
});
parcelRegister("69fcl", function(module, exports) {
    $parcel$export(module.exports, "asyncFlagWithCommentModal", ()=>$28aff258c4c6ce35$export$58c94fab0d44ad1);
    var $eufEc;
    var $fEDBv;
    const $28aff258c4c6ce35$export$58c94fab0d44ad1 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("47u60")).then((module)=>module.CommentOnFlaggingUnflaggingEntryPoint), {
            moduleId: "265517b7"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("47u60", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("gXwUo")
    ]).then(()=>parcelRequire('dbKJB'));
});
parcelRegister("ae5j7", function(module, exports) {
    $parcel$export(module.exports, "useFlagIssueModal", ()=>$c416c370f4462794$export$db07b3fff1829cc2);
    $parcel$export(module.exports, "useFlagIssueModalActions", ()=>$c416c370f4462794$export$9c426adea6bff2be);
    var $3sQ5x;
    var $iXqE5;
    var $5K87F;
    const $c416c370f4462794$var$initialState = {
        forcePreload: false,
        issues: [],
        flagAction: undefined
    };
    const $c416c370f4462794$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $c416c370f4462794$var$initialState,
        actions: (0, parcelRequire("5K87F")).actions,
        name: 'flagIssueModalStore'
    });
    const $c416c370f4462794$export$db07b3fff1829cc2 = (0, (0, parcelRequire("3sQ5x")).createHook)($c416c370f4462794$var$store);
    const $c416c370f4462794$export$9c426adea6bff2be = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($c416c370f4462794$var$store);
});
parcelRegister("5K87F", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$a410b1e438cebcdc$export$e324594224ef24da);
    const $a410b1e438cebcdc$var$open = ({ issues: issues, flagAction: flagAction, callback: callback, source: source, analyticsArgs: analyticsArgs })=>({ setState: setState })=>{
            const newState = {
                issues: issues,
                flagAction: flagAction,
                callback: callback,
                analyticsArgs: {
                    source: source,
                    ...analyticsArgs
                }
            };
            setState(newState);
        };
    const $a410b1e438cebcdc$var$close = ()=>({ setState: setState })=>{
            setState({
                issues: [],
                flagAction: undefined,
                callback: undefined,
                analyticsArgs: undefined
            });
        };
    const $a410b1e438cebcdc$var$preload = ()=>({ setState: setState, getState: getState })=>{
            const { forcePreload: forcePreload } = getState();
            if (!forcePreload) setState({
                forcePreload: true
            });
        };
    const $a410b1e438cebcdc$export$e324594224ef24da = {
        open: $a410b1e438cebcdc$var$open,
        close: $a410b1e438cebcdc$var$close,
        preload: $a410b1e438cebcdc$var$preload
    };
});
parcelRegister("hY88a", function(module, exports) {
    $parcel$export(module.exports, "saveFlagWithComment", ()=>$5ce14b9ace0b4c07$export$59f88df61be59073);
    var $jJZqs;
    var $iwPwz;
    const $5ce14b9ace0b4c07$export$3ae968343ffb0d2b = '/rest/greenhopper/3/xboard/issue/flag/flag';
    const $5ce14b9ace0b4c07$var$noContentStatus = 204;
    const $5ce14b9ace0b4c07$export$59f88df61be59073 = (issueKeys, flag, comment)=>fetch($5ce14b9ace0b4c07$export$3ae968343ffb0d2b, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                issueKeys: issueKeys,
                flag: flag,
                comment: comment,
                commentProperty: '',
                commentVisibility: ''
            })
        }).then((response)=>{
            if (!response.ok) {
                const { status: status } = response;
                const traceId = (0, (0, parcelRequire("iwPwz")).getTraceId)(response);
                if (traceId != null && traceId !== '') throw new (0, (0, parcelRequire("jJZqs")).default)(status, `Fetch call failed with status code: ${status}`, traceId);
                else throw new (0, (0, parcelRequire("jJZqs")).default)(status);
            }
            if (response.status === $5ce14b9ace0b4c07$var$noContentStatus) return null;
            return response.text().then((body)=>{
                const result = body ? JSON.parse(body) : null;
                if (result) {
                    const errorMessage = result.errorMessages ? result.errorMessages.join(', ') : 'Unidentified error when saving flag with comment';
                    throw new Error(errorMessage);
                }
                return null;
            });
        });
});
parcelRegister("jNNUm", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$1899c91be04dbda7$export$defe85febe8b728c);
    var $7VHMR;
    const $1899c91be04dbda7$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addFlagFailedTitle: {
            "id": "software-add-issue-flag-with-comment.add-flag-failed-title",
            "defaultMessage": "We couldn't flag this issue"
        },
        addFlagFailedDescription: {
            "id": "software-add-issue-flag-with-comment.add-flag-failed-description",
            "defaultMessage": "Check your connection and try adding the flag again."
        },
        removeFlagFailedTitle: {
            "id": "software-add-issue-flag-with-comment.remove-flag-failed-title",
            "defaultMessage": "We couldn't remove the flag from this issue"
        },
        removeFlagFailedDescription: {
            "id": "software-add-issue-flag-with-comment.remove-flag-failed-description",
            "defaultMessage": "Check your connection and try removing the flag again."
        }
    });
});
parcelRegister("eZISU", function(module, exports) {
    $parcel$export(module.exports, "AsyncEnforceStorageLimitsModal", ()=>$81094c6a1ad285ba$export$319be76441a339a9);
    var $5uXOq = parcelRequire("5uXOq");
    var $luVGE;
    var $ivDCs;
    var $4mO32;
    var $6H3Sx;
    var $koeKL;
    var $itmJb;
    var $l2AwX;
    var $b1F16;
    var $dVd9U;
    const $81094c6a1ad285ba$export$319be76441a339a9 = ()=>{
        const isFreeEdition = (0, (0, parcelRequire("6H3Sx")).useIsJswFreeEdition)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const { canUpgradeAndPay: canUpgradeAndPay, loading: isBillingPermissionsLoading } = (0, (0, parcelRequire("luVGE")).useCanUpgradeAndPayForJswFree)({
            caller: (0, $3f79643dcab1adf8$export$b8b9d90f9e5bd72b),
            billingAdminCheckMethod: 'traits',
            skip: !isFreeEdition || !isAdmin
        });
        const { jswStorageRatio: jswStorageRatio, jswStorageLimit: jswStorageLimit } = (0, (0, parcelRequire("dVd9U")).useJswStorageUsage)({
            skip: !isFreeEdition || !isAdmin || !canUpgradeAndPay
        });
        const hasReachedStorageRatioThreshold = jswStorageRatio && jswStorageRatio > (0, $bd1c5ff994e2d732$export$dada91eca2d214e9);
        if (!isFreeEdition || !jswStorageLimit || !hasReachedStorageRatioThreshold || isBillingPermissionsLoading) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($81094c6a1ad285ba$export$cfe1392b5c9b528f, {
            jswStorageRatio: jswStorageRatio,
            jswStorageLimit: jswStorageLimit,
            canUpgradeAndPay: Boolean(canUpgradeAndPay)
        });
    };
    const $81094c6a1ad285ba$export$cfe1392b5c9b528f = ({ jswStorageRatio: jswStorageRatio, jswStorageLimit: jswStorageLimit, canUpgradeAndPay: canUpgradeAndPay })=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("b1F16")).enforceStorageLimitsModalEntryPoint), {
            cloudId: cloudId,
            productKey: 'jira-software.ondemand',
            offeringKey: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526'
        });
        const [{ isOpen: isOpen }, { setIsOpen: setIsOpen }] = (0, (0, parcelRequire("l2AwX")).useEnforceStorageModal)();
        const enforceStorageLimitsModalProps = (0, $5uXOq.useMemo)(()=>({
                onClose: ()=>{
                    setIsOpen({
                        isOpen: 'closed',
                        touchpoint: undefined
                    });
                },
                jswStorageRatio: jswStorageRatio,
                jswStorageLimit: jswStorageLimit,
                canUpgradeAndPay: canUpgradeAndPay
            }), [
            jswStorageRatio,
            jswStorageLimit,
            canUpgradeAndPay,
            setIsOpen
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen === 'open') entryPointActions.load();
        }, [
            entryPointActions,
            isOpen
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ivDCs")).ModalEntryPointContainer), {
            id: "async-enforce-storage-limits-modal",
            packageName: (0, $3f79643dcab1adf8$export$b8b9d90f9e5bd72b),
            teamName: "jlove-makkuro",
            entryPointReferenceSubject: entryPointReferenceSubject,
            entryPointActions: entryPointActions,
            errorFallback: "unmount",
            runtimeProps: enforceStorageLimitsModalProps
        });
    };
});
parcelRegister("luVGE", function(module, exports) {
    $parcel$export(module.exports, "useCanUpgradeAndPayForJswFree", ()=>$67815aac06127855$export$f4f07d855739fba1);
    $parcel$export(module.exports, "useCanUpgradeAndPayForCurrentProduct", ()=>$67815aac06127855$export$2e34435b19772971);
    $parcel$export(module.exports, "useCanProductUserUpgradeAndPay", ()=>$67815aac06127855$export$53827a0ff095f14b);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $cVzoY;
    var $jcw0u;
    var $iHAwr;
    var $eusud;
    var $8ilPk;
    var $16v4H;
    var $9OXo1;
    var $grETT;
    const $67815aac06127855$var$fetchEntitlementDetails = (entitlementId)=>(0, (0, parcelRequire("eusud")).performGetRequest)(`/gateway/api/ccp/api/v1/entitlements/${entitlementId}/details`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    const $67815aac06127855$var$fetchBillingAdmins = (transactionAccountId)=>(0, (0, parcelRequire("eusud")).performGetRequest)('/gateway/api/ccp/api/v1/billing-admins', {
            headers: {
                'Content-Type': 'application/json',
                'X-transaction-account': transactionAccountId
            }
        });
    const $67815aac06127855$export$2abcbc88aea6e581 = (0, (0, parcelRequire("8QpSo")).default)($67815aac06127855$var$fetchEntitlementDetails);
    const $67815aac06127855$export$294eed4c864e0f71 = (0, (0, parcelRequire("8QpSo")).default)($67815aac06127855$var$fetchBillingAdmins);
    const $67815aac06127855$export$f4f07d855739fba1 = ({ caller: caller, skip: skip = false, billingAdminCheckMethod: billingAdminCheckMethod = 'traits' })=>{
        const [canUpgradeAndPay, setCanUpgradeAndPay] = (0, $5uXOq.useState)(undefined);
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const [error, setError] = (0, $5uXOq.useState)(undefined);
        const [ineligibilityReason, setIneligibilityReason] = (0, $5uXOq.useState)(undefined);
        const { isSiteAdmin: isSiteAdmin, cloudId: cloudId, atlassianAccountId: atlassianAccountId, productEntitlementDetails: productEntitlementDetails } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { fetch: fetch, error: personalizationApiError } = (0, (0, parcelRequire("8ilPk")).useSiteUserPersonalization)();
        const isBillingSystemCcp = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d]?.billingSourceSystem === 'CCP';
        const entitlementId = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d]?.entitlementId;
        const checkIsCcpBillingAdmin = (0, $5uXOq.useCallback)(async ()=>{
            if (!entitlementId) throw new Error('Empty entitlementId');
            if (!atlassianAccountId) throw new Error('Empty atlassianAccountId');
            if (billingAdminCheckMethod === 'ccpApi') {
                const entitlementDetails = await $67815aac06127855$export$2abcbc88aea6e581(entitlementId);
                const transactionAccountId = entitlementDetails?.transactionAccountId;
                const billingAdminsResponse = await $67815aac06127855$export$294eed4c864e0f71(transactionAccountId);
                const isBillingAdmin = !!billingAdminsResponse?.data?.find(({ id: id = null })=>id === atlassianAccountId);
                return isBillingAdmin;
            }
            const personalizationData = await fetch({
                cloudId: cloudId,
                userId: atlassianAccountId
            });
            if (!personalizationData) return undefined;
            const isBillingAdmin = personalizationData.find((trait)=>trait.name === (0, $02e6bdfbfa6ba416$export$3aad3de2cc377789) && trait.value === true) !== undefined;
            return isBillingAdmin;
        }, [
            atlassianAccountId,
            billingAdminCheckMethod,
            cloudId,
            entitlementId,
            fetch
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (skip) return;
            setLoading(true);
            if (isSiteAdmin) {
                if (isBillingSystemCcp) checkIsCcpBillingAdmin().then((isBillingAdmin)=>{
                    setCanUpgradeAndPay(isBillingAdmin);
                    setIneligibilityReason(isBillingAdmin ? '' : 'not a billing admin');
                }).catch((e)=>{
                    setError(e);
                    setIneligibilityReason('error checking eligibility');
                }).finally(()=>{
                    setLoading(false);
                });
                else {
                    setCanUpgradeAndPay(true);
                    setLoading(false);
                    setIneligibilityReason('');
                }
            } else {
                setCanUpgradeAndPay(false);
                setLoading(false);
                setIneligibilityReason('not a site admin');
            }
        }, [
            atlassianAccountId,
            caller,
            checkIsCcpBillingAdmin,
            isBillingSystemCcp,
            isSiteAdmin,
            skip
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (personalizationApiError) setError(personalizationApiError);
        }, [
            personalizationApiError
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (error) (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'useCanUpgradeAndPayForJswFree',
                    packageName: (0, $02e6bdfbfa6ba416$export$b8b9d90f9e5bd72b),
                    teamName: 'growth-tako'
                },
                attributes: {
                    billingSourceSystem: isBillingSystemCcp ? 'CCP' : 'HAMS',
                    caller: caller,
                    billingAdminCheckMethod: billingAdminCheckMethod
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }, [
            error,
            isBillingSystemCcp,
            caller,
            billingAdminCheckMethod
        ]);
        return {
            canUpgradeAndPay: canUpgradeAndPay,
            loading: loading,
            error: error,
            ineligibilityReason: ineligibilityReason
        };
    };
    const $67815aac06127855$export$2e34435b19772971 = ({ caller: caller, skip: skip = false })=>{
        const [canUpgradeAndPay, setCanUpgradeAndPay] = (0, $5uXOq.useState)(undefined);
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const [error, setError] = (0, $5uXOq.useState)(undefined);
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const subProduct = (0, (0, parcelRequire("16v4H")).useSubProduct)();
        const explicitlyLicensedProducts = (0, (0, parcelRequire("cVzoY")).default)(tenantContext);
        const applicationKey = (0, (0, parcelRequire("iHAwr")).getProductKey)(subProduct, explicitlyLicensedProducts);
        (0, $5uXOq.useEffect)(()=>{
            if (skip) return;
            if (!applicationKey) {
                setError(new Error('Empty applicationKey'));
                return;
            }
            const isBillingSystemCcp = tenantContext.productEntitlementDetails?.[applicationKey]?.billingSourceSystem === 'CCP';
            const entitlementId = tenantContext.productEntitlementDetails?.[applicationKey]?.entitlementId;
            const checkIsCcpBillingAdmin = async ()=>{
                if (!entitlementId) throw new Error('Empty entitlementId');
                if (!tenantContext.atlassianAccountId) throw new Error('Empty atlassianAccountId');
                const entitlementDetails = await $67815aac06127855$export$2abcbc88aea6e581(entitlementId);
                const transactionAccountId = entitlementDetails?.transactionAccountId;
                const billingAdminsResponse = await $67815aac06127855$export$294eed4c864e0f71(transactionAccountId);
                const isBillingAdmin = billingAdminsResponse?.data?.some(({ id: id = null })=>id === tenantContext.atlassianAccountId) ?? false;
                return isBillingAdmin;
            };
            setLoading(true);
            if (tenantContext.isSiteAdmin && tenantContext.atlassianAccountId) {
                if (isBillingSystemCcp) checkIsCcpBillingAdmin().then((isBillingAdmin)=>{
                    setCanUpgradeAndPay(isBillingAdmin);
                }).catch((e)=>{
                    setError(e);
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: e,
                        meta: {
                            id: 'useCanUpgradeAndPayForCurrentProduct',
                            packageName: (0, $02e6bdfbfa6ba416$export$b8b9d90f9e5bd72b),
                            teamName: 'growth-tako'
                        },
                        attributes: {
                            billingSourceSystem: isBillingSystemCcp ? 'CCP' : 'HAMS',
                            caller: caller,
                            subProduct: subProduct,
                            applicationKey: applicationKey,
                            licensedProducts: tenantContext.licensedProducts,
                            productEntitlementDetails: tenantContext.productEntitlementDetails
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }).finally(()=>{
                    setLoading(false);
                });
                else {
                    setCanUpgradeAndPay(true);
                    setLoading(false);
                }
            } else {
                setCanUpgradeAndPay(false);
                setLoading(false);
            }
        }, [
            applicationKey,
            caller,
            skip,
            subProduct,
            tenantContext.atlassianAccountId,
            tenantContext.isSiteAdmin,
            tenantContext.licensedProducts,
            tenantContext.productEntitlementDetails
        ]);
        return {
            canUpgradeAndPay: canUpgradeAndPay,
            loading: loading,
            error: error
        };
    };
    const $67815aac06127855$export$422d9ad995b055f = ({ caller: caller, onError: onError })=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const subProduct = (0, (0, parcelRequire("16v4H")).useSubProduct)();
        const explicitlyLicensedProducts = (0, (0, parcelRequire("cVzoY")).default)(tenantContext);
        const applicationKey = (0, (0, parcelRequire("iHAwr")).getProductKey)(subProduct, explicitlyLicensedProducts);
        const checkIsCcpBillingAdmin = (0, $5uXOq.useCallback)(async (entitlementId)=>{
            if (!entitlementId) throw new Error('Empty entitlementId');
            if (!tenantContext.atlassianAccountId) throw new Error('Empty atlassianAccountId');
            const entitlementDetails = await $67815aac06127855$export$2abcbc88aea6e581(entitlementId);
            const transactionAccountId = entitlementDetails?.transactionAccountId;
            const billingAdminsResponse = await $67815aac06127855$export$294eed4c864e0f71(transactionAccountId);
            const isBillingAdmin = billingAdminsResponse?.data?.some(({ id: id = null })=>id === tenantContext.atlassianAccountId) ?? false;
            return isBillingAdmin;
        }, [
            tenantContext.atlassianAccountId
        ]);
        const hasUpgradeAndBillingPermission = (0, $5uXOq.useCallback)(async ()=>{
            if (!applicationKey) {
                const error = new Error('Empty applicationKey');
                const analyticsAttributes = {
                    caller: caller,
                    subProduct: subProduct,
                    applicationKey: applicationKey,
                    licensedProducts: tenantContext.licensedProducts,
                    productEntitlementDetails: tenantContext.productEntitlementDetails
                };
                onError?.(error, analyticsAttributes);
                return null;
            }
            if (!tenantContext.isSiteAdmin || !tenantContext.atlassianAccountId) return false;
            const isBillingSystemCcp = tenantContext.productEntitlementDetails?.[applicationKey]?.billingSourceSystem === 'CCP';
            if (isBillingSystemCcp) {
                const entitlementId = tenantContext.productEntitlementDetails?.[applicationKey]?.entitlementId;
                return checkIsCcpBillingAdmin(entitlementId).then((isBillingAdmin)=>isBillingAdmin).catch((e)=>{
                    const analyticsAttributes = {
                        billingSourceSystem: isBillingSystemCcp ? 'CCP' : 'HAMS',
                        caller: caller,
                        subProduct: subProduct,
                        applicationKey: applicationKey,
                        licensedProducts: tenantContext.licensedProducts,
                        productEntitlementDetails: tenantContext.productEntitlementDetails
                    };
                    onError?.(e, analyticsAttributes);
                    return null;
                });
            }
            return true;
        }, [
            applicationKey,
            caller,
            checkIsCcpBillingAdmin,
            onError,
            subProduct,
            tenantContext.atlassianAccountId,
            tenantContext.isSiteAdmin,
            tenantContext.licensedProducts,
            tenantContext.productEntitlementDetails
        ]);
        return {
            hasUpgradeAndBillingPermission: hasUpgradeAndBillingPermission
        };
    };
    function $67815aac06127855$export$53827a0ff095f14b({ skip: skip, productKey: productKey }) {
        const { data: data, isLoading: isLoading, error: error, fetch: fetchCanProductUserUpgradeAndPay } = (0, (0, parcelRequire("grETT")).useCanProductUserUpgradeAndPayQuery)();
        (0, $5uXOq.useEffect)(()=>{
            if (skip || !productKey) return;
            fetchCanProductUserUpgradeAndPay(productKey);
        }, [
            fetchCanProductUserUpgradeAndPay,
            productKey,
            skip
        ]);
        const canProductUserUpgradeAndPay = data?.canProductUserUpgradeAndPay;
        const isProductUserBillingAdmin = data?.isBillingAdmin;
        return {
            isProductUserBillingAdmin: isProductUserBillingAdmin,
            canProductUserUpgradeAndPay: canProductUserUpgradeAndPay,
            isLoading: isLoading,
            error: error
        };
    }
});
parcelRegister("cVzoY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$386aacc800b616d8$export$2e2bcd8739ae039);
    var $386aacc800b616d8$export$2e2bcd8739ae039 = (tenantContext)=>{
        const { licensedProducts: licensedProducts } = tenantContext;
        const result = [];
        licensedProducts[0, $c06e1abca7c13910$export$db515c8cec1e6f79] && result.push((0, $c06e1abca7c13910$export$db515c8cec1e6f79));
        licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && result.push((0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61));
        licensedProducts[0, $c06e1abca7c13910$export$1346c9aa3cbb477d] && result.push((0, $c06e1abca7c13910$export$1346c9aa3cbb477d));
        licensedProducts[0, $c06e1abca7c13910$export$202f50ee62667e32] && result.push((0, $c06e1abca7c13910$export$202f50ee62667e32));
        return result;
    };
});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';
parcelRegister("iHAwr", function(module, exports) {
    $parcel$export(module.exports, "getProductKey", ()=>$a2785a755bdb8c08$export$d0b7f02493f85477);
    const $a2785a755bdb8c08$export$d0b7f02493f85477 = (subProduct, explicitlyLicensedProducts)=>{
        if (subProduct === 'software') return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
        if (subProduct === 'serviceDesk') return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
        if (subProduct === 'polaris') return 0, $c06e1abca7c13910$export$202f50ee62667e32;
        if (subProduct === 'core') return 0, $c06e1abca7c13910$export$db515c8cec1e6f79;
        if (explicitlyLicensedProducts.length === 1) return explicitlyLicensedProducts[0];
        return null;
    };
});
parcelRegister("8ilPk", function(module, exports) {
    $parcel$export(module.exports, "memoizedFetchSiteUserPersonalization", ()=>$4ab23cf8c5a935d6$export$de93ec54b11be450);
    $parcel$export(module.exports, "useSiteUserPersonalization", ()=>$4ab23cf8c5a935d6$export$8dc79ff315095801);
    var $8QpSo;
    var $ld2hZ;
    var $7f4tk;
    const $4ab23cf8c5a935d6$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
    const $4ab23cf8c5a935d6$export$8f40704723ec6690 = async ({ cloudId: cloudId, userId: userId })=>{
        if (!cloudId) throw new Error('empty cloudId');
        if (!userId) throw new Error('empty userId');
        const { attributes: attributes } = await (0, (0, parcelRequire("7f4tk")).default)($4ab23cf8c5a935d6$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'x-atlassian-mau-ignore': 'true'
            }
        });
        return attributes;
    };
    const $4ab23cf8c5a935d6$export$de93ec54b11be450 = (0, (0, parcelRequire("8QpSo")).default)($4ab23cf8c5a935d6$export$8f40704723ec6690, ([{ cloudId: newCloudId, userId: newUserId }], [{ cloudId: lastCloudId, userId: lastUserId }])=>newCloudId === lastCloudId && newUserId === lastUserId);
    const $4ab23cf8c5a935d6$export$8dc79ff315095801 = ()=>(0, (0, parcelRequire("ld2hZ")).useService)($4ab23cf8c5a935d6$export$de93ec54b11be450);
});
const $02e6bdfbfa6ba416$export$3aad3de2cc377789 = 'jira_software_free_is_ccp_billing_admins';
const $02e6bdfbfa6ba416$export$b8b9d90f9e5bd72b = 'jiraBilling';
parcelRegister("grETT", function(module, exports) {
    $parcel$export(module.exports, "useCanProductUserUpgradeAndPayQuery", ()=>$112732b26b85a7cd$export$44d5ccfd376c6700);
    var $8MTii;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $koeKL;
    const $112732b26b85a7cd$export$62297b13309008b2 = (0, (0, parcelRequire("8MTii")).default);
    const $112732b26b85a7cd$export$44d5ccfd376c6700 = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const relayEnvironment = (0, $8Uumt.useRelayEnvironment)();
        const [data, setData] = (0, $5uXOq.useState)(undefined);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [error, setError] = (0, $5uXOq.useState)(null);
        const fetch = (0, $5uXOq.useCallback)((productKey)=>{
            setIsLoading(true);
            const variables = {
                cloudId: cloudId,
                productKey: productKey
            };
            (0, $8Uumt.fetchQuery)(relayEnvironment, $112732b26b85a7cd$export$62297b13309008b2, variables, {
                fetchPolicy: 'store-or-network'
            }).subscribe({
                complete: ()=>{
                    setIsLoading(false);
                },
                next: (response)=>{
                    const entitlement = response?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
                    const canPay = entitlement?.transactionAccount?.experienceCapabilities?.addPaymentMethodV2?.isAvailableToUser;
                    const canUpgrade = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser;
                    const isCurrentUserBillingAdmin = entitlement?.transactionAccount?.isCurrentUserBillingAdmin;
                    const canUpgradeAndPay = canUpgrade && canPay;
                    setData({
                        canProductUserUpgradeAndPay: canUpgradeAndPay ?? false,
                        isBillingAdmin: isCurrentUserBillingAdmin ?? false
                    });
                },
                error: (fetchError)=>{
                    setIsLoading(false);
                    setError(fetchError);
                }
            });
        }, [
            cloudId,
            relayEnvironment
        ]);
        return {
            fetch: fetch,
            data: data,
            isLoading: isLoading,
            error: error
        };
    };
});
parcelRegister("8MTii", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a332fe2790ce2104$export$2e2bcd8739ae039);
    const $a332fe2790ce2104$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "productKey"
            }
        ], v1 = [
            {
                "items": [
                    {
                        "kind": "Variable",
                        "name": "cloudIds.0",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
            }
        ], v2 = [
            {
                "kind": "Variable",
                "name": "hamsProductKey",
                "variableName": "productKey"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "isCurrentUserBillingAdmin"
        }, v4 = {
            "kind": "ScalarField",
            "name": "isAvailableToUser"
        }, v5 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v6 = [
            v5,
            v4
        ], v7 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "canProductUserUpgradeAndPayQuery",
                "selections": [
                    {
                        "args": v1,
                        "concreteType": "TenantContext",
                        "kind": "LinkedField",
                        "name": "tenantContexts",
                        "plural": true,
                        "selections": [
                            {
                                "args": v2,
                                "kind": "LinkedField",
                                "name": "entitlementInfo",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "entitlement",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "transactionAccount",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3,
                                                        "action": "THROW",
                                                        "path": "tenantContexts.entitlementInfo.entitlement.transactionAccount.isCurrentUserBillingAdmin"
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "experienceCapabilities",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "addPaymentMethodV2",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v4,
                                                                        "action": "THROW",
                                                                        "path": "tenantContexts.entitlementInfo.entitlement.transactionAccount.experienceCapabilities.addPaymentMethodV2.isAvailableToUser"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "LinkedField",
                                                "name": "experienceCapabilities",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "changeOfferingV2",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4,
                                                                "action": "THROW",
                                                                "path": "tenantContexts.entitlementInfo.entitlement.experienceCapabilities.changeOfferingV2.isAvailableToUser"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "canProductUserUpgradeAndPayQuery",
                "selections": [
                    {
                        "args": v1,
                        "concreteType": "TenantContext",
                        "kind": "LinkedField",
                        "name": "tenantContexts",
                        "plural": true,
                        "selections": [
                            {
                                "args": v2,
                                "kind": "LinkedField",
                                "name": "entitlementInfo",
                                "plural": false,
                                "selections": [
                                    v5,
                                    {
                                        "kind": "LinkedField",
                                        "name": "entitlement",
                                        "plural": false,
                                        "selections": [
                                            v5,
                                            {
                                                "kind": "LinkedField",
                                                "name": "transactionAccount",
                                                "plural": false,
                                                "selections": [
                                                    v5,
                                                    v3,
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "experienceCapabilities",
                                                        "plural": false,
                                                        "selections": [
                                                            v5,
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "addPaymentMethodV2",
                                                                "plural": false,
                                                                "selections": v6
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v7
                                                        ],
                                                        "type": "CcpTransactionAccount"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "LinkedField",
                                                "name": "experienceCapabilities",
                                                "plural": false,
                                                "selections": [
                                                    v5,
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "changeOfferingV2",
                                                        "plural": false,
                                                        "selections": v6
                                                    }
                                                ]
                                            },
                                            v7
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "9308b51a7dfc7d956d54b611c603679c467cba651b645e963aac170dd0f5ba0b",
                "metadata": {},
                "name": "canProductUserUpgradeAndPayQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $a332fe2790ce2104$var$node.hash = "018980114a88416ec612e7565b16db6c";
    var $a332fe2790ce2104$export$2e2bcd8739ae039 = $a332fe2790ce2104$var$node;
});
parcelRegister("6H3Sx", function(module, exports) {
    $parcel$export(module.exports, "useIsJswFreeEdition", ()=>$b4bd5e0f3cc31225$export$caad10020a17bf56);
    var $5uXOq = parcelRequire("5uXOq");
    var $ldyPw;
    var $k9JTq;
    const $b4bd5e0f3cc31225$export$caad10020a17bf56 = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        return (0, $5uXOq.useMemo)(()=>appEditions.software === (0, (0, parcelRequire("ldyPw")).FREE_EDITION), [
            appEditions
        ]);
    };
});
const $3f79643dcab1adf8$export$b8b9d90f9e5bd72b = 'jira-enforce-storage-limits';
const $3f79643dcab1adf8$export$8f56a4ad6e1486ea = 10;
const $3f79643dcab1adf8$export$ed785d2382d0101d = 'lastStorageEnforcement';
parcelRegister("l2AwX", function(module, exports) {
    $parcel$export(module.exports, "useEnforceStorageModal", ()=>$377250c350eb1ea3$export$56beb4c2629d6615);
    var $3sQ5x;
    var $iXqE5;
    var $7FEwN;
    const $377250c350eb1ea3$var$initialState = {
        isOpen: 'closed',
        touchpoint: undefined
    };
    const $377250c350eb1ea3$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'jsw-enforce-storage-limit-modal',
        initialState: $377250c350eb1ea3$var$initialState,
        actions: (0, parcelRequire("7FEwN")).actions
    });
    const $377250c350eb1ea3$export$56beb4c2629d6615 = (0, (0, parcelRequire("3sQ5x")).createHook)($377250c350eb1ea3$var$store);
});
parcelRegister("7FEwN", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$a1630f6ff8f7879d$export$e324594224ef24da);
    var $aBMM9;
    const $a1630f6ff8f7879d$export$e324594224ef24da = {
        setIsOpen: (0, parcelRequire("aBMM9")).setIsOpen
    };
});
parcelRegister("aBMM9", function(module, exports) {
    $parcel$export(module.exports, "setIsOpen", ()=>$bd4df525f1eeff62$export$dcf23146e0a40195);
    const $bd4df525f1eeff62$export$dcf23146e0a40195 = (newState)=>({ setState: setState })=>{
            setState(newState);
        };
});
const $bd1c5ff994e2d732$export$dada91eca2d214e9 = 1;
parcelRegister("b1F16", function(module, exports) {
    $parcel$export(module.exports, "enforceStorageLimitsModalEntryPoint", ()=>$e1822a392f1093a8$export$9dc1f3d91d81486);
    var $KLO63;
    var $eufEc;
    var $fEDBv;
    const $e1822a392f1093a8$export$9dc1f3d91d81486 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("hzjjk")), {
            moduleId: "0c63b578"
        }),
        getPreloadProps: ({ cloudId: cloudId, productKey: productKey, offeringKey: offeringKey })=>({
                queries: {
                    changeOffering: {
                        parameters: (0, parcelRequire("KLO63")).default,
                        variables: {
                            cloudId: cloudId,
                            productKey: productKey,
                            offeringKey: offeringKey
                        }
                    }
                }
            })
    });
});
parcelRegister("KLO63", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$502cdae88604486d$export$2e2bcd8739ae039);
    const $502cdae88604486d$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "ea8945a70156b0e6ef8bae1986c4a0b7fa509f9e2517d04cd635ce03b865cbd3",
            "metadata": {},
            "name": "modal_EnforceStorageLimitQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $502cdae88604486d$export$2e2bcd8739ae039 = $502cdae88604486d$var$node;
});
parcelRegister("hzjjk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("iUBXl")
    ]).then(()=>parcelRequire('fxJ51'));
});
parcelRegister("dVd9U", function(module, exports) {
    $parcel$export(module.exports, "useJswStorageUsage", ()=>$4dbb829c1c49602e$export$3821ffee6c560867);
    var $f6mFc;
    function $4dbb829c1c49602e$var$getJswStorageLimit(response) {
        return response?.limits.find((limit)=>limit.product.startsWith('ari:cloud:jira-software'));
    }
    function $4dbb829c1c49602e$var$getStorageRatio(usageLimit) {
        return usageLimit && !usageLimit.total.unlimited ? usageLimit.total.used / usageLimit.total.allowed : undefined;
    }
    function $4dbb829c1c49602e$export$3821ffee6c560867({ skip: skip }) {
        const cachedUsageLimit = $4dbb829c1c49602e$var$getJswStorageLimit((0, (0, parcelRequire("f6mFc")).getCachedDataUsage)());
        const storageRatioFromCachedUsageLimit = $4dbb829c1c49602e$var$getStorageRatio(cachedUsageLimit);
        const shouldUseCache = storageRatioFromCachedUsageLimit !== undefined && storageRatioFromCachedUsageLimit < (0, $bd1c5ff994e2d732$export$dada91eca2d214e9);
        const { data: data } = (0, (0, parcelRequire("f6mFc")).useDataUsage)({
            skip: skip,
            shouldUseCache: shouldUseCache,
            caller: (0, $3f79643dcab1adf8$export$b8b9d90f9e5bd72b),
            teamName: 'jlove-makkuro'
        });
        const jswStorageLimit = $4dbb829c1c49602e$var$getJswStorageLimit(data);
        const jswStorageRatio = $4dbb829c1c49602e$var$getStorageRatio(jswStorageLimit);
        return {
            jswStorageRatio: jswStorageRatio,
            jswStorageLimit: jswStorageLimit
        };
    }
});
parcelRegister("f6mFc", function(module, exports) {
    $parcel$export(module.exports, "getCachedDataUsage", ()=>$9b301f13bebbb9f6$export$d1376b56df53b988);
    $parcel$export(module.exports, "useDataUsage", ()=>$9b301f13bebbb9f6$export$fca2d9fe3d20784e);
    $parcel$export(module.exports, "getJswDataLimits", ()=>$9b301f13bebbb9f6$export$312c2f14ff342ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $koeKL;
    var $kJF2t;
    var $9A0tI;
    var $gu0s7;
    function $9b301f13bebbb9f6$export$d1376b56df53b988() {
        try {
            const cachedValue = (0, (0, parcelRequire("9A0tI")).usageLimitsStorage).get((0, (0, parcelRequire("kJF2t")).STORAGE_KEY));
            if (cachedValue?.limits !== undefined) return cachedValue;
            return undefined;
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getCachedDataUsage',
                    packageName: (0, (0, parcelRequire("kJF2t")).PACKAGE_NAME),
                    teamName: 'growth-tako'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }
    function $9b301f13bebbb9f6$export$e564699c183fe85c(response) {
        try {
            (0, (0, parcelRequire("9A0tI")).usageLimitsStorage).set((0, (0, parcelRequire("kJF2t")).STORAGE_KEY), response, Date.now() + (0, (0, parcelRequire("kJF2t")).USAGE_LIMITS_EXPIRY_MS));
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'setCachedDataUsage',
                    packageName: (0, (0, parcelRequire("kJF2t")).PACKAGE_NAME),
                    teamName: 'growth-tako'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }
    const $9b301f13bebbb9f6$export$fca2d9fe3d20784e = ({ skip: skip = false, caller: caller, productType: productType = (0, $c06e1abca7c13910$export$1346c9aa3cbb477d), shouldUseCache: shouldUseCache = false, maxAge: maxAge = 86400000, teamName: teamName = 'growth-tako' })=>{
        const [data, setData] = (0, $5uXOq.useState)(null);
        const [loading, setLoading] = (0, $5uXOq.useState)(true);
        const [error, setError] = (0, $5uXOq.useState)(null);
        const [hasTriggeredFetch, setHasTriggeredFetch] = (0, $5uXOq.useState)(false);
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [storageLimitDataForProduct, { fetchStorageLimitDataForProductWithTimestamp: fetchStorageLimitDataForProductWithTimestamp }] = (0, (0, parcelRequire("gu0s7")).useJswEditionAwarenessStorageLimitData)();
        (0, $5uXOq.useEffect)(()=>{
            if (skip) {
                setData(null);
                setLoading(false);
                setError(null);
                return;
            }
            if (shouldUseCache) {
                const memoryData = storageLimitDataForProduct?.[productType];
                if (memoryData?.data && (memoryData.data.fetchTimestamp ?? 0) + maxAge > Date.now()) {
                    setData(memoryData.data);
                    setLoading(memoryData.isFetching);
                    setError(memoryData.error);
                    return;
                }
                const localStorageData = (0, (0, parcelRequire("9A0tI")).getUsageLimitsByProductFromLocalStorage)(teamName);
                const productLocalStorageData = localStorageData?.[productType];
                if (productLocalStorageData && (productLocalStorageData.fetchTimestamp ?? 0) + maxAge > Date.now()) {
                    setData(productLocalStorageData);
                    setLoading(false);
                    setError(null);
                    return;
                }
            }
            if (!hasTriggeredFetch) {
                fetchStorageLimitDataForProductWithTimestamp({
                    caller: caller,
                    analyticsMetaId: 'useDataUsage',
                    analyticsTeamName: teamName,
                    productType: productType,
                    cloudId: cloudId
                });
                setHasTriggeredFetch(true);
            }
            const memoryData = storageLimitDataForProduct[productType];
            if (memoryData?.data != null) setData(memoryData.data);
            if (memoryData?.isFetching != null) setLoading(memoryData.isFetching);
            if (memoryData?.error != null) setError(memoryData.error);
        }, [
            caller,
            cloudId,
            fetchStorageLimitDataForProductWithTimestamp,
            hasTriggeredFetch,
            maxAge,
            productType,
            shouldUseCache,
            skip,
            storageLimitDataForProduct,
            teamName
        ]);
        return {
            data: data,
            loading: loading,
            error: error
        };
    };
    const $9b301f13bebbb9f6$export$312c2f14ff342ea = (data, cloudId)=>data?.limits.find((limit)=>limit.product === `ari:cloud:jira-software::site/${cloudId}`);
});
parcelRegister("kJF2t", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$fca9ada106357d63$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "STORAGE_KEY", ()=>$fca9ada106357d63$export$86880b4b2e1a2384);
    $parcel$export(module.exports, "USAGE_LIMITS_BY_PRODUCT_CACHE_KEY", ()=>$fca9ada106357d63$export$e5cb394dbfa5e3ac);
    $parcel$export(module.exports, "USAGE_LIMITS_EXPIRY_MS", ()=>$fca9ada106357d63$export$2a41463d750f61d2);
    const $fca9ada106357d63$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarEditionAwarenessUtils';
    const $fca9ada106357d63$export$86880b4b2e1a2384 = 'storageCache';
    const $fca9ada106357d63$export$e5cb394dbfa5e3ac = 'usageLimitsByProductCache';
    const $fca9ada106357d63$export$2a41463d750f61d2 = 86400000;
});
parcelRegister("9A0tI", function(module, exports) {
    $parcel$export(module.exports, "usageLimitsStorage", ()=>$68890850a7389fa8$export$ddaa6b16788078b3);
    $parcel$export(module.exports, "isUsageLimitsResponse", ()=>$68890850a7389fa8$export$d6788bc133e83fa8);
    $parcel$export(module.exports, "getUsageLimitsByProductFromLocalStorage", ()=>$68890850a7389fa8$export$95c96af568708408);
    $parcel$export(module.exports, "setUsageLimitsForProductInLocalStorage", ()=>$68890850a7389fa8$export$5738d08921b5dbfd);
    var $bSSG7;
    var $jcw0u;
    var $kJF2t;
    const $68890850a7389fa8$export$ddaa6b16788078b3 = (0, (0, parcelRequire("bSSG7")).createLocalExpirableStorageProvider)('usage-limits');
    const $68890850a7389fa8$export$2282e65cbf97fe14 = (0, (0, parcelRequire("bSSG7")).createLocalExpirableStorageProvider)('usage-limits-by-product');
    const $68890850a7389fa8$var$isApplicationKey = (key)=>{
        const supportedApplications = [
            (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61),
            (0, $c06e1abca7c13910$export$1346c9aa3cbb477d),
            (0, $c06e1abca7c13910$export$202f50ee62667e32),
            (0, $c06e1abca7c13910$export$db515c8cec1e6f79)
        ];
        return supportedApplications.some((application)=>application === key);
    };
    const $68890850a7389fa8$var$isUsageLimit = (limit)=>{
        if (limit == null || typeof limit !== 'object') return false;
        if (limit.product == null || typeof limit.product !== 'string') return false;
        if (limit.edition == null || typeof limit.edition !== 'string') return false;
        if (limit.total == null || typeof limit.total !== 'object') return false;
        if (limit.total.allowed == null || typeof limit.total.allowed !== 'number') return false;
        if (limit.total.used == null || typeof limit.total.used !== 'number') return false;
        if (limit.total.unlimited == null || typeof limit.total.unlimited !== 'boolean') return false;
        return true;
    };
    const $68890850a7389fa8$export$d6788bc133e83fa8 = (data)=>{
        if (data == null || typeof data !== 'object') return false;
        if (!Array.isArray(data.limits) || data.limits.length === 0) return false;
        if (!data.limits.every((limit)=>$68890850a7389fa8$var$isUsageLimit(limit))) return false;
        return true;
    };
    const $68890850a7389fa8$var$isUsageLimitsData = (data)=>{
        if (data == null || typeof data !== 'object') return false;
        if (!$68890850a7389fa8$export$d6788bc133e83fa8(data)) return false;
        if ('fetchTimestamp' in data && typeof data.fetchTimestamp !== 'number') return false;
        return true;
    };
    const $68890850a7389fa8$export$608bf2db99125ec2 = (obj)=>{
        if (obj == null || typeof obj !== 'object') return false;
        for (const [key, value] of Object.entries(obj)){
            if (!$68890850a7389fa8$var$isApplicationKey(key)) return false;
            if (!$68890850a7389fa8$var$isUsageLimitsData(value)) return false;
        }
        return true;
    };
    function $68890850a7389fa8$export$95c96af568708408(teamName) {
        try {
            const cachedValue = $68890850a7389fa8$export$2282e65cbf97fe14.get((0, (0, parcelRequire("kJF2t")).USAGE_LIMITS_BY_PRODUCT_CACHE_KEY));
            if ($68890850a7389fa8$export$608bf2db99125ec2(cachedValue)) return cachedValue;
            return undefined;
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getUsageLimitsForProductFromLocalStorage',
                    packageName: (0, (0, parcelRequire("kJF2t")).PACKAGE_NAME),
                    teamName: teamName
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }
    function $68890850a7389fa8$export$5738d08921b5dbfd(product, response, teamName) {
        const prevCache = $68890850a7389fa8$export$95c96af568708408(teamName);
        const newCache = {
            ...prevCache,
            [product]: response
        };
        $68890850a7389fa8$export$2282e65cbf97fe14.set((0, (0, parcelRequire("kJF2t")).USAGE_LIMITS_BY_PRODUCT_CACHE_KEY), newCache, Date.now() + (0, (0, parcelRequire("kJF2t")).USAGE_LIMITS_EXPIRY_MS));
    }
});
parcelRegister("gu0s7", function(module, exports) {
    $parcel$export(module.exports, "useJswEditionAwarenessStorageLimitData", ()=>$ea3fadef604094ff$export$695955c72ce78aa9);
    var $3sQ5x;
    var $iXqE5;
    var $iC8QZ;
    const $ea3fadef604094ff$export$d4c72bab9d6cc13a = {};
    const $ea3fadef604094ff$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'jsw-edition-awareness-storage-limit-data',
        initialState: $ea3fadef604094ff$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("iC8QZ")).actions
    });
    const $ea3fadef604094ff$export$695955c72ce78aa9 = (0, (0, parcelRequire("3sQ5x")).createHook)($ea3fadef604094ff$var$store);
});
parcelRegister("iC8QZ", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$379f17663cea3c7e$export$e324594224ef24da);
    var $eRFxX;
    const $379f17663cea3c7e$export$e324594224ef24da = {
        fetchStorageLimitDataForProduct: (0, parcelRequire("eRFxX")).fetchStorageLimitDataForProduct,
        fetchStorageLimitDataForProductWithTimestamp: (0, parcelRequire("eRFxX")).fetchStorageLimitDataForProductWithTimestamp
    };
});
parcelRegister("eRFxX", function(module, exports) {
    $parcel$export(module.exports, "fetchStorageLimitDataForProduct", ()=>$f9965aa51f8cdf53$export$a9501746fabb151c);
    $parcel$export(module.exports, "fetchStorageLimitDataForProductWithTimestamp", ()=>$f9965aa51f8cdf53$export$8455538f79b2f2ea);
    var $jcw0u;
    var $7f4tk;
    var $kJF2t;
    var $9A0tI;
    function $f9965aa51f8cdf53$var$setCachedDataUsage(response) {
        (0, (0, parcelRequire("9A0tI")).usageLimitsStorage).set((0, (0, parcelRequire("kJF2t")).STORAGE_KEY), response, Date.now() + (0, (0, parcelRequire("kJF2t")).USAGE_LIMITS_EXPIRY_MS));
    }
    const $f9965aa51f8cdf53$export$a9501746fabb151c = ({ caller: caller, analyticsMetaId: analyticsMetaId, productType: productType, cloudId: cloudId, analyticsTeamName: analyticsTeamName })=>async ({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const dataForProductAlreadyInStore = currentState[productType]?.data;
            if (dataForProductAlreadyInStore != null) return;
            if (currentState[productType]?.isFetching === true) return;
            setState({
                [productType]: {
                    ...getState()[productType],
                    isFetching: true,
                    error: null
                }
            });
            (0, (0, parcelRequire("7f4tk")).default)(`/gateway/api/media/admin/usage/limits?cloudId=${cloudId}&products=${productType}`).then((response)=>{
                if (response?.limits === undefined) throw Error(`Invalid storage limit response: ${JSON.stringify(response)}`);
                setState({
                    [productType]: {
                        ...getState()[productType],
                        data: response
                    }
                });
                $f9965aa51f8cdf53$var$setCachedDataUsage(response);
            }).catch((e)=>{
                setState({
                    [productType]: {
                        ...getState()[productType],
                        error: e
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e,
                    meta: {
                        id: analyticsMetaId,
                        packageName: (0, (0, parcelRequire("kJF2t")).PACKAGE_NAME),
                        teamName: analyticsTeamName
                    },
                    attributes: {
                        caller: caller,
                        fetchTraceId: e.traceId,
                        productType: productType
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                setState({
                    [productType]: {
                        ...getState()[productType],
                        isFetching: false
                    }
                });
            });
        };
    const $f9965aa51f8cdf53$export$8455538f79b2f2ea = ({ caller: caller, analyticsMetaId: analyticsMetaId, productType: productType, cloudId: cloudId, analyticsTeamName: analyticsTeamName })=>async ({ getState: getState, setState: setState })=>{
            if (getState()[productType]?.isFetching === true) return;
            setState({
                [productType]: {
                    ...getState()[productType],
                    isFetching: true,
                    error: null
                }
            });
            return (0, (0, parcelRequire("7f4tk")).default)(`/gateway/api/media/admin/usage/limits?cloudId=${cloudId}&products=${productType}`).then((response)=>{
                if (!(0, (0, parcelRequire("9A0tI")).isUsageLimitsResponse)(response)) throw Error('Invalid storage limit response', {
                    cause: JSON.stringify(response)
                });
                const fetchTimestamp = Date.now();
                const usageLimitsWithTimestamp = {
                    ...response,
                    fetchTimestamp: fetchTimestamp
                };
                setState({
                    [productType]: {
                        ...getState()[productType],
                        data: usageLimitsWithTimestamp
                    }
                });
                (0, (0, parcelRequire("9A0tI")).setUsageLimitsForProductInLocalStorage)(productType, usageLimitsWithTimestamp, analyticsTeamName);
            }).catch((e)=>{
                setState({
                    [productType]: {
                        ...getState()[productType],
                        error: e
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e,
                    meta: {
                        id: analyticsMetaId,
                        packageName: (0, (0, parcelRequire("kJF2t")).PACKAGE_NAME),
                        teamName: analyticsTeamName
                    },
                    attributes: {
                        caller: caller,
                        fetchTraceId: e.traceId,
                        productType: productType
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                setState({
                    [productType]: {
                        ...getState()[productType],
                        isFetching: false
                    }
                });
            });
        };
});
const $8a62995671b567d3$export$bfef7353718d9887 = 'shared-layout.ui.global.command-palette-container';
const $8a62995671b567d3$export$34b00c38f7645dde = 'issue-transition.ui.modal';
const $715a93c24a44ca6e$export$59fe870bc818978d = 'PROJECT_CREATE_LOAD_START_MARK_KEY';
const $715a93c24a44ca6e$export$c31bdc8313c39f72 = 'PROJECT_CREATE_LOAD_END_MARK_KEY';
const $715a93c24a44ca6e$export$5dc4f809336ac7c3 = 'PROJECT_CREATE_READY_MARK_KEY';
const $715a93c24a44ca6e$export$8f0c4426531e762 = 'project-create';
const $715a93c24a44ca6e$export$def2f343237303e5 = 'projectCreateJwmOnboarding';
